import React, { useState, useEffect } from 'react';
import { ConsoleShell, useConsoleTheme } from '../components/Console';
import { useAuth } from '../AuthContext';
import { supabase } from '../supabaseClient';

const F = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';

const CARD = (t) => ({
  background: t.panel,
  borderRadius: 12,
  border: `1px solid ${t.bd}`,
  padding: '20px 22px',
});

// ─── Brand SVG icons (replaces all emoji) ────────────────────────────────────
const IC = {
  web: (
    React.createElement('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('circle', { cx: 12, cy: 12, r: 10 }),
      React.createElement('line', { x1: 2, y1: 12, x2: 22, y2: 12 }),
      React.createElement('path', { d: 'M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z' })
    )
  ),
  mobile: (
    React.createElement('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('rect', { x: 5, y: 2, width: 14, height: 20, rx: 2 }),
      React.createElement('line', { x1: 12, y1: 18, x2: 12, y2: 18 })
    )
  ),
  android: (
    React.createElement('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('path', { d: 'M4 16.5A8.5 8.5 0 0112 3a8.5 8.5 0 018 13.5' }),
      React.createElement('line', { x1: 1, y1: 10, x2: 4, y2: 10 }),
      React.createElement('line', { x1: 20, y1: 10, x2: 23, y2: 10 }),
      React.createElement('line', { x1: 8, y1: 2, x2: 10, y2: 5 }),
      React.createElement('line', { x1: 16, y1: 2, x2: 14, y2: 5 }),
      React.createElement('rect', { x: 5, y: 16, width: 14, height: 6, rx: 2 })
    )
  ),
  ios: (
    React.createElement('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('rect', { x: 5, y: 2, width: 14, height: 20, rx: 3 }),
      React.createElement('line', { x1: 12, y1: 18, x2: 12, y2: 18 }),
      React.createElement('line', { x1: 10, y1: 5, x2: 14, y2: 5 })
    )
  ),
  package: (
    React.createElement('svg', { width: 28, height: 28, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('path', { d: 'M16.5 9.4l-9-5.19M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 002 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z' }),
      React.createElement('polyline', { points: '3.27 6.96 12 12.01 20.73 6.96' }),
      React.createElement('line', { x1: 12, y1: 22.08, x2: 12, y2: 12 })
    )
  ),
  users: (
    React.createElement('svg', { width: 28, height: 28, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('path', { d: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2' }),
      React.createElement('circle', { cx: 9, cy: 7, r: 4 }),
      React.createElement('path', { d: 'M23 21v-2a4 4 0 00-3-3.87' }),
      React.createElement('path', { d: 'M16 3.13a4 4 0 010 7.75' })
    )
  ),
  search: (
    React.createElement('svg', { width: 28, height: 28, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('circle', { cx: 11, cy: 11, r: 8 }),
      React.createElement('line', { x1: 21, y1: 21, x2: 16.65, y2: 16.65 })
    )
  ),
  clipboard: (
    React.createElement('svg', { width: 28, height: 28, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('path', { d: 'M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2' }),
      React.createElement('rect', { x: 8, y: 2, width: 8, height: 4, rx: 1 })
    )
  ),
  bug: (
    React.createElement('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('path', { d: 'M8 2l1.88 1.88M14.12 3.88L16 2' }),
      React.createElement('path', { d: 'M9 7.13v-1a3.003 3.003 0 116 0v1' }),
      React.createElement('path', { d: 'M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 014-4h4a4 4 0 014 4v3c0 3.3-2.7 6-6 6z' }),
      React.createElement('path', { d: 'M12 20v-9' }),
      React.createElement('path', { d: 'M6.53 9C4.6 8.8 3 7.1 3 5' }),
      React.createElement('path', { d: 'M6 13H2' }),
      React.createElement('path', { d: 'M3 21c0-2.1 1.7-3.9 4-4' }),
      React.createElement('path', { d: 'M17.47 9c1.93-.2 3.53-1.9 3.53-4' }),
      React.createElement('path', { d: 'M18 13h4' }),
      React.createElement('path', { d: 'M21 21c0-2.1-1.7-3.9-4-4' })
    )
  ),
  warning: (
    React.createElement('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('path', { d: 'M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z' }),
      React.createElement('line', { x1: 12, y1: 9, x2: 12, y2: 13 }),
      React.createElement('line', { x1: 12, y1: 17, x2: 12.01, y2: 17 })
    )
  ),
  sparkle: (
    React.createElement('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('polygon', { points: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2' })
    )
  ),
  reload: (
    React.createElement('svg', { width: 11, height: 11, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('polyline', { points: '23 4 23 10 17 10' }),
      React.createElement('path', { d: 'M20.49 15a9 9 0 11-2.12-9.36L23 10' })
    )
  ),
  download: (
    React.createElement('svg', { width: 11, height: 11, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('path', { d: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4' }),
      React.createElement('polyline', { points: '7 10 12 15 17 10' }),
      React.createElement('line', { x1: 12, y1: 15, x2: 12, y2: 3 })
    )
  ),
  check: (
    React.createElement('svg', { width: 11, height: 11, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('polyline', { points: '20 6 9 17 4 12' })
    )
  ),
  music: (
    React.createElement('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('path', { d: 'M9 18V5l12-2v13' }),
      React.createElement('circle', { cx: 6, cy: 18, r: 3 }),
      React.createElement('circle', { cx: 18, cy: 16, r: 3 })
    )
  ),
  play: (
    React.createElement('svg', { width: 13, height: 13, viewBox: '0 0 24 24', fill: 'currentColor', stroke: 'none' },
      React.createElement('polygon', { points: '5 3 19 12 5 21 5 3' })
    )
  ),
  pause: (
    React.createElement('svg', { width: 13, height: 13, viewBox: '0 0 24 24', fill: 'currentColor', stroke: 'none' },
      React.createElement('rect', { x: 6, y: 4, width: 4, height: 16 }),
      React.createElement('rect', { x: 14, y: 4, width: 4, height: 16 })
    )
  ),
  star: (
    React.createElement('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('polygon', { points: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2' })
    )
  ),
  starFill: (
    React.createElement('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: '#e08c2e', stroke: '#e08c2e', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('polygon', { points: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2' })
    )
  ),
  upload: (
    React.createElement('svg', { width: 13, height: 13, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('path', { d: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4' }),
      React.createElement('polyline', { points: '17 8 12 3 7 8' }),
      React.createElement('line', { x1: 12, y1: 3, x2: 12, y2: 15 })
    )
  ),
  trash: (
    React.createElement('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('polyline', { points: '3 6 5 6 21 6' }),
      React.createElement('path', { d: 'M19 6l-1 14H6L5 6' }),
      React.createElement('path', { d: 'M10 11v6' }),
      React.createElement('path', { d: 'M14 11v6' }),
      React.createElement('path', { d: 'M9 6V4h6v2' })
    )
  ),
  pencil: (
    React.createElement('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('path', { d: 'M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7' }),
      React.createElement('path', { d: 'M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z' })
    )
  ),
  filter: (
    React.createElement('svg', { width: 13, height: 13, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('polygon', { points: '22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3' })
    )
  ),
  sort: (
    React.createElement('svg', { width: 13, height: 13, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
      React.createElement('line', { x1: 8, y1: 6, x2: 21, y2: 6 }),
      React.createElement('line', { x1: 8, y1: 12, x2: 21, y2: 12 }),
      React.createElement('line', { x1: 8, y1: 18, x2: 21, y2: 18 }),
      React.createElement('line', { x1: 3, y1: 6, x2: 3.01, y2: 6 }),
      React.createElement('line', { x1: 3, y1: 12, x2: 3.01, y2: 12 }),
      React.createElement('line', { x1: 3, y1: 18, x2: 3.01, y2: 18 })
    )
  ),
};



// eslint-disable-next-line no-unused-vars
// ─── Shared UI primitives ─────────────────────────────────────────────────────
function Pill({ children, color }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const c = color || '#314F5C';
  return React.createElement('span', {
    style: {
      display: 'inline-flex', alignItems: 'center',
      padding: '2px 9px', borderRadius: 99,
      fontSize: '.62rem', fontWeight: 600,
      background: c + '18', color: c, border: '1px solid ' + c + '30',
      lineHeight: 1.6,
    }
  }, children);
}

function StatusBadge({ status }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const map = {
    active:    { label: 'Active',     color: '#1D9E75' },
    inactive:  { label: 'Inactive',   color: '#9aabba' },
    pending:   { label: 'Pending',    color: '#f59e0b' },
    installed: { label: 'Installed',  color: '#1D9E75' },
    invited:   { label: 'Invited',    color: '#6F8FA7' },
    draft:     { label: 'Draft',      color: '#f59e0b' },
  };
  const cfg = map[status] || map['inactive'];
  return React.createElement(Pill, { color: cfg.color }, cfg.label);
}

function Empty({ icon, title, sub }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return React.createElement('div', { style: { textAlign: 'center', padding: '48px 24px', color: '#9aabba' } },
    React.createElement('div', { style: { display: 'flex', justifyContent: 'center', marginBottom: 14 } },
      React.createElement('div', { style: { width: 52, height: 52, borderRadius: 14, background: 'rgba(49,79,92,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6F8FA7' } }, icon)
    ),
    React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 600, color: '#314F5C', marginBottom: 4 } }, title),
    React.createElement('div', { style: { fontSize: '.78rem' } }, sub)
  );
}

function Modal({ open, onClose, title, children, wide }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  useEffect(() => {
    function handler(e) { if (e.key === 'Escape') onClose(); }
    if (open) document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);
  if (!open) return null;
  return React.createElement('div', {
    style: { position: 'fixed', inset: 0, zIndex: 9000, background: 'rgba(10,22,32,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: F },
    onClick: onClose,
  },
    React.createElement('div', {
      style: { background: t.panel, borderRadius: 16, width: wide ? 580 : 460, maxWidth: 'calc(100vw - 32px)', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 24px 64px rgba(0,0,0,0.22)', padding: '24px 26px' },
      onClick: e => e.stopPropagation(),
    },
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 } },
        React.createElement('div', { style: { fontSize: '.92rem', fontWeight: 700, color: '#0f1e28' } }, title),
        React.createElement('button', { onClick: onClose, style: { background: 'none', border: 'none', cursor: 'pointer', color: '#9aabba', padding: 4, display: 'flex' } },
          React.createElement('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' },
            React.createElement('path', { d: 'M18 6L6 18M6 6l12 12' })
          )
        )
      ),
      children
    )
  );
}

function Btn({ onClick, children, variant, small, disabled }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const v = variant || 'primary';
  const base = { display: 'inline-flex', alignItems: 'center', gap: 5, borderRadius: 8, fontFamily: F, fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.55 : 1, padding: small ? '5px 12px' : '8px 16px', fontSize: small ? '.74rem' : '.78rem', transition: 'all .12s', border: 'none' };
  const extra = v === 'primary'   ? { background: t.accent, color: '#fff' }
              : v === 'secondary' ? { background: '#f0f4f6', color: '#314F5C', border: '1px solid #d5e0e6' }
              : v === 'danger'    ? { background: '#fef2f2', color: '#c0392b', border: '1px solid #fca5a5' }
              : v === 'success'   ? { background: '#f0fdf7', color: '#1D9E75', border: '1px solid #6ee7b7' }
              :                    { background: 'transparent', color: '#314F5C', border: '1px solid #d5e0e6' };
  return React.createElement('button', { onClick: disabled ? undefined : onClick, style: { ...base, ...extra } }, children);
}

function LabeledInput({ label, value, onChange, placeholder, type, required }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return React.createElement('div', { style: { marginBottom: 14 } },
    label && React.createElement('label', { style: { display: 'block', fontSize: '.74rem', fontWeight: 600, color: '#314F5C', marginBottom: 5 } },
      label,
      required && React.createElement('span', { style: { color: '#e05c5c', marginLeft: 2 } }, '*')
    ),
    React.createElement('input', {
      type: type || 'text', value, onChange: e => onChange(e.target.value), placeholder: placeholder || '',
      style: { width: '100%', boxSizing: 'border-box', padding: '8px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.82rem', color: '#0f1e28', outline: 'none', background: '#fafcfd' },
    })
  );
}

function LabeledSelect({ label, value, onChange, options }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return React.createElement('div', { style: { marginBottom: 14 } },
    label && React.createElement('label', { style: { display: 'block', fontSize: '.74rem', fontWeight: 600, color: '#314F5C', marginBottom: 5 } }, label),
    React.createElement('select', {
      value, onChange: e => onChange(e.target.value),
      style: { width: '100%', boxSizing: 'border-box', padding: '8px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.82rem', color: '#0f1e28', background: '#fafcfd', outline: 'none' },
    },
      options.map(o => React.createElement('option', { key: o.value, value: o.value }, o.label))
    )
  );
}

function LabeledTextarea({ label, value, onChange, placeholder, rows }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return React.createElement('div', { style: { marginBottom: 14 } },
    label && React.createElement('label', { style: { display: 'block', fontSize: '.74rem', fontWeight: 600, color: '#314F5C', marginBottom: 5 } }, label),
    React.createElement('textarea', {
      value, onChange: e => onChange(e.target.value), placeholder: placeholder || '', rows: rows || 3,
      style: { width: '100%', boxSizing: 'border-box', padding: '8px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.82rem', color: '#0f1e28', outline: 'none', background: '#fafcfd', resize: 'vertical' },
    })
  );
}

// ─── QR Code (pure JS, no external lib) ──────────────────────────────────────
// Uses Google Charts API \u2014 privacy-safe, no auth needed, just renders a URL
function QRCode({ url, size }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const sz = size || 160;
  const src = `https://chart.googleapis.com/chart?chs=${sz}x${sz}&cht=qr&chl=${encodeURIComponent(url)}&choe=UTF-8`;
  return React.createElement('img', { src, alt: 'QR code', width: sz, height: sz, style: { borderRadius: 8, display: 'block' } });
}

// ─── Clipboard helper ─────────────────────────────────────────────────────────
function useCopy() {
  const [copied, setCopied] = useState(null);
  function copy(text, key) {
    navigator.clipboard.writeText(text).catch(() => {});
    setCopied(key);
    setTimeout(() => setCopied(null), 2000);
  }
  return { copy, copied };
}

// ═══════════════════════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════════════════════
// PREVIEW PANEL  \u2014 web/mobile: live iframe  |  android/ios: screenshots/video/live
// ═══════════════════════════════════════════════════════════════════════════════

// Screens and features for the native app screenshot organiser
var NATIVE_SCREENS = [
  { id: 'home',      label: 'Home' },
  { id: 'search',    label: 'Search' },
  { id: 'map',       label: 'Map' },
  { id: 'results',   label: 'Results' },
  { id: 'detail',    label: 'Location Detail' },
  { id: 'account',   label: 'Account' },
  { id: 'sana',      label: 'Sana AI' },
  { id: 'saved',     label: 'Saved' },
  { id: 'trips',     label: 'Trips' },
  { id: 'onboarding',label: 'Onboarding' },
  { id: 'login',     label: 'Login' },
  { id: 'other',     label: 'Other' },
];

var NATIVE_FEATURES = [
  { id: 'care',       label: 'Care Mode' },
  { id: 'wellness',   label: 'Wellness Mode' },
  { id: 'sana_ai',    label: 'Sana AI' },
  { id: 'telehealth', label: 'Telehealth' },
  { id: 'emergency',  label: 'Emergency' },
  { id: 'near_me',    label: 'Near Me' },
  { id: 'dark_mode',  label: 'Dark Mode' },
  { id: 'map_view',   label: 'Map View' },
  { id: 'filters',    label: 'Filters' },
  { id: 'other',      label: 'Other' },
];

var SB_URL  = 'https://dekxnqbjzgkvltclthqw.supabase.co';
var SB_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRla3hucWJqemdrdmx0Y2x0aHF3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE3NzM1ODEsImV4cCI6MjA3NzM0OTU4MX0.07Aj6pv1hhGAIzMgdkoseoSRJscx3vH3Uy9Bq472ubM';
var BUCKET  = 'app-previews';

function storagePubUrl(path) {
  return SB_URL + '/storage/v1/object/public/' + BUCKET + '/' + path;
}

// ── Phone shell wrapper ───────────────────────────────────────────────────────
function PhoneShell({ platform, children, height }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var isIos = platform === 'ios';
  var frameBg = isIos ? '#1c1c1e' : '#202124';
  var w = 393; var h = height || 851;
  return React.createElement('div', {
    style: { position: 'relative', flexShrink: 0, display: 'inline-block' }
  },
    React.createElement('div', {
      style: { background: frameBg, borderRadius: 52, padding: '12px', boxShadow: '0 24px 64px rgba(0,0,0,0.4), inset 0 0 0 1px rgba(255,255,255,0.08)', position: 'relative', display: 'inline-block' }
    },
      // Notch / camera hole
      isIos
        ? React.createElement('div', { style: { position: 'absolute', top: 22, left: '50%', transform: 'translateX(-50%)', width: 120, height: 34, background: frameBg, borderRadius: 20, zIndex: 10 } })
        : React.createElement('div', { style: { position: 'absolute', top: 26, left: '50%', transform: 'translateX(-50%)', width: 12, height: 12, background: frameBg, borderRadius: '50%', zIndex: 10 } }),
      // Screen area
      React.createElement('div', {
        style: { borderRadius: 42, overflow: 'hidden', width: w, height: h, background: '#111', position: 'relative' }
      }, children),
      // Bottom bar
      isIos
        ? React.createElement('div', { style: { height: 5, background: 'rgba(255,255,255,0.3)', borderRadius: 3, margin: '8px auto 0', width: 130 } })
        : React.createElement('div', { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 28, padding: '8px 0 4px' } },
            ['\u25C1', '\u25CB', '\u25A1'].map(function(s) { return React.createElement('span', { key: s, style: { fontSize: 12, color: 'rgba(255,255,255,0.35)' } }, s); })
          ),
      // Side buttons
      React.createElement('div', { style: { position: 'absolute', right: -4, top: 80,  width: 4, height: 50, background: frameBg, borderRadius: '0 4px 4px 0' } }),
      React.createElement('div', { style: { position: 'absolute', left:  -4, top: 100, width: 4, height: 35, background: frameBg, borderRadius: '4px 0 0 4px' } }),
      React.createElement('div', { style: { position: 'absolute', left:  -4, top: 146, width: 4, height: 35, background: frameBg, borderRadius: '4px 0 0 4px' } })
    )
  );
}

// ── Native asset uploader / viewer ────────────────────────────────────────────

// ─── Shared UI helpers ────────────────────────────────────────────────────────
function CopyCmd({ label, cmd }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var _c = useCopy(); var copy = _c.copy; var copied = _c.copied;
  return React.createElement('div', { style: { margin: '8px 0' } },
    label && React.createElement('div', { style: { fontSize: '.68rem', fontWeight: 700, color: '#9aabba', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '.04em', fontFamily: F } }, label),
    React.createElement('div', { style: { position: 'relative' } },
      React.createElement('pre', { style: { background: '#0f1923', color: '#AFE1F6', borderRadius: 8, padding: '10px 50px 10px 14px', fontSize: '.75rem', lineHeight: 1.65, margin: 0, fontFamily: 'Consolas,Monaco,monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-all' } }, cmd),
      React.createElement('button', { onClick: function() { copy(cmd); }, style: { position: 'absolute', top: 7, right: 7, background: copied ? '#1D9E75' : 'rgba(175,225,246,0.15)', border: 'none', borderRadius: 5, color: '#AFE1F6', fontSize: '.66rem', fontWeight: 700, padding: '3px 8px', cursor: 'pointer', fontFamily: F, transition: 'background .15s' } }, copied ? '\u2713 Copied' : 'Copy')
    )
  );
}

function Section({ title, color, children, defaultOpen }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [open, setOpen] = useState(defaultOpen !== false);
  return React.createElement('div', { style: { borderRadius: 10, border: '1.5px solid ' + (open ? (color || '#314F5C') + '30' : '#edf0f3'), overflow: 'hidden', marginBottom: 10 } },
    React.createElement('button', { onClick: function() { setOpen(function(o) { return !o; }); }, style: { width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', background: open ? (color || '#314F5C') + '08' : '#fafafa', border: 'none', cursor: 'pointer', fontFamily: F } },
      React.createElement('div', { style: { fontSize: '.82rem', fontWeight: 700, color: '#0f1e28', textAlign: 'left' } }, title),
      React.createElement('div', { style: { fontSize: '.8rem', color: '#9aabba', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s' } }, '\u25be')
    ),
    open && React.createElement('div', { style: { padding: '4px 16px 16px' } }, children)
  );
}

function Note({ children, color }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return React.createElement('div', { style: { background: (color || '#314F5C') + '10', border: '1px solid ' + (color || '#314F5C') + '30', borderRadius: 8, padding: '10px 14px', fontSize: '.76rem', color: '#4a6070', lineHeight: 1.7, margin: '8px 0 12px' } }, children);
}

function Step({ n, children }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return React.createElement('div', { style: { display: 'flex', gap: 10, marginBottom: 10, alignItems: 'flex-start' } },
    React.createElement('div', { style: { width: 20, height: 20, borderRadius: '50%', background: t.accent, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.66rem', fontWeight: 700, flexShrink: 0, marginTop: 2 } }, n),
    React.createElement('div', { style: { flex: 1, fontSize: '.8rem', color: '#4a6070', lineHeight: 1.75 } }, children)
  );
}

// ─── LiveDevicePanel — accurate node server.js setup guide ───────────────────
function LiveDevicePanel({ platform, platformLabel }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  // This renders the My Device (USB) setup guide inside NativePreview's "live" sub-tab.
  // The actual live iframe is in NativeLivePreview (Android layout).
  // This panel shows when accessed from the older NativePreview route.
  var [serverInput, setServerInput] = useState('https://localhost:8886');

  var Hl = function(props) { return React.createElement('code', { style: { background: '#f0f4f6', padding: '1px 6px', borderRadius: 4, fontSize: '.76rem', color: '#314F5C' } }, props.children); };
  var P  = function(props) { return React.createElement('div', { style: { fontSize: '.8rem', color: '#4a6070', lineHeight: 1.75, margin: '8px 0' } }, props.children); };
  var Warn = function(props) { return React.createElement('div', { style: { background: '#FEF3C7', border: '1px solid #FCD34D', borderRadius: 8, padding: '10px 13px', fontSize: '.76rem', color: '#92600A', lineHeight: 1.7, margin: '10px 0' } }, props.children); };
  var Ok = function(props) { return React.createElement('div', { style: { background: '#E1F5EE', border: '1px solid #6EE7B7', borderRadius: 8, padding: '10px 13px', fontSize: '.76rem', color: '#065F46', lineHeight: 1.7, margin: '10px 0' } }, props.children); };

  return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 0 } },

    // Header
    React.createElement('div', { style: Object.assign({}, CARD(t), { background: 'linear-gradient(135deg,#0f1e28,#1a3040)', border: 'none', marginBottom: 12 }) },
      React.createElement('div', { style: { fontSize: '.92rem', fontWeight: 700, color: '#e8f4fb', marginBottom: 6 } }, 'My Device (USB) — Setup Guide'),
      React.createElement('div', { style: { fontSize: '.78rem', color: 'rgba(175,225,246,0.65)', lineHeight: 1.7 } },
        'Stream your real Android device into this dashboard using ', React.createElement('strong', { style: { color: '#AFE1F6' } }, 'node server.js'),
        ' — a script already in the Sanoire app repo. No extra installs. Touch and scroll directly in the dashboard.'
      )
    ),

    // Step 1 — Prerequisites
    React.createElement(Section, { title: 'Step 1 \u2014 Prerequisites (one-time)', color: '#314F5C', defaultOpen: true },
      React.createElement('div', { style: { paddingTop: 8 } },
        React.createElement(Step, { n: 1 },
          'Install ', React.createElement('strong', null, 'Node.js 18+'), ' from ', React.createElement('a', { href: 'https://nodejs.org', target: '_blank', rel: 'noreferrer', style: { color: '#314F5C', fontWeight: 600 } }, 'nodejs.org'), '. Run this to confirm:'
        ),
        React.createElement(CopyCmd, { cmd: 'node --version' }),
        React.createElement(P, null, 'You need v18 or higher (e.g. v18.20.4).'),
        React.createElement(Step, { n: 2 },
          'Confirm ', React.createElement('strong', null, 'ADB'), ' is installed. If you\'ve built the Android app, it\'s already there:'
        ),
        React.createElement(CopyCmd, { cmd: 'adb version' }),
        React.createElement(P, null, 'Should show something like ', React.createElement(Hl, null, 'Android Debug Bridge version 1.0.41'), '. If not, add Android SDK platform-tools to your PATH:'),
        React.createElement(CopyCmd, { label: 'Add ADB to PATH (Windows — run once in PowerShell)', cmd: '$env:PATH += ";$env:LOCALAPPDATA\\Android\\Sdk\\platform-tools"' }),
        React.createElement(Step, { n: 3 },
          'On your Android phone: go to ', React.createElement('strong', null, 'Settings \u2192 About Phone'), ', tap ', React.createElement('strong', null, 'Build Number 7 times'), ' to unlock Developer Options. Then ', React.createElement('strong', null, 'Settings \u2192 Developer Options \u2192 USB Debugging'), ' \u2014 turn it ON.'
        )
      )
    ),

    // Step 2 — Run the server
    React.createElement(Section, { title: 'Step 2 \u2014 Connect phone and start the server', color: '#1D9E75', defaultOpen: true },
      React.createElement('div', { style: { paddingTop: 8 } },
        React.createElement(Step, { n: 1 },
          'Connect your Android phone to your PC with a ', React.createElement('strong', null, 'data USB cable'), ' (not charge-only). When the phone asks \u201cAllow USB debugging?\u201d \u2014 tap ', React.createElement('strong', null, 'Allow'), '.'
        ),
        React.createElement(Step, { n: 2 }, 'Verify your phone is detected:'),
        React.createElement(CopyCmd, { cmd: 'adb devices' }),
        React.createElement(Ok, null,
          React.createElement('strong', null, 'Good: '), 'Shows ', React.createElement(Hl, null, 'device'), ' status, e.g. ', React.createElement(Hl, null, 'R3CR205XXXX    device')
        ),
        React.createElement(Warn, null,
          React.createElement('strong', null, 'Problem: '), 'Shows ', React.createElement(Hl, null, 'unauthorized'), '? Check your phone screen \u2014 tap ', React.createElement('strong', null, 'Allow'), ' on the USB debugging prompt.'
        ),
        React.createElement(Step, { n: 3 }, 'Navigate to the Sanoire app folder and run the server:'),
        React.createElement(CopyCmd, { label: 'Windows (PowerShell)', cmd: 'cd C:\\Users\\jenni\\Documents\\Sanoire\\sanoire-app\nnode server.js' }),
        React.createElement(Ok, null,
          React.createElement('strong', null, 'Success looks like:'),
          React.createElement('pre', { style: { margin: '6px 0 0', fontSize: '.72rem', background: 'transparent', padding: 0, fontFamily: 'monospace' } },
            '[mirror] Device(s): 3B15A900TS900000\n[mirror] Screen resolution: 1080x2374\n\u2554\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2557\n\u2551 Sanoire Mirror \u2014 HTTPS \u2551\n\u2551 https://localhost:8886  \u2551\n\u255a\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u255d'
          )
        )
      )
    ),

    // Wireless ADB section
    React.createElement(Section, { title: 'Wireless ADB — Connect without USB', color: '#5856d6', defaultOpen: false },
      React.createElement('div', { style: { paddingTop: 8 } },
        React.createElement(P, null, 'Once paired, you can build and install over Wi-Fi — no cable needed. Do this once per session.'),
        React.createElement(Step, { n: 1 },
          'On your OPPO: ', React.createElement('strong', null, 'Settings → Developer Options → Wireless debugging → ON'),
          '. Tap ‘Pair device with pairing code’ and note the ', React.createElement('strong', null, 'PORT'), ' and ', React.createElement('strong', null, '6-digit CODE'), '.'
        ),
        React.createElement(Step, { n: 2 }, 'Run the pairing command (replace PORT and CODE with the values from your phone):'),
        React.createElement(CopyCmd, { label: 'Step 1 — Pair (use PORT + CODE from phone)', cmd: 'adb pair 192.168.100.100:PORT CODE' }),
        React.createElement(Step, { n: 3 }, 'Back on the main Wireless Debugging screen, note the connection PORT (e.g. 192.168.100.100:XXXXX), then connect:'),
        React.createElement(CopyCmd, { label: 'Step 2 — Connect (use PORT from main Wireless Debugging screen)', cmd: 'adb connect 192.168.100.100:PORT' }),
        React.createElement(Step, { n: 4 }, 'Or run the all-in-one script (connect + build + install):'),
        React.createElement(CopyCmd, { label: 'Connect only', cmd: 'powershell -ExecutionPolicy Bypass -File "C:\\Users\\jenni\\Documents\\Sanoire\\sanoire-app\\sanoire-android.ps1"' }),
        React.createElement(CopyCmd, { label: 'Connect + build + install', cmd: 'powershell -ExecutionPolicy Bypass -File "C:\\Users\\jenni\\Documents\\Sanoire\\sanoire-app\\sanoire-android.ps1" -build' }),
        React.createElement(Ok, null,
          React.createElement('strong', null, 'Success: '), 'You’ll see ', React.createElement(Hl, null, 'connected to 192.168.100.100:PORT'), '. Run ', React.createElement(Hl, null, 'adb devices'), ' to confirm.'
        )
      )
    ),

    // Step 3 — Trust cert (one-time)
    React.createElement(Section, { title: 'Step 3 \u2014 Trust the certificate (first time only)', color: '#e08c2e', defaultOpen: true },
      React.createElement('div', { style: { paddingTop: 8 } },
        React.createElement(Note, { color: '#e08c2e' },
          'This step is required once per computer. After you trust the cert, you never need to do it again \u2014 just run server.js and click Load.'
        ),
        React.createElement(Step, { n: 1 }, 'With server.js running, open this URL in Chrome:'),
        React.createElement(CopyCmd, { cmd: 'https://localhost:8886' }),
        React.createElement(Step, { n: 2 },
          'Chrome shows \u201cYour connection is not private\u201d. Click ', React.createElement('strong', null, 'Advanced'), ', then click ', React.createElement('strong', null, 'Proceed to localhost (unsafe)'), '.'
        ),
        React.createElement(Step, { n: 3 },
          'You\u2019ll see your phone screen appear in the browser tab. That confirms it\u2019s working. Close that tab and come back to the dashboard.'
        ),
        React.createElement(Step, { n: 4 },
          'In App Studio \u2192 Android \u2192 My device (USB) \u2192 click ', React.createElement('strong', null, '\u25ba Load'), '. Your phone appears embedded.'
        )
      )
    ),

    // Server URL input
    React.createElement('div', { style: Object.assign({}, CARD(t), { padding: '14px 18px' }) },
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 10 } },
        React.createElement('div', { style: { fontSize: '.8rem', fontWeight: 600, color: '#0f1e28', flexShrink: 0 } }, 'Server URL'),
        React.createElement('input', { value: serverInput, onChange: function(e) { setServerInput(e.target.value); }, placeholder: 'https://localhost:8886',
          style: { flex: 1, padding: '7px 10px', borderRadius: 7, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.76rem', outline: 'none', color: '#314F5C' }
        }),
        React.createElement('a', { href: serverInput || 'https://localhost:8886', target: '_blank', rel: 'noreferrer',
          style: { padding: '7px 14px', borderRadius: 7, background: t.accent, color: '#fff', fontSize: '.76rem', fontWeight: 700, textDecoration: 'none', fontFamily: F, flexShrink: 0 }
        }, 'Open to trust cert \u2197')
      )
    ),

    // Troubleshooting
    React.createElement(Section, { title: 'Troubleshooting', color: '#9aabba', defaultOpen: false },
      React.createElement('div', { style: { paddingTop: 8, display: 'flex', flexDirection: 'column', gap: 10 } },
        [
          { q: 'adb devices shows nothing', a: 'Unplug and replug the cable. Check phone screen for the "Allow USB debugging?" prompt and tap Allow. Try a different cable \u2014 many cables are charge-only and cannot transfer data.' },
          { q: 'adb devices shows "unauthorized"', a: 'Your phone is asking for permission. Unlock the phone screen and look for the "Allow USB debugging?" dialog. Tap Allow. If you don\'t see it, unplug and replug.' },
          { q: 'openssl not found \u2014 falling back to HTTP mode', a: 'server.js auto-finds openssl from Git for Windows. If Git is installed, this works automatically. If not, run: winget install Git.Git then restart PowerShell.' },
          { q: 'ERR_SSL_PROTOCOL_ERROR in the dashboard', a: 'The old version of server.js is still running (HTTP only). Kill all node processes and pull the latest: Get-Process -Name node | Stop-Process -Force, then git fetch origin && git reset --hard origin/main, then node server.js.' },
          { q: 'Port 8886 already in use (EADDRINUSE)', a: 'An old server.js is still running. Kill it: Get-Process -Name node -ErrorAction SilentlyContinue | Stop-Process -Force, then run node server.js again.' },
          { q: 'Phone screen appears but is black', a: 'The phone screen may be locked or off. Wake it up and unlock it. ADB screencap only captures the active screen.' },
          { q: 'Stream works but taps/scrolls don\'t respond', a: 'Make sure you\'re clicking inside the phone frame (not the surrounding dashboard). Clicks outside the iframe area are not forwarded to ADB.' },
        ].map(function(item, i) {
          return React.createElement('div', { key: i, style: { background: '#f8fafc', borderRadius: 8, padding: '11px 14px', border: '1px solid #edf2f6' } },
            React.createElement('div', { style: { fontSize: '.78rem', fontWeight: 700, color: '#0f1e28', marginBottom: 4 } }, item.q),
            React.createElement('div', { style: { fontSize: '.75rem', color: '#6a8898', lineHeight: 1.65 } }, item.a)
          );
        })
      )
    )
  );
}


function NativePreview({ platform }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [subTab,      setSubTab]      = useState('screenshots');
  var [assets,      setAssets]      = useState([]);
  var [loading,     setLoading]     = useState(true);
  var [bucketErr,   setBucketErr]   = useState(false);
  var [groupBy,     setGroupBy]     = useState('screen'); // 'screen' | 'feature'
  var [activeGroup, setActiveGroup] = useState('all');
  var [uploading,   setUploading]   = useState(false);
  var [uploadForm,  setUploadForm]  = useState({ screen: 'home', feature: 'care', label: '', type: 'screenshot' });
  var [selectedImg, setSelectedImg] = useState(null);
  var fileInputRef = React.useRef(null);

  // Load assets from app_preview_assets table
  useEffect(function() { loadAssets(); }, [platform, subTab]); // eslint-disable-line react-hooks/exhaustive-deps

  async function loadAssets() {
    setLoading(true); setBucketErr(false);
    try {
      var type = subTab === 'screenshots' ? 'screenshot' : 'video';
      var result = await supabase
        .from('app_preview_assets')
        .select('*')
        .eq('platform', platform)
        .eq('type', type)
        .order('created_at', { ascending: false });
      if (result.error) throw result.error;
      setAssets(result.data || []);
    } catch (e) {
      if (e.message && (e.message.includes('does not exist') || e.message.includes('relation'))) {
        setBucketErr(true);
      }
    } finally { setLoading(false); }
  }

  async function handleUpload(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      var ext  = file.name.split('.').pop();
      var path = platform + '/' + subTab + '/' + Date.now() + '.' + ext;

      // Upload to Supabase storage
      var formData = new FormData();
      formData.append('', file);
      var uploadResp = await fetch(
        SB_URL + '/storage/v1/object/' + BUCKET + '/' + path,
        { method: 'POST', headers: { apikey: SB_ANON, Authorization: 'Bearer ' + SB_ANON }, body: formData }
      );
      if (!uploadResp.ok) {
        var err = await uploadResp.json();
        throw new Error(err.message || 'Upload failed');
      }

      // Save metadata to DB
      var label = uploadForm.label.trim() || (uploadForm.screen + ' \u2014 ' + uploadForm.feature);
      await supabase.from('app_preview_assets').insert([{
        platform:     platform,
        type:         subTab === 'screenshots' ? 'screenshot' : 'video',
        storage_path: path,
        screen:       uploadForm.screen,
        feature:      uploadForm.feature,
        label:        label,
      }]);

      await loadAssets();
      if (fileInputRef.current) fileInputRef.current.value = '';
      setUploadForm(function(f) { return Object.assign({}, f, { label: '' }); });
    } catch (err) {
      alert('Upload failed: ' + err.message);
    } finally { setUploading(false); }
  }

  async function deleteAsset(asset) {
    try {
      await fetch(
        SB_URL + '/storage/v1/object/' + BUCKET + '/' + asset.storage_path,
        { method: 'DELETE', headers: { apikey: SB_ANON, Authorization: 'Bearer ' + SB_ANON } }
      );
      await supabase.from('app_preview_assets').delete().eq('id', asset.id);
      setAssets(function(a) { return a.filter(function(x) { return x.id !== asset.id; }); });
    } catch (_e) {}
  }

  // Group assets
  var groups = groupBy === 'screen' ? NATIVE_SCREENS : NATIVE_FEATURES;
  var groupKey = groupBy === 'screen' ? 'screen' : 'feature';
  var filtered = activeGroup === 'all'
    ? assets
    : assets.filter(function(a) { return a[groupKey] === activeGroup; });

  var platformLabel = platform === 'android' ? 'Android' : 'iOS';
  var platformColor = platform === 'android' ? '#3ddc84' : '#0071e3';

  // ── BrowserStack sub-tab ─────────────────────────────────────────────────────
  if (subTab === 'live') {
    return React.createElement(LiveDevicePanel, { platform: platform, platformLabel: platformLabel, platformColor: platformColor });
  }

  // ── Screenshots / Video sub-tabs ─────────────────────────────────────────────
  return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 16 } },

    // Sub-tab bar + upload
    React.createElement('div', { style: Object.assign({}, CARD(t), { display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }) },
      // Sub-tabs
      React.createElement('div', { style: { display: 'flex', background: '#f0f4f6', borderRadius: 8, padding: 2, gap: 1, flexShrink: 0 } },
        [
          { id: 'screenshots', label: 'Screenshots' },
          { id: 'video',       label: 'Video' },
          { id: 'live',        label: 'Live Device' },
        ].map(function(t) {
          return React.createElement('button', {
            key: t.id, onClick: function() { setSubTab(t.id); },
            style: { padding: '5px 12px', borderRadius: 6, border: 'none', fontFamily: F, fontSize: '.74rem', cursor: 'pointer', background: subTab === t.id ? '#fff' : 'transparent', color: subTab === t.id ? '#0f1e28' : '#7a9aaa', fontWeight: subTab === t.id ? 600 : 400, boxShadow: subTab === t.id ? '0 1px 3px rgba(0,0,0,0.1)' : 'none', transition: 'all .1s' }
          }, t.label);
        })
      ),
      // Group by toggle
      React.createElement('div', { style: { display: 'flex', background: '#f0f4f6', borderRadius: 8, padding: 2, gap: 1 } },
        [{ id: 'screen', label: 'By Screen' }, { id: 'feature', label: 'By Feature' }].map(function(g) {
          return React.createElement('button', {
            key: g.id, onClick: function() { setGroupBy(g.id); setActiveGroup('all'); },
            style: { padding: '4px 10px', borderRadius: 6, border: 'none', fontFamily: F, fontSize: '.72rem', cursor: 'pointer', background: groupBy === g.id ? '#fff' : 'transparent', color: groupBy === g.id ? '#0f1e28' : '#7a9aaa', fontWeight: groupBy === g.id ? 600 : 400, boxShadow: groupBy === g.id ? '0 1px 3px rgba(0,0,0,0.1)' : 'none', transition: 'all .1s' }
          }, g.label);
        })
      ),
      React.createElement('div', { style: { flex: 1 } }),
      // Upload button
      React.createElement('label', {
        style: { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 14px', borderRadius: 8, background: platformColor, color: '#fff', fontSize: '.78rem', fontWeight: 600, cursor: uploading ? 'not-allowed' : 'pointer', opacity: uploading ? 0.6 : 1, fontFamily: F }
      },
        uploading ? 'Uploading\u2026' : ('+ Upload ' + (subTab === 'video' ? 'Video' : 'Screenshot')),
        React.createElement('input', {
          ref: fileInputRef, type: 'file', accept: subTab === 'video' ? 'video/*' : 'image/*',
          style: { display: 'none' }, onChange: handleUpload, disabled: uploading,
        })
      )
    ),

    // Upload metadata form (shown when file selected \u2014 always visible as config)
    React.createElement('div', { style: Object.assign({}, CARD(t), { padding: '14px 18px' }) },
      React.createElement('div', { style: { fontSize: '.74rem', fontWeight: 700, color: '#314F5C', marginBottom: 10 } }, 'Upload settings \u2014 applied to next upload'),
      React.createElement('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 10 } },
        React.createElement('div', null,
          React.createElement('label', { style: { fontSize: '.7rem', color: '#9aabba', display: 'block', marginBottom: 3 } }, 'Screen'),
          React.createElement('select', {
            value: uploadForm.screen,
            onChange: function(e) { setUploadForm(function(f) { return Object.assign({}, f, { screen: e.target.value }); }); },
            style: { width: '100%', padding: '6px 8px', borderRadius: 7, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', color: '#0f1e28', background: '#fafcfd', outline: 'none' }
          },
            NATIVE_SCREENS.map(function(s) { return React.createElement('option', { key: s.id, value: s.id }, s.label); })
          )
        ),
        React.createElement('div', null,
          React.createElement('label', { style: { fontSize: '.7rem', color: '#9aabba', display: 'block', marginBottom: 3 } }, 'Feature'),
          React.createElement('select', {
            value: uploadForm.feature,
            onChange: function(e) { setUploadForm(function(f) { return Object.assign({}, f, { feature: e.target.value }); }); },
            style: { width: '100%', padding: '6px 8px', borderRadius: 7, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', color: '#0f1e28', background: '#fafcfd', outline: 'none' }
          },
            NATIVE_FEATURES.map(function(s) { return React.createElement('option', { key: s.id, value: s.id }, s.label); })
          )
        ),
        React.createElement('div', null,
          React.createElement('label', { style: { fontSize: '.7rem', color: '#9aabba', display: 'block', marginBottom: 3 } }, 'Label (optional)'),
          React.createElement('input', {
            value: uploadForm.label,
            onChange: function(e) { setUploadForm(function(f) { return Object.assign({}, f, { label: e.target.value }); }); },
            placeholder: 'e.g. Care mode \u2014 search results',
            style: { width: '100%', boxSizing: 'border-box', padding: '6px 8px', borderRadius: 7, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', color: '#0f1e28', background: '#fafcfd', outline: 'none' }
          })
        )
      )
    ),

    // Table not set up yet
    bucketErr && React.createElement('div', { style: Object.assign({}, CARD(t), { color: '#7a5c00', background: '#fffbeb', border: '1px solid #fde68a', fontSize: '.82rem', lineHeight: 1.7 }) },
      React.createElement('strong', null, 'One-time setup needed.'),
      ' Please run the SQL below in Supabase to create the assets table, then create a public storage bucket named ',
      React.createElement('code', null, 'app-previews'),
      ' in Storage \u2192 New Bucket.',
      React.createElement('pre', { style: { marginTop: 10, fontFamily: 'monospace', fontSize: '.7rem', color: '#314F5C', background: '#edf4f7', borderRadius: 8, padding: '10px 14px', overflowX: 'auto', lineHeight: 1.8 } },
'CREATE TABLE IF NOT EXISTS app_preview_assets (\n  id           uuid PRIMARY KEY DEFAULT gen_random_uuid(),\n  platform     text NOT NULL CHECK (platform IN (\'android\',\'ios\')),\n  type         text NOT NULL CHECK (type IN (\'screenshot\',\'video\')),\n  storage_path text NOT NULL,\n  screen       text NOT NULL DEFAULT \'other\',\n  feature      text NOT NULL DEFAULT \'other\',\n  label        text,\n  created_at   timestamptz NOT NULL DEFAULT now()\n);\nALTER TABLE app_preview_assets ENABLE ROW LEVEL SECURITY;\nCREATE POLICY "allow_all_preview_assets" ON app_preview_assets\n  FOR ALL USING (true) WITH CHECK (true);'
      )
    ),

    // Group filter chips
    !bucketErr && React.createElement('div', { style: { display: 'flex', gap: 6, flexWrap: 'wrap' } },
      React.createElement('button', {
        onClick: function() { setActiveGroup('all'); },
        style: { padding: '3px 12px', borderRadius: 99, border: '1.5px solid ' + (activeGroup === 'all' ? platformColor : '#dde4ea'), background: activeGroup === 'all' ? platformColor + '18' : '#fff', color: activeGroup === 'all' ? platformColor : '#9aabba', fontSize: '.72rem', fontWeight: activeGroup === 'all' ? 700 : 400, cursor: 'pointer', fontFamily: F }
      }, 'All'),
      groups.map(function(g) {
        var count = assets.filter(function(a) { return a[groupKey] === g.id; }).length;
        if (count === 0) return null;
        var active = activeGroup === g.id;
        return React.createElement('button', {
          key: g.id, onClick: function() { setActiveGroup(g.id); },
          style: { padding: '3px 12px', borderRadius: 99, border: '1.5px solid ' + (active ? platformColor : '#dde4ea'), background: active ? platformColor + '18' : '#fff', color: active ? platformColor : '#9aabba', fontSize: '.72rem', fontWeight: active ? 700 : 400, cursor: 'pointer', fontFamily: F }
        }, g.label + ' (' + count + ')');
      })
    ),

    // Asset grid
    loading
      ? React.createElement('div', { style: Object.assign({}, CARD(t), { textAlign: 'center', color: '#9aabba', padding: 48 }) }, 'Loading\u2026')
      : !bucketErr && filtered.length === 0
        ? React.createElement('div', { style: CARD(t) },
            React.createElement(Empty, {
              icon: subTab === 'video' ? '\uD83C\uDFA5' : '\uD83D\uDCF8',
              title: 'No ' + (subTab === 'video' ? 'videos' : 'screenshots') + ' yet',
              sub: 'Upload real ' + platformLabel + ' ' + (subTab === 'video' ? 'screen recordings' : 'screenshots') + ' above to show them here in the phone frame.'
            })
          )
        : React.createElement('div', { style: Object.assign({}, CARD(t), { padding: 0, overflow: 'hidden' }) },
            React.createElement('div', { style: { display: 'flex', gap: 0, background: '#f8fafc', minHeight: 700, flexWrap: 'wrap' } },

              // Thumbnail strip (left)
              React.createElement('div', { style: { width: 200, flexShrink: 0, borderRight: '1px solid #edf2f6', overflowY: 'auto', maxHeight: 780 } },
                filtered.length === 0
                  ? React.createElement('div', { style: { padding: 24, fontSize: '.76rem', color: '#b0c4ce', textAlign: 'center' } }, 'None in this group')
                  : filtered.map(function(asset, idx) {
                      var url = storagePubUrl(asset.storage_path);
                      var isSelected = selectedImg ? selectedImg.id === asset.id : idx === 0;
                      return React.createElement('div', {
                        key: asset.id,
                        onClick: function() { setSelectedImg(asset); },
                        style: { padding: '8px 10px', borderBottom: '1px solid #f0f2f4', cursor: 'pointer', background: isSelected ? platformColor + '10' : 'transparent', borderLeft: isSelected ? '3px solid ' + platformColor : '3px solid transparent', transition: 'all .1s' }
                      },
                        asset.type === 'video'
                          ? React.createElement('div', { style: { width: '100%', aspectRatio: '9/16', background: '#1a1a1a', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, marginBottom: 5 } }, '\u25B6\uFE0F')
                          : React.createElement('img', { src: url, alt: asset.label || '', style: { width: '100%', aspectRatio: '9/16', objectFit: 'cover', borderRadius: 6, display: 'block', marginBottom: 5 }, loading: 'lazy' }),
                        React.createElement('div', { style: { fontSize: '.66rem', color: '#314F5C', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, asset.label || (asset.screen + ' / ' + asset.feature)),
                        React.createElement('div', { style: { fontSize: '.6rem', color: '#b0c4ce', marginTop: 2 } }, new Date(asset.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }))
                      );
                    })
              ),

              // Main phone frame view (right)
              React.createElement('div', { style: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', padding: '32px 24px 48px', gap: 16 } },
                (function() {
                  var asset = selectedImg || filtered[0];
                  if (!asset) return null;
                  var url = storagePubUrl(asset.storage_path);
                  return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 } },
                    React.createElement(PhoneShell, { platform: platform },
                      asset.type === 'video'
                        ? React.createElement('video', { src: url, controls: true, autoPlay: false, style: { width: '100%', height: '100%', objectFit: 'cover', display: 'block', background: '#000' } })
                        : React.createElement('img', { src: url, alt: asset.label || '', style: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' } })
                    ),
                    // Asset info + delete
                    React.createElement('div', { style: { textAlign: 'center', maxWidth: 393 } },
                      React.createElement('div', { style: { fontSize: '.82rem', fontWeight: 600, color: '#0f1e28', marginBottom: 4 } }, asset.label || (asset.screen + ' \u2014 ' + asset.feature)),
                      React.createElement('div', { style: { display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 8 } },
                        React.createElement(Pill, { color: platformColor }, platformLabel),
                        React.createElement(Pill, { color: '#314F5C' }, NATIVE_SCREENS.find(function(s) { return s.id === asset.screen; }) ? NATIVE_SCREENS.find(function(s) { return s.id === asset.screen; }).label : asset.screen),
                        React.createElement(Pill, { color: '#6F8FA7' }, NATIVE_FEATURES.find(function(s) { return s.id === asset.feature; }) ? NATIVE_FEATURES.find(function(s) { return s.id === asset.feature; }).label : asset.feature)
                      ),
                      React.createElement('div', { style: { display: 'flex', gap: 8, justifyContent: 'center' } },
                        React.createElement('a', { href: url, target: '_blank', rel: 'noreferrer', style: { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '5px 12px', borderRadius: 7, border: '1px solid #d5e0e6', background: '#f0f4f6', color: '#314F5C', fontSize: '.74rem', fontWeight: 600, textDecoration: 'none', fontFamily: F } }, 'Open full size'),
                        React.createElement('button', {
                          onClick: function() { if (window.confirm('Delete this asset?')) deleteAsset(asset).then(function() { setSelectedImg(null); }); },
                          style: { padding: '5px 12px', borderRadius: 7, border: '1px solid #fca5a5', background: '#fef2f2', color: '#c0392b', fontSize: '.74rem', fontWeight: 600, cursor: 'pointer', fontFamily: F }
                        }, 'Delete')
                      )
                    )
                  );
                })()
              )
            )
          )
  );
}

// ═══════════════════════════════════════════════════════════════════════════════

// ─── Activity logger ───────────────────────────────────────────────────────────
async function logActivity({ action, entity, summary, detail, author_email, author_name }) {
  try {
    await supabase.from('app_activity').insert([{
      action, entity, summary,
      detail:       detail       || null,
      author_email: author_email || null,
      author_name:  author_name  || null,
    }]);
  } catch (_e) { /* never block the main action */ }
}

// BUILDS PANEL  (improvements: notify, QR, share link, structured changelog, version history per tester)
// ═══════════════════════════════════════════════════════════════════════════════

// ── CI/CD Deploy Panel ────────────────────────────────────────────────────────
var GH_TOKEN  = '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';
var GH_REPO   = 'product-sanoire/sanoire-app';
var GH_API    = 'https://api.github.com/repos/' + GH_REPO;

function DeployPanel() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var _webStatus = useState(null); var webStatus = _webStatus[0]; var setWebStatus = _webStatus[1];
  var _droidStatus = useState(null); var droidStatus = _droidStatus[0]; var setDroidStatus = _droidStatus[1];
  var _webLoading = useState(false); var webLoading = _webLoading[0]; var setWebLoading = _webLoading[1];
  var _droidLoading = useState(false); var droidLoading = _droidLoading[0]; var setDroidLoading = _droidLoading[1];
  var _droidType = useState('debug'); var droidType = _droidType[0]; var setDroidType = _droidType[1];
  var _webEnv = useState('production'); var webEnv = _webEnv[0]; var setWebEnv = _webEnv[1];
  var _recentRuns = useState([]); var recentRuns = _recentRuns[0]; var setRecentRuns = _recentRuns[1];
  var _runsLoading = useState(true); var runsLoading = _runsLoading[0]; var setRunsLoading = _runsLoading[1];
  var _ghToken = useState(''); var ghToken = _ghToken[0]; var setGhToken = _ghToken[1];
  var _tokenSaved = useState(false); var tokenSaved = _tokenSaved[0]; var setTokenSaved = _tokenSaved[1];

  var GH_HDR = { 'Authorization': 'token ' + (ghToken || GH_TOKEN), 'Content-Type': 'application/json', 'Accept': 'application/vnd.github+json' };

  useEffect(function() { loadRecentRuns(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function() {
    var saved = localStorage.getItem('sanoire_gh_token');
    if (saved) setGhToken(saved);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function loadRecentRuns() {
    setRunsLoading(true);
    try {
      var resp = await fetch(GH_API + '/actions/runs?per_page=10', { headers: GH_HDR });
      if (!resp.ok) throw new Error('GitHub API error ' + resp.status);
      var data = await resp.json();
      setRecentRuns(data.workflow_runs || []);
    } catch (_e) { setRecentRuns([]); }
    finally { setRunsLoading(false); }
  }

  async function triggerWebDeploy() {
    setWebLoading(true); setWebStatus(null);
    try {
      var resp = await fetch(GH_API + '/actions/workflows/deploy-web.yml/dispatches', {
        method: 'POST',
        headers: GH_HDR,
        body: JSON.stringify({ ref: 'main', inputs: { environment: webEnv, triggered_by: 'Admin Dashboard' } })
      });
      if (resp.status === 204) {
        setWebStatus('started');
        setTimeout(loadRecentRuns, 3000);
        setTimeout(loadRecentRuns, 8000);
      } else if (resp.status === 404) {
        setWebStatus('missing');
      } else {
        setWebStatus('error');
      }
    } catch (_e) { setWebStatus('error'); }
    finally { setWebLoading(false); }
  }

  async function triggerAndroidBuild() {
    setDroidLoading(true); setDroidStatus(null);
    try {
      var resp = await fetch(GH_API + '/actions/workflows/build-android.yml/dispatches', {
        method: 'POST',
        headers: GH_HDR,
        body: JSON.stringify({ ref: 'main', inputs: { build_type: droidType, triggered_by: 'Admin Dashboard' } })
      });
      if (resp.status === 204) {
        setDroidStatus('started');
        setTimeout(loadRecentRuns, 3000);
        setTimeout(loadRecentRuns, 8000);
      } else if (resp.status === 404) {
        setDroidStatus('missing');
      } else {
        setDroidStatus('error');
      }
    } catch (_e) { setDroidStatus('error'); }
    finally { setDroidLoading(false); }
  }

  function saveToken() {
    localStorage.setItem('sanoire_gh_token', ghToken);
    setTokenSaved(true);
    setTimeout(function() { setTokenSaved(false); }, 2000);
  }

  function runStatusColor(s) {
    if (s === 'completed') return '#1D9E75';
    if (s === 'in_progress') return '#e08c2e';
    if (s === 'queued') return '#6F8FA7';
    if (s === 'failure') return '#c0392b';
    return '#9aabba';
  }
  function runStatusLabel(run) {
    if (run.status === 'completed') return run.conclusion === 'success' ? '\u2713 Success' : '\u2717 ' + (run.conclusion || 'Failed');
    if (run.status === 'in_progress') return '\u25cf Running';
    if (run.status === 'queued') return '\u25cb Queued';
    return run.status;
  }

  function statusNote(status, platform) {
    if (status === 'started') return React.createElement('div', { style: { fontSize: '.76rem', color: '#1D9E75', marginTop: 8, display: 'flex', alignItems: 'center', gap: 5 } },
      '\u2713 ' + platform + ' workflow started \u2014 check Recent Runs below for progress');
    if (status === 'missing') return React.createElement('div', { style: { fontSize: '.76rem', color: '#e08c2e', marginTop: 8 } },
      '\u26a0 Workflow file not found in repo. Add a GitHub token with workflow scope below, then the workflow files will be created automatically.');
    if (status === 'error') return React.createElement('div', { style: { fontSize: '.76rem', color: '#c0392b', marginTop: 8 } },
      'Failed to trigger. Check your GitHub token has workflow scope.');
    return null;
  }

  return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 16 } },

    // ── Web Deploy ─────────────────────────────────────────────────────────────
    React.createElement('div', { style: Object.assign({}, CARD(t)) },
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 } },
        React.createElement('div', { style: { width: 8, height: 8, borderRadius: '50%', background: '#1D9E75' } }),
        React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Web App Deploy'),
        React.createElement('div', { style: { fontSize: '.72rem', color: '#9aabba', marginLeft: 'auto' } }, 'Deploys to Vercel via GitHub Actions')
      ),
      React.createElement('div', { style: { display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' } },
        React.createElement('div', { style: { display: 'flex', background: '#f0f4f6', borderRadius: 8, padding: 2, gap: 1 } },
          ['production', 'preview'].map(function(env) {
            return React.createElement('button', {
              key: env, onClick: function() { setWebEnv(env); },
              style: { padding: '5px 12px', borderRadius: 6, border: 'none', fontFamily: F, fontSize: '.74rem', cursor: 'pointer', background: webEnv === env ? '#fff' : 'transparent', color: webEnv === env ? '#0f1e28' : '#7a9aaa', fontWeight: webEnv === env ? 600 : 400, boxShadow: webEnv === env ? '0 1px 3px rgba(0,0,0,0.1)' : 'none', transition: 'all .1s' }
            }, env.charAt(0).toUpperCase() + env.slice(1));
          })
        ),
        React.createElement(Btn, {
          onClick: triggerWebDeploy,
          disabled: webLoading,
          style: { background: '#1D9E75' }
        }, webLoading ? 'Triggering\u2026' : '\u25ba Deploy Web App'),
        React.createElement('a', {
          href: 'https://vercel.com/sanoire/sanoire-app/deployments',
          target: '_blank', rel: 'noreferrer',
          style: { fontSize: '.74rem', color: '#314F5C', textDecoration: 'none', fontFamily: F }
        }, 'View Vercel \u2197')
      ),
      statusNote(webStatus, 'Web')
    ),

    // ── Android Build ──────────────────────────────────────────────────────────
    React.createElement('div', { style: Object.assign({}, CARD(t)) },
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 } },
        React.createElement('div', { style: { width: 8, height: 8, borderRadius: '50%', background: '#3ddc84' } }),
        React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Android APK Build'),
        React.createElement('div', { style: { fontSize: '.72rem', color: '#9aabba', marginLeft: 'auto' } }, 'Builds APK via GitHub Actions — no PC required')
      ),
      React.createElement('div', { style: { display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' } },
        React.createElement('div', { style: { display: 'flex', background: '#f0f4f6', borderRadius: 8, padding: 2, gap: 1 } },
          ['debug', 'release'].map(function(t) {
            return React.createElement('button', {
              key: t, onClick: function() { setDroidType(t); },
              style: { padding: '5px 12px', borderRadius: 6, border: 'none', fontFamily: F, fontSize: '.74rem', cursor: 'pointer', background: droidType === t ? '#fff' : 'transparent', color: droidType === t ? '#0f1e28' : '#7a9aaa', fontWeight: droidType === t ? 600 : 400, boxShadow: droidType === t ? '0 1px 3px rgba(0,0,0,0.1)' : 'none', transition: 'all .1s' }
            }, t.charAt(0).toUpperCase() + t.slice(1));
          })
        ),
        React.createElement(Btn, {
          onClick: triggerAndroidBuild,
          disabled: droidLoading,
          style: { background: t.accent }
        }, droidLoading ? 'Triggering\u2026' : '\u25ba Build Android APK'),
        React.createElement('a', {
          href: 'https://github.com/' + GH_REPO + '/actions',
          target: '_blank', rel: 'noreferrer',
          style: { fontSize: '.74rem', color: '#314F5C', textDecoration: 'none', fontFamily: F }
        }, 'View Actions \u2197')
      ),
      statusNote(droidStatus, 'Android'),
      React.createElement('div', { style: { fontSize: '.72rem', color: '#9aabba', marginTop: 10, lineHeight: 1.6 } },
        'Debug builds are faster and good for testing. Release builds require signing keys set up in GitHub Secrets.'
      )
    ),

    // ── Recent Runs ────────────────────────────────────────────────────────────
    React.createElement('div', { style: Object.assign({}, CARD(t), { padding: 0, overflow: 'hidden' }) },
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 18px', borderBottom: '1px solid #f0f2f4' } },
        React.createElement('div', { style: { fontSize: '.82rem', fontWeight: 700, color: '#0f1e28' } }, 'Recent Workflow Runs'),
        React.createElement('button', {
          onClick: loadRecentRuns,
          style: { fontSize: '.72rem', color: '#314F5C', border: 'none', cursor: 'pointer', fontFamily: F, padding: '4px 8px', borderRadius: 6, background: '#f0f4f6' }
        }, runsLoading ? 'Loading\u2026' : '\u21bb Refresh')
      ),
      runsLoading
        ? React.createElement('div', { style: { padding: 24, textAlign: 'center', color: '#9aabba', fontSize: '.78rem' } }, 'Loading runs\u2026')
        : recentRuns.length === 0
          ? React.createElement('div', { style: { padding: 24 } },
              React.createElement(Empty, { icon: '\u25ba', title: 'No workflow runs yet', sub: 'Trigger your first build above. Runs appear here within a few seconds.' })
            )
          : React.createElement('div', null,
              recentRuns.map(function(run, idx) {
                var color = runStatusColor(run.status === 'completed' ? run.conclusion : run.status);
                var ago = Math.round((Date.now() - new Date(run.updated_at)) / 60000);
                var agoStr = ago < 1 ? 'just now' : ago < 60 ? ago + 'm ago' : Math.round(ago/60) + 'h ago';
                return React.createElement('div', {
                  key: run.id,
                  style: { display: 'flex', alignItems: 'center', gap: 12, padding: '10px 18px', borderBottom: idx < recentRuns.length - 1 ? '1px solid #f0f2f4' : 'none' }
                },
                  React.createElement('div', { style: { width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 } }),
                  React.createElement('div', { style: { flex: 1, minWidth: 0 } },
                    React.createElement('div', { style: { fontSize: '.78rem', fontWeight: 600, color: '#0f1e28', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, run.display_title || run.name || 'Workflow run'),
                    React.createElement('div', { style: { fontSize: '.68rem', color: '#9aabba', marginTop: 2 } }, run.name + ' \u2022 ' + agoStr + ' \u2022 #' + run.run_number)
                  ),
                  React.createElement('div', { style: { fontSize: '.72rem', fontWeight: 600, color: color, flexShrink: 0 } }, runStatusLabel(run)),
                  React.createElement('a', {
                    href: run.html_url, target: '_blank', rel: 'noreferrer',
                    style: { fontSize: '.7rem', color: '#6F8FA7', textDecoration: 'none', flexShrink: 0, fontFamily: F }
                  }, 'View \u2197')
                );
              })
            )
    ),


    // ── LambdaTest Cloud Device ──────────────────────────
    React.createElement('div', { style: Object.assign({}, CARD(t), { background: 'linear-gradient(135deg, #0f1e28 0%, #1a3040 100%)', border: 'none' }) },
      React.createElement('div', { style: { display: 'flex', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap', marginBottom: 14 } },
        React.createElement('div', { style: { flex: 1, minWidth: 240 } },
          React.createElement('div', { style: { fontSize: '.92rem', fontWeight: 700, color: '#e8f4fb', marginBottom: 4 } }, 'Cloud Device — LambdaTest'),
          React.createElement('div', { style: { fontSize: '.78rem', color: 'rgba(175,225,246,0.65)', lineHeight: 1.7 } },
            'Test the real Sanoire app on cloud Android and iOS devices. Accessible by all 10 team members from any computer, no USB required.'
          )
        ),
        React.createElement('div', { style: { display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', flexShrink: 0 } },
          React.createElement('a', { href: 'https://applive.lambdatest.com/app', target: '_blank', rel: 'noreferrer',
            style: { display: 'inline-flex', alignItems: 'center', gap: 5, padding: '7px 14px', borderRadius: 8, background: '#1D9E75', color: '#fff', fontSize: '.76rem', fontWeight: 600, textDecoration: 'none', fontFamily: F }
          }, '► Open App Live ↗'),
          React.createElement('a', { href: 'https://accounts.lambdatest.com/dashboard', target: '_blank', rel: 'noreferrer',
            style: { display: 'inline-flex', alignItems: 'center', gap: 5, padding: '7px 14px', borderRadius: 8, background: 'rgba(175,225,246,0.12)', border: '1px solid rgba(175,225,246,0.2)', color: '#AFE1F6', fontSize: '.76rem', fontWeight: 600, textDecoration: 'none', fontFamily: F }
          }, 'Dashboard ↗')
        )
      ),
      React.createElement('div', { style: { padding: '12px 14px', background: 'rgba(175,225,246,0.06)', borderRadius: 8 } },
        React.createElement('div', { style: { fontSize: '.74rem', fontWeight: 700, color: 'rgba(175,225,246,0.8)', marginBottom: 8 } }, 'How to share a live session with your team:'),
        React.createElement('div', { style: { display: 'flex', flexWrap: 'wrap', gap: 8 } },
          ['Build Android APK above', 'Open App Live', 'Upload the APK file', 'Pick any real device', 'Share the session link'].map(function(s, i) {
            return React.createElement('div', { key: i, style: { display: 'flex', alignItems: 'center', gap: 6, fontSize: '.72rem', color: 'rgba(175,225,246,0.6)' } },
              React.createElement('div', { style: { width: 18, height: 18, borderRadius: '50%', background: 'rgba(175,225,246,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.65rem', fontWeight: 700, color: '#AFE1F6', flexShrink: 0 } }, i + 1),
              s
            );
          })
        )
      )
    ),

    // ── GitHub Token ───────────────────────────────────────────────────────────
    React.createElement('div', { style: Object.assign({}, CARD(t), { background: '#f8fafc' }) },
      React.createElement('div', { style: { fontSize: '.78rem', fontWeight: 700, color: '#314F5C', marginBottom: 6 } }, 'GitHub Token (workflow scope)'),
      React.createElement('div', { style: { fontSize: '.72rem', color: '#9aabba', marginBottom: 10, lineHeight: 1.6 } },
        'To trigger builds, the token needs the ', React.createElement('code', { style: { background: '#f0f4f6', padding: '1px 5px', borderRadius: 4 } }, 'workflow'),
        ' scope. ',
        React.createElement('a', { href: 'https://github.com/settings/tokens', target: '_blank', rel: 'noreferrer', style: { color: '#314F5C' } }, 'Update at github.com/settings/tokens \u2197')
      ),
      React.createElement('div', { style: { display: 'flex', gap: 8 } },
        React.createElement('input', {
          type: 'password',
          value: ghToken,
          onChange: function(e) { setGhToken(e.target.value); },
          placeholder: 'ghp_xxxx (paste token with workflow scope)',
          style: { flex: 1, padding: '7px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', color: '#0f1e28', outline: 'none', background: t.panel }
        }),
        React.createElement(Btn, { onClick: saveToken, variant: 'secondary', small: true },
          tokenSaved ? '\u2713 Saved' : 'Save'
        )
      )
    )
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// TESTERS PANEL  (improvements: version history, status toggle, QR per tester, send link)
// ═══════════════════════════════════════════════════════════════════════════════
function TestersPanel() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const { session: tpSess } = useAuth();
  const authorEmail = tpSess?.user?.email || null;
  const authorName  = authorEmail ? authorEmail.split('@')[0].split(/[._-]/).map(function(s){ return s.charAt(0).toUpperCase()+s.slice(1); }).join(' ') : 'Admin';
  const [testers, setTesters]         = useState([]);
  const [builds, setBuilds]           = useState([]);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);
  const [showModal, setShowModal]     = useState(false);
  const [editTarget, setEditTarget]   = useState(null);
  const [confirmDel, setConfirmDel]   = useState(null);
  const [deleting, setDeleting]       = useState(null);
  const [search, setSearch]           = useState('');
  const [filterPlatform, setFilterPlatform] = useState('all');
  const [expandedId, setExpandedId]   = useState(null); // version history drawer
  const [sendLinkModal, setSendLinkModal] = useState(null); // { tester, build }
  const [form, setForm]               = useState({ name: '', email: '', platform: 'both', role: 'external', status: 'invited', notes: '' });
  const [saving, setSaving]           = useState(false);
  const [formError, setFormError]     = useState(null);
  const { copy, copied }              = useCopy();

  useEffect(() => { loadTesters(); loadBuilds(); }, []);

  async function loadTesters() {
    setLoading(true); setError(null);
    try {
      const { data, error: err } = await supabase.from('app_testers').select('*').order('created_at', { ascending: false });
      if (err) throw err;
      setTesters(data || []);
    } catch (e) { setError(e.message || 'Failed to load testers'); }
    finally { setLoading(false); }
  }

  async function loadBuilds() {
    const { data } = await supabase.from('app_builds').select('id,platform,version,download_url,created_at').order('created_at', { ascending: false });
    setBuilds(data || []);
  }

  function openAdd() {
    setEditTarget(null);
    setForm({ name: '', email: '', platform: 'both', role: 'external', status: 'invited', notes: '' });
    setFormError(null); setShowModal(true);
  }

  function openEdit(t) {
    setEditTarget(t);
    setForm({ name: t.name || '', email: t.email || '', platform: t.platform || 'both', role: t.role || 'external', status: t.status || 'invited', notes: t.notes || '' });
    setFormError(null); setShowModal(true);
  }

  async function saveTester() {
    if (!form.name.trim())  { setFormError('Name is required');  return; }
    if (!form.email.trim()) { setFormError('Email is required'); return; }
    setSaving(true); setFormError(null);
    try {
      const payload = { name: form.name.trim(), email: form.email.trim().toLowerCase(), platform: form.platform, role: form.role, status: form.status, notes: form.notes.trim() || null };
      if (editTarget) {
        const before = { name: editTarget.name, email: editTarget.email, platform: editTarget.platform, role: editTarget.role, status: editTarget.status, notes: editTarget.notes };
        const { error: err } = await supabase.from('app_testers').update(payload).eq('id', editTarget.id);
        if (err) throw err;
        await logActivity({ action: 'tester_updated', entity: 'tester', summary: payload.name + ' tester details updated', detail: { before, after: payload }, author_email: authorEmail, author_name: authorName });
      } else {
        const { error: err } = await supabase.from('app_testers').insert([payload]);
        if (err) throw err;
        await logActivity({ action: 'tester_added', entity: 'tester', summary: payload.name + ' added as tester (' + payload.platform + ', ' + payload.role + ')', detail: payload, author_email: authorEmail, author_name: authorName });
      }
      setShowModal(false); await loadTesters();
    } catch (e) { setFormError(e.message || 'Failed to save tester'); }
    finally { setSaving(false); }
  }

  async function deleteTester(id) {
    setDeleting(id);
    try {
      const testerToDelete = testers.find(function(t){ return t.id === id; });
      const { error: err } = await supabase.from('app_testers').delete().eq('id', id);
      if (err) throw err;
      setTesters(ts => ts.filter(t => t.id !== id));
      if (testerToDelete) await logActivity({ action: 'tester_removed', entity: 'tester', summary: testerToDelete.name + ' removed from testers', detail: testerToDelete, author_email: authorEmail, author_name: authorName });
    } catch (_e) {}
    finally { setDeleting(null); setConfirmDel(null); }
  }

  async function toggleStatus(t) {
    const next = t.status === 'active' ? 'inactive' : t.status === 'inactive' ? 'invited' : 'active';
    try {
      await supabase.from('app_testers').update({ status: next }).eq('id', t.id);
      setTesters(ts => ts.map(x => x.id === t.id ? { ...x, status: next } : x));
      await logActivity({ action: 'tester_status_changed', entity: 'tester', summary: t.name + ' status: ' + t.status + ' to ' + next, detail: { before: { status: t.status }, after: { status: next }, tester: t.name, email: t.email }, author_email: authorEmail, author_name: authorName });
    } catch (_e) {}
  }

  // Builds relevant to a tester's platform
  function relevantBuilds(t) {
    return builds.filter(b => t.platform === 'both' || b.platform === t.platform);
  }

  // Copy send-link email to clipboard
  function buildSendLinkEmail(tester, b) {
    const platform = b.platform === 'ios' ? 'iOS' : 'Android';
    return `To: ${tester.email}
Subject: Sanoire ${platform} v${b.version} \u2014 install link

Hi ${tester.name.split(' ')[0]},

Here's your install link for Sanoire ${platform} v${b.version}:

${b.download_url}

${b.platform === 'android'
  ? 'Open the link on your Android device, allow installing from unknown sources if prompted, then tap the .apk to install.'
  : 'Open the link on your iOS device and follow the install instructions.'}

Let us know how it goes!

Sanoire Team`;
  }

  const platLabel = { android: 'Android', ios: 'iOS', both: 'Both' };

  const filtered = testers.filter(t => {
    const q = search.toLowerCase();
    const matchQ = !q || (t.name || '').toLowerCase().includes(q) || (t.email || '').toLowerCase().includes(q);
    const matchP = filterPlatform === 'all' || t.platform === filterPlatform || t.platform === 'both';
    return matchQ && matchP;
  });

  const stats = {
    total:   testers.length,
    active:  testers.filter(t => t.status === 'active').length,
    android: testers.filter(t => t.platform === 'android' || t.platform === 'both').length,
    ios:     testers.filter(t => t.platform === 'ios'     || t.platform === 'both').length,
  };

  const tableErr = error && (error.includes('does not exist') || error.includes('relation'));

  return React.createElement('div', null,
    /* Stats */
    React.createElement('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 16 } },
      [
        { label: 'Total Testers', value: stats.total,   color: '#314F5C' },
        { label: 'Active',        value: stats.active,  color: '#1D9E75' },
        { label: 'Android',       value: stats.android, color: '#3dba78' },
        { label: 'iOS',           value: stats.ios,     color: '#555'    },
      ].map(s =>
        React.createElement('div', { key: s.label, style: { ...CARD, textAlign: 'center', padding: '14px 12px' } },
          React.createElement('div', { style: { fontSize: '1.4rem', fontWeight: 700, color: s.color } }, s.value),
          React.createElement('div', { style: { fontSize: '.68rem', color: '#9aabba', marginTop: 3 } }, s.label)
        )
      )
    ),

    /* Toolbar */
    React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14, flexWrap: 'wrap' } },
      React.createElement('input', {
        value: search, onChange: e => setSearch(e.target.value), placeholder: 'Search testers\u2026',
        style: { flex: 1, minWidth: 160, padding: '7px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.8rem', color: '#0f1e28', outline: 'none', background: '#fafcfd' },
      }),
      React.createElement('div', { style: { display: 'flex', background: '#f0f4f6', borderRadius: 8, padding: 2, gap: 1 } },
        [{ id: 'all', label: 'All' }, { id: 'android', label: 'Android' }, { id: 'ios', label: 'iOS' }].map(p =>
          React.createElement('button', {
            key: p.id, onClick: () => setFilterPlatform(p.id),
            style: { padding: '4px 10px', borderRadius: 6, border: 'none', fontFamily: F, fontSize: '.72rem', cursor: 'pointer', background: filterPlatform === p.id ? '#fff' : 'transparent', color: filterPlatform === p.id ? '#0f1e28' : '#7a9aaa', fontWeight: filterPlatform === p.id ? 600 : 400, boxShadow: filterPlatform === p.id ? '0 1px 3px rgba(0,0,0,0.1)' : 'none', transition: 'all .1s' },
          }, p.label)
        )
      ),
      React.createElement(Btn, { onClick: openAdd }, '+ Add Tester')
    ),

    loading && React.createElement('div', { style: { ...CARD, textAlign: 'center', color: '#9aabba', padding: 48 } }, 'Loading testers\u2026'),
    !loading && error && !tableErr && React.createElement('div', { style: { ...CARD, color: '#c0392b', fontSize: '.82rem' } }, error),
    !loading && tableErr && React.createElement('div', { style: { ...CARD, color: '#7a5c00', background: '#fffbeb', border: '1px solid #fde68a', fontSize: '.82rem' } },
      'The ', React.createElement('code', null, 'app_testers'), ' table doesn\u2019t exist yet. Please run the setup SQL in Supabase.'
    ),

    !loading && !error && filtered.length === 0 &&
      React.createElement('div', { style: CARD(t) },
        testers.length === 0
          ? React.createElement(Empty, { icon: IC.users, title: 'No testers yet', sub: 'Add team members and clients to track who has access to your app builds.' })
          : React.createElement(Empty, { icon: IC.search, title: 'No results', sub: 'Try a different search or filter.' })
      ),

    !loading && !error && filtered.length > 0 &&
      React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 8 } },
        /* Header row */
        React.createElement('div', { style: { display: 'grid', gridTemplateColumns: '1fr 180px 100px 100px 90px 80px', gap: 12, padding: '6px 18px', fontSize: '.66rem', fontWeight: 700, color: '#9aabba', textTransform: 'uppercase', letterSpacing: '.06em' } },
          React.createElement('span', null, 'Name / Email'),
          React.createElement('span', null, 'Platform'),
          React.createElement('span', null, 'Role'),
          React.createElement('span', null, 'Status'),
          React.createElement('span', null, 'Added'),
          React.createElement('span', null)
        ),
        filtered.map(t => {
          const relBuilds = relevantBuilds(t);
          const isExpanded = expandedId === t.id;
          return React.createElement('div', { key: t.id },
            React.createElement('div', {
              style: { ...CARD, padding: '12px 18px', display: 'grid', gridTemplateColumns: '1fr 180px 100px 100px 90px 80px', gap: 12, alignItems: 'center' },
            },
              /* Name + email */
              React.createElement('div', { style: { minWidth: 0 } },
                React.createElement('div', { style: { fontWeight: 600, color: '#0f1e28', fontSize: '.84rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }, t.name),
                React.createElement('div', { style: { fontSize: '.72rem', color: '#9aabba', marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }, t.email),
                t.notes && React.createElement('div', { style: { fontSize: '.68rem', color: '#b0c4ce', marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }, t.notes)
              ),
              React.createElement('div', { style: { fontSize: '.76rem', color: '#314F5C' } }, platLabel[t.platform] || t.platform),
              React.createElement('div', null, React.createElement(Pill, { color: t.role === 'team' ? '#314F5C' : '#6F8FA7' }, t.role === 'team' ? 'Team' : 'Client')),
              /* Clickable status toggle */
              React.createElement('div', null,
                React.createElement('button', { onClick: () => toggleStatus(t), title: 'Click to cycle: invited \u2192 active \u2192 inactive', style: { background: 'none', border: 'none', cursor: 'pointer', padding: 0 } },
                  React.createElement(StatusBadge, { status: t.status })
                )
              ),
              React.createElement('div', { style: { fontSize: '.72rem', color: '#b0c4ce' } },
                t.created_at ? new Date(t.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: '2-digit' }) : '\u2014'
              ),
              /* Actions */
              React.createElement('div', { style: { display: 'flex', gap: 5, justifyContent: 'flex-end' } },
                /* Version history toggle */
                React.createElement('button', {
                  onClick: () => setExpandedId(isExpanded ? null : t.id),
                  title: isExpanded ? 'Hide build history' : 'Show build history',
                  style: { width: 26, height: 26, borderRadius: 6, border: '1px solid ' + (isExpanded ? '#314F5C' : '#dde4ea'), background: isExpanded ? '#314F5C18' : '#f8fafc', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: isExpanded ? '#314F5C' : '#9aabba' },
                },
                  React.createElement('svg', { width: 11, height: 11, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' },
                    React.createElement('polyline', { points: '22 12 18 12 15 21 9 3 6 12 2 12' })
                  )
                ),
                React.createElement('button', { onClick: () => openEdit(t), title: 'Edit tester', style: { width: 26, height: 26, borderRadius: 6, border: '1px solid #dde4ea', background: '#f8fafc', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#314F5C' } },
                  React.createElement('svg', { width: 11, height: 11, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' },
                    React.createElement('path', { d: 'M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7' }),
                    React.createElement('path', { d: 'M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z' })
                  )
                ),
                React.createElement('button', { onClick: () => setConfirmDel(t.id), disabled: deleting === t.id, style: { width: 26, height: 26, borderRadius: 6, border: '1px solid #fca5a5', background: '#fef2f2', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#c0392b', opacity: deleting === t.id ? 0.5 : 1 } },
                  React.createElement('svg', { width: 11, height: 11, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' },
                    React.createElement('polyline', { points: '3 6 5 6 21 6' }), React.createElement('path', { d: 'M19 6l-1 14H6L5 6' }), React.createElement('path', { d: 'M10 11v6M14 11v6M9 6V4h6v2' })
                  )
                )
              )
            ),
            /* ── Version history drawer ── */
            isExpanded && React.createElement('div', {
              style: { background: '#f8fafc', border: '1px solid #e8eef3', borderTop: 'none', borderRadius: '0 0 12px 12px', padding: '12px 18px' }
            },
              React.createElement('div', { style: { fontSize: '.72rem', fontWeight: 700, color: '#314F5C', marginBottom: 10 } }, 'Available builds for ' + t.name),
              relBuilds.length === 0
                ? React.createElement('div', { style: { fontSize: '.76rem', color: '#b0c4ce', padding: '8px 0' } }, 'No builds match this tester\u2019s platform yet.')
                : React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 6 } },
                    relBuilds.map(b => React.createElement('div', {
                      key: b.id,
                      style: { display: 'flex', alignItems: 'center', gap: 12, background: t.panel, borderRadius: 8, border: '1px solid #e8eef3', padding: '8px 12px' }
                    },
                      React.createElement('span', { style: { fontSize: '.8rem', fontWeight: 600, color: '#0f1e28' } }, 'v' + b.version),
                      React.createElement(Pill, { color: b.platform === 'android' ? '#3dba78' : '#555' }, b.platform === 'android' ? 'Android' : 'iOS'),
                      React.createElement('span', { style: { fontSize: '.7rem', color: '#9aabba', flex: 1 } },
                        new Date(b.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
                      ),
                      b.download_url && React.createElement('div', { style: { display: 'flex', gap: 6 } },
                        /* QR for this build/tester combo */
                        React.createElement('button', {
                          onClick: () => setSendLinkModal({ tester: t, build: b }),
                          title: 'Send this build to tester',
                          style: { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 6, border: '1px solid #d5e0e6', background: '#f0f4f6', color: '#314F5C', fontSize: '.7rem', fontWeight: 600, cursor: 'pointer', fontFamily: F },
                        },
                          React.createElement('svg', { width: 10, height: 10, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' }, React.createElement('path', { d: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z' }), React.createElement('polyline', { points: '22,6 12,13 2,6' })),
                          'Send'
                        ),
                        React.createElement('button', {
                          onClick: () => copy(b.download_url, b.id + '-' + t.id),
                          style: { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 6, border: '1px solid #d5e0e6', background: '#f0f4f6', color: '#314F5C', fontSize: '.7rem', fontWeight: 600, cursor: 'pointer', fontFamily: F },
                        }, copied === b.id + '-' + t.id ? React.createElement('span', { style: { display: 'inline-flex', alignItems: 'center', gap: 4 } }, IC.check, 'Copied') : 'Copy Link')
                      )
                    ))
                  )
            )
          );
        })
      ),

    /* Add/Edit modal */
    React.createElement(Modal, { open: showModal, onClose: () => setShowModal(false), title: editTarget ? 'Edit Tester' : 'Add Tester' },
      React.createElement(LabeledInput, { label: 'Name', required: true, value: form.name, onChange: v => setForm(f => ({ ...f, name: v })), placeholder: 'Jane Smith' }),
      React.createElement(LabeledInput, { label: 'Email', required: true, type: 'email', value: form.email, onChange: v => setForm(f => ({ ...f, email: v })), placeholder: 'jane@example.com' }),
      React.createElement(LabeledSelect, { label: 'Platform', value: form.platform, onChange: v => setForm(f => ({ ...f, platform: v })), options: [{ value: 'both', label: 'Both' }, { value: 'android', label: 'Android' }, { value: 'ios', label: 'iOS' }] }),
      React.createElement(LabeledSelect, { label: 'Role', value: form.role, onChange: v => setForm(f => ({ ...f, role: v })), options: [{ value: 'team', label: 'Team Member' }, { value: 'external', label: 'Client' }] }),
      React.createElement(LabeledSelect, { label: 'Status', value: form.status, onChange: v => setForm(f => ({ ...f, status: v })), options: [{ value: 'invited', label: 'Invited' }, { value: 'active', label: 'Active' }, { value: 'inactive', label: 'Inactive' }] }),
      React.createElement(LabeledInput, { label: 'Notes', value: form.notes, onChange: v => setForm(f => ({ ...f, notes: v })), placeholder: 'Optional context\u2026' }),
      formError && React.createElement('div', { style: { color: '#c0392b', fontSize: '.76rem', marginBottom: 12 } }, formError),
      React.createElement('div', { style: { display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 } },
        React.createElement(Btn, { variant: 'ghost', onClick: () => setShowModal(false) }, 'Cancel'),
        React.createElement(Btn, { onClick: saveTester, disabled: saving }, saving ? 'Saving\u2026' : editTarget ? 'Save Changes' : 'Add Tester')
      )
    ),

    /* Send link modal */
    React.createElement(Modal, { open: !!sendLinkModal, onClose: () => setSendLinkModal(null), title: 'Send Build Link', wide: true },
      sendLinkModal && React.createElement('div', null,
        React.createElement('div', { style: { display: 'flex', gap: 20, marginBottom: 20, flexWrap: 'wrap', alignItems: 'flex-start' } },
          React.createElement('div', { style: { flex: 1 } },
            React.createElement('div', { style: { fontSize: '.76rem', color: '#9aabba', marginBottom: 4 } }, 'QR Code \u2014 scan on device'),
            sendLinkModal.build.download_url
              ? React.createElement(QRCode, { url: sendLinkModal.build.download_url, size: 140 })
              : React.createElement('div', { style: { fontSize: '.76rem', color: '#c0392b' } }, 'No download URL set for this build.')
          ),
          React.createElement('div', { style: { flex: 2, minWidth: 240 } },
            React.createElement('div', { style: { fontSize: '.76rem', fontWeight: 600, color: '#314F5C', marginBottom: 6 } }, 'Email to ' + sendLinkModal.tester.name),
            React.createElement('textarea', {
              defaultValue: buildSendLinkEmail(sendLinkModal.tester, sendLinkModal.build),
              id: 'send-link-email',
              rows: 14,
              style: { width: '100%', boxSizing: 'border-box', padding: '8px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: 'monospace', fontSize: '.7rem', color: '#0f1e28', outline: 'none', background: '#fafcfd', resize: 'vertical', lineHeight: 1.6 },
            })
          )
        ),
        React.createElement('div', { style: { display: 'flex', gap: 8, justifyContent: 'flex-end' } },
          React.createElement(Btn, { variant: 'ghost', onClick: () => setSendLinkModal(null) }, 'Close'),
          React.createElement(Btn, { variant: 'success', onClick: () => {
            const el = document.getElementById('send-link-email');
            if (el) navigator.clipboard.writeText(el.value).catch(() => {});
            setSendLinkModal(null);
          }}, 'Copy Email to Clipboard')
        )
      )
    ),

    /* Delete confirm */
    React.createElement(Modal, { open: !!confirmDel, onClose: () => setConfirmDel(null), title: 'Remove Tester' },
      React.createElement('p', { style: { fontSize: '.84rem', color: '#4a6070', marginBottom: 20 } }, 'Are you sure you want to remove this tester?'),
      React.createElement('div', { style: { display: 'flex', gap: 8, justifyContent: 'flex-end' } },
        React.createElement(Btn, { variant: 'ghost', onClick: () => setConfirmDel(null) }, 'Cancel'),
        React.createElement(Btn, { variant: 'danger', onClick: () => deleteTester(confirmDel) }, 'Remove')
      )
    )
  );
}

// ═══════════════════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════════════
// ACTIVITY PANEL
// ═══════════════════════════════════════════════════════════════════════════════
const ACTION_META = {
  build_added:           { label: 'Build Added',     color: '#1D9E75' },
  build_deleted:         { label: 'Build Deleted',   color: '#c0392b' },
  tester_added:          { label: 'Tester Added',    color: '#314F5C' },
  tester_updated:        { label: 'Tester Updated',  color: '#6F8FA7' },
  tester_removed:        { label: 'Tester Removed',  color: '#c0392b' },
  tester_status_changed: { label: 'Status Changed',  color: '#e08c2e' },
  system:                { label: 'System',          color: '#9aabba' },
};

function timeAgo(ts) {
  if (!ts) return '';
  const diff = Date.now() - new Date(ts).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1)  return 'just now';
  if (m < 60) return m + 'm ago';
  const h = Math.floor(m / 60);
  if (h < 24) return h + 'h ago';
  const d = Math.floor(h / 24);
  if (d < 7)  return d + 'd ago';
  return new Date(ts).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

function DetailDiff({ detail }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  if (!detail) return React.createElement('div', { style: { fontSize: '.74rem', color: '#9aabba' } }, 'No detail recorded.');
  if (detail.before !== undefined && detail.after !== undefined) {
    const before = detail.before || {};
    const after  = detail.after  || {};
    const keys = Array.from(new Set([...Object.keys(before), ...Object.keys(after)]));
    const changed = keys.filter(function(k) { return JSON.stringify(before[k]) !== JSON.stringify(after[k]); });
    if (changed.length === 0) return React.createElement('div', { style: { fontSize: '.74rem', color: '#9aabba' } }, 'No field-level differences recorded.');
    return React.createElement('div', null,
      React.createElement('div', { style: { display: 'grid', gridTemplateColumns: '110px 1fr 1fr', gap: 6, fontSize: '.66rem', fontWeight: 700, color: '#9aabba', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 8 } },
        React.createElement('span', null, 'Field'),
        React.createElement('span', null, 'Before'),
        React.createElement('span', null, 'After')
      ),
      React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 6 } },
        changed.map(function(k) {
          return React.createElement('div', { key: k, style: { display: 'grid', gridTemplateColumns: '110px 1fr 1fr', gap: 6, alignItems: 'start', fontSize: '.76rem' } },
            React.createElement('div', { style: { fontWeight: 600, color: '#314F5C', paddingTop: 3 } }, k),
            React.createElement('div', { style: { background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, padding: '4px 8px', color: '#c0392b', wordBreak: 'break-all', lineHeight: 1.4 } },
              String(before[k] === null || before[k] === undefined ? '\u2014' : before[k])
            ),
            React.createElement('div', { style: { background: '#f0fdf7', border: '1px solid #6ee7b7', borderRadius: 6, padding: '4px 8px', color: '#1D9E75', wordBreak: 'break-all', lineHeight: 1.4 } },
              String(after[k] === null || after[k] === undefined ? '\u2014' : after[k])
            )
          );
        })
      )
    );
  }
  // flat detail \u2014 filter noisy fields
  var entries = Object.entries(detail).filter(function(pair) { return !['id','created_at'].includes(pair[0]); });
  return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 6 } },
    entries.map(function(pair) {
      var k = pair[0]; var v = pair[1];
      return React.createElement('div', { key: k, style: { display: 'grid', gridTemplateColumns: '120px 1fr', gap: 8, fontSize: '.76rem' } },
        React.createElement('div', { style: { fontWeight: 600, color: '#314F5C', paddingTop: 3 } }, k),
        React.createElement('div', { style: { color: '#4a6070', wordBreak: 'break-all', background: '#f8fafc', borderRadius: 6, padding: '3px 8px', lineHeight: 1.5 } },
          v === null || v === undefined
            ? React.createElement('span', { style: { color: '#b0c4ce' } }, '\u2014')
            : typeof v === 'object'
              ? React.createElement('pre', { style: { margin: 0, fontFamily: 'monospace', fontSize: '.68rem', whiteSpace: 'pre-wrap' } }, JSON.stringify(v, null, 2))
              : String(v)
        )
      );
    })
  );
}

function ActivityPanel() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const { session: apSession } = useAuth();
  const authorEmail = apSession?.user?.email || null;
  const authorName  = authorEmail ? authorEmail.split('@')[0].split(/[._-]/).map(function(s){ return s.charAt(0).toUpperCase()+s.slice(1); }).join(' ') : 'Admin';
  const [events,       setEvents]       = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [error,        setError]        = useState(null);
  const [expanded,     setExpanded]     = useState(null);
  const [filterAction, setFilterAction] = useState('all');
  const [confirmDel,   setConfirmDel]   = useState(null);
  const [deleting,     setDeleting]     = useState(null);
  const [clearing,     setClearing]     = useState(false);
  const [confirmClear, setConfirmClear] = useState(false);

  useEffect(function() { loadEvents(); }, []);

  async function loadEvents() {
    setLoading(true); setError(null);
    try {
      var result = await supabase.from('app_activity').select('*').order('created_at', { ascending: false });
      if (result.error) throw result.error;
      setEvents(result.data || []);
    } catch (e) { setError(e.message || 'Failed to load activity'); }
    finally { setLoading(false); }
  }

  async function deleteEvent(id) {
    setDeleting(id);
    try {
      var result = await supabase.from('app_activity').delete().eq('id', id);
      if (result.error) throw result.error;
      setEvents(function(ev) { return ev.filter(function(e) { return e.id !== id; }); });
    } catch (_e) {}
    finally { setDeleting(null); setConfirmDel(null); }
  }

  async function clearAll() {
    setClearing(true);
    try {
      await supabase.from('app_activity').delete().neq('id', '00000000-0000-0000-0000-000000000000');
      await logActivity({ action: 'system', entity: 'activity', summary: 'Activity log cleared by ' + authorName, author_email: authorEmail, author_name: authorName });
      setEvents([]);
    } catch (_e) {}
    finally { setClearing(false); setConfirmClear(false); }
  }

  var actionTypes = ['all'].concat(Array.from(new Set(events.map(function(e) { return e.action; }))));
  var filtered = filterAction === 'all' ? events : events.filter(function(e) { return e.action === filterAction; });
  var tableErr = error && (error.includes('does not exist') || error.includes('relation'));

  return React.createElement('div', null,
    /* Header */
    React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16, flexWrap: 'wrap', gap: 10 } },
      React.createElement('div', null,
        React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Activity Log'),
        React.createElement('div', { style: { fontSize: '.74rem', color: '#9aabba', marginTop: 2 } },
          filtered.length + ' event' + (filtered.length !== 1 ? 's' : '') + ' \u2014 all platform changes recorded automatically'
        )
      ),
      React.createElement('div', { style: { display: 'flex', gap: 8 } },
        React.createElement(Btn, { small: true, variant: 'ghost', onClick: loadEvents }, React.createElement('span', { style: { display: 'inline-flex', alignItems: 'center', gap: 4 } }, IC.reload, 'Refresh')),
        events.length > 0 && React.createElement(Btn, { small: true, variant: 'danger', onClick: function() { setConfirmClear(true); } }, 'Clear All')
      )
    ),

    /* Filter chips */
    events.length > 1 && React.createElement('div', { style: { display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' } },
      actionTypes.map(function(a) {
        var meta = ACTION_META[a] || { label: a, color: '#9aabba' };
        var active = filterAction === a;
        return React.createElement('button', {
          key: a,
          onClick: function() { setFilterAction(a); },
          style: { padding: '4px 12px', borderRadius: 99, border: '1.5px solid ' + (active ? meta.color : '#dde4ea'), background: active ? meta.color + '18' : '#fff', color: active ? meta.color : '#9aabba', fontSize: '.72rem', fontWeight: active ? 700 : 400, cursor: 'pointer', fontFamily: F, transition: 'all .1s' },
        }, a === 'all' ? 'All events' : meta.label);
      })
    ),

    loading && React.createElement('div', { style: { ...CARD, textAlign: 'center', color: '#9aabba', padding: 48 } }, 'Loading activity\u2026'),

    !loading && error && !tableErr && React.createElement('div', { style: { ...CARD, color: '#c0392b', fontSize: '.82rem' } }, error),

    !loading && tableErr && React.createElement('div', { style: { ...CARD, color: '#7a5c00', background: '#fffbeb', border: '1px solid #fde68a', fontSize: '.82rem', lineHeight: 1.7 } },
      'The ', React.createElement('code', null, 'app_activity'), ' table doesn\u2019t exist yet. Please run this SQL in Supabase:',
      React.createElement('pre', { style: { marginTop: 12, fontFamily: 'monospace', fontSize: '.7rem', color: '#314F5C', background: '#edf4f7', borderRadius: 8, padding: '12px 14px', overflowX: 'auto', lineHeight: 1.8, margin: '10px 0 0' } },
        'CREATE TABLE IF NOT EXISTS app_activity (\n  id           uuid PRIMARY KEY DEFAULT gen_random_uuid(),\n  action       text NOT NULL,\n  entity       text NOT NULL,\n  summary      text NOT NULL,\n  detail       jsonb,\n  author_email text,\n  author_name  text,\n  created_at   timestamptz NOT NULL DEFAULT now()\n);\n\nALTER TABLE app_activity ENABLE ROW LEVEL SECURITY;\nCREATE POLICY "allow_all_app_activity"\n  ON app_activity FOR ALL\n  USING (true) WITH CHECK (true);'
      )
    ),

    !loading && !error && filtered.length === 0 &&
      React.createElement('div', { style: CARD(t) },
        React.createElement(Empty, { icon: IC.clipboard, title: 'No activity yet', sub: 'Every change to builds and testers will be recorded here automatically.' })
      ),

    !loading && !error && filtered.length > 0 &&
      React.createElement('div', { style: { position: 'relative' } },
        /* Timeline spine */
        React.createElement('div', { style: { position: 'absolute', left: 19, top: 20, bottom: 20, width: 2, background: '#edf2f6', zIndex: 0 } }),

        React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 8 } },
          filtered.map(function(ev, idx) {
            var meta = ACTION_META[ev.action] || { label: ev.action, color: '#9aabba' };
            var isExp = expanded === ev.id;
            var hasDetail = ev.detail && Object.keys(ev.detail).length > 0;
            return React.createElement('div', { key: ev.id, style: { display: 'flex', gap: 14, position: 'relative', zIndex: 1 } },
              /* Dot */
              React.createElement('div', { style: { width: 40, flexShrink: 0, display: 'flex', justifyContent: 'center', paddingTop: 14 } },
                React.createElement('div', { style: { width: 22, height: 22, borderRadius: '50%', background: t.panel, border: '2px solid ' + meta.color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, zIndex: 2, position: 'relative' } },
                  React.createElement('div', { style: { width: 8, height: 8, borderRadius: '50%', background: meta.color } })
                )
              ),
              /* Card */
              React.createElement('div', { style: { flex: 1, minWidth: 0, paddingBottom: 4 } },
                React.createElement('div', { style: { ...CARD, padding: '12px 16px' } },
                  /* Summary row */
                  React.createElement('div', { style: { display: 'flex', alignItems: 'flex-start', gap: 10 } },
                    React.createElement('div', { style: { flex: 1, minWidth: 0 } },
                      /* Meta row */
                      React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 } },
                        React.createElement(Pill, { color: meta.color }, meta.label),
                        ev.author_name && React.createElement('span', { style: { fontSize: '.74rem', fontWeight: 600, color: '#314F5C' } }, ev.author_name),
                        ev.author_email && React.createElement('span', { style: { fontSize: '.68rem', color: '#9aabba' } }, ev.author_email === ev.author_name ? '' : '(' + ev.author_email + ')')
                      ),
                      /* Summary text */
                      React.createElement('div', { style: { fontSize: '.84rem', color: '#0f1e28', fontWeight: 500, lineHeight: 1.4, marginBottom: 3 } }, ev.summary),
                      /* Timestamp */
                      React.createElement('div', { style: { fontSize: '.68rem', color: '#b0c4ce' } },
                        timeAgo(ev.created_at) + '  \u00B7  ' + new Date(ev.created_at).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
                      )
                    ),
                    /* Buttons */
                    React.createElement('div', { style: { display: 'flex', gap: 5, alignItems: 'center', flexShrink: 0 } },
                      hasDetail && React.createElement('button', {
                        onClick: function() { setExpanded(isExp ? null : ev.id); },
                        style: { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', borderRadius: 6, border: '1px solid ' + (isExp ? '#314F5C' : '#dde4ea'), background: isExp ? '#314F5C18' : '#f8fafc', color: isExp ? '#314F5C' : '#9aabba', fontSize: '.7rem', fontWeight: 600, cursor: 'pointer', fontFamily: F },
                      },
                        React.createElement('svg', { width: 10, height: 10, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.5, strokeLinecap: 'round' },
                          React.createElement('polyline', { points: isExp ? '18 15 12 9 6 15' : '6 9 12 15 18 9' })
                        ),
                        isExp ? 'Hide' : 'Details'
                      ),
                      React.createElement('button', {
                        onClick: function() { setConfirmDel(ev.id); },
                        disabled: deleting === ev.id,
                        style: { width: 26, height: 26, borderRadius: 6, border: '1px solid #fca5a5', background: '#fef2f2', cursor: deleting === ev.id ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#c0392b', opacity: deleting === ev.id ? 0.5 : 1 },
                      },
                        React.createElement('svg', { width: 11, height: 11, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' },
                          React.createElement('polyline', { points: '3 6 5 6 21 6' }), React.createElement('path', { d: 'M19 6l-1 14H6L5 6' }), React.createElement('path', { d: 'M10 11v6M14 11v6M9 6V4h6v2' })
                        )
                      )
                    )
                  ),
                  /* Expanded detail */
                  isExp && hasDetail && React.createElement('div', { style: { marginTop: 14, paddingTop: 14, borderTop: '1px solid #edf2f6' } },
                    React.createElement('div', { style: { fontSize: '.72rem', fontWeight: 700, color: '#314F5C', marginBottom: 12, textTransform: 'uppercase', letterSpacing: '.06em' } }, 'Full Details'),
                    React.createElement(DetailDiff, { detail: ev.detail })
                  )
                )
              )
            );
          })
        )
      ),

    /* Delete single */
    React.createElement(Modal, { open: !!confirmDel, onClose: function() { setConfirmDel(null); }, title: 'Delete Entry' },
      React.createElement('p', { style: { fontSize: '.84rem', color: '#4a6070', marginBottom: 20 } }, 'Remove this entry from the activity log? This cannot be undone.'),
      React.createElement('div', { style: { display: 'flex', gap: 8, justifyContent: 'flex-end' } },
        React.createElement(Btn, { variant: 'ghost', onClick: function() { setConfirmDel(null); } }, 'Cancel'),
        React.createElement(Btn, { variant: 'danger', onClick: function() { deleteEvent(confirmDel); } }, 'Delete')
      )
    ),

    /* Clear all */
    React.createElement(Modal, { open: confirmClear, onClose: function() { setConfirmClear(false); }, title: 'Clear All Activity' },
      React.createElement('p', { style: { fontSize: '.84rem', color: '#4a6070', marginBottom: 20 } }, 'This will permanently delete all ' + events.length + ' activity entries. This cannot be undone.'),
      React.createElement('div', { style: { display: 'flex', gap: 8, justifyContent: 'flex-end' } },
        React.createElement(Btn, { variant: 'ghost', onClick: function() { setConfirmClear(false); } }, 'Cancel'),
        React.createElement(Btn, { variant: 'danger', onClick: clearAll, disabled: clearing }, clearing ? 'Clearing\u2026' : 'Clear All')
      )
    )
  );
}


// ROOT
// ═══════════════════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════════════
// CONFIG PANEL \u2014 Remote config, feature flags, per-platform overrides
// Role-based: admin = publish live, others = propose draft → admin reviews
// ═══════════════════════════════════════════════════════════════════════════════

// ─── Config schema \u2014 defines every configurable value ─────────────────────────
// type: 'toggle' | 'text' | 'select' | 'number'
// scope: 'all' | ['web','android','ios'] \u2014 which platforms this applies to
// requiresBuild: true = cannot be changed without a new app build
const CONFIG_SCHEMA = [
  // ── App Modes ────────────────────────────────────────────────────────────────
  {
    section: 'App Modes',
    items: [
      { key: 'care_mode_enabled',     label: 'Care Mode',          type: 'toggle', scope: 'all',               default: true,    description: 'Enable the Care (medical) mode across all platforms' },
      { key: 'wellness_mode_enabled', label: 'Wellness Mode',      type: 'toggle', scope: 'all',               default: true,    description: 'Enable the Wellness mode across all platforms' },
      { key: 'default_mode',          label: 'Default Mode',       type: 'select', scope: 'all',               default: 'care',  description: 'Which mode users land on by default', options: ['care','wellness'] },
      { key: 'telehealth_filter',     label: 'Telehealth Filter',  type: 'toggle', scope: 'all',               default: true,    description: 'Show the Telehealth filter checkbox in search' },
      { key: 'emergency_filter',      label: '24/7 Emergency Filter', type: 'toggle', scope: 'all',            default: true,    description: 'Show the 24/7 Emergency filter checkbox in search' },
    ],
  },
  // ── Platform Availability ────────────────────────────────────────────────────
  {
    section: 'Platform Availability',
    items: [
      { key: 'web_live',              label: 'Web App Live',        type: 'toggle', scope: ['web'],             default: true,    description: 'Take web app offline for maintenance' },
      { key: 'android_live',          label: 'Android App Live',    type: 'toggle', scope: ['android'],         default: true,    description: 'Take Android app offline for maintenance' },
      { key: 'ios_live',              label: 'iOS App Live',        type: 'toggle', scope: ['ios'],             default: false,   description: 'Take iOS app offline for maintenance' },
      { key: 'maintenance_message',   label: 'Maintenance Message', type: 'text',   scope: 'all',              default: 'Sanoire is undergoing maintenance. We\'ll be back shortly.', description: 'Message shown when a platform is taken offline' },
    ],
  },
  // ── Version Control ──────────────────────────────────────────────────────────
  {
    section: 'Version Control',
    items: [
      { key: 'min_android_version',   label: 'Min Android Version', type: 'text',   scope: ['android'],        default: '1.0.0', description: 'Minimum Android build version \u2014 older builds will be prompted to update' },
      { key: 'min_ios_version',       label: 'Min iOS Version',     type: 'text',   scope: ['ios'],            default: '1.0.0', description: 'Minimum iOS build version \u2014 older builds will be prompted to update' },
      { key: 'force_update_message',  label: 'Force Update Message',type: 'text',   scope: ['android','ios'],  default: 'A new version of Sanoire is required. Please update in the app store.', description: 'Message shown when forcing an update' },
      { key: 'beta_access_code',      label: 'Beta Access Code',    type: 'text',   scope: 'all',              default: '2314',  description: 'Code required during beta to access the app' },
    ],
  },
  // ── Search & Discovery ───────────────────────────────────────────────────────
  {
    section: 'Search & Discovery',
    items: [
      { key: 'search_results_limit',  label: 'Search Results Limit',type: 'number', scope: 'all',              default: 20,      description: 'Max number of locations returned per search query' },
      { key: 'near_me_enabled',       label: 'Near Me Button',      type: 'toggle', scope: 'all',              default: true,    description: 'Show the Near Me GPS button on the map' },
      { key: 'map_default_zoom',      label: 'Map Default Zoom',    type: 'number', scope: 'all',              default: 12,      description: 'Default zoom level when the map loads (1-20)' },
      { key: 'gps_cache_minutes',     label: 'GPS Cache (minutes)', type: 'number', scope: 'all',              default: 30,      description: 'How long GPS coordinates are cached before a fresh fetch' },
    ],
  },
  // ── Sana AI ──────────────────────────────────────────────────────────────────
  {
    section: 'Sana AI',
    items: [
      { key: 'sana_enabled',          label: 'Sana Chat',           type: 'toggle', scope: 'all',              default: true,    description: 'Enable the Sana AI assistant globally' },
      { key: 'sana_max_results',      label: 'Sana Max Results',    type: 'number', scope: 'all',              default: 5,       description: 'Max locations Sana returns per response' },
      { key: 'sana_greeting',         label: 'Sana Greeting',       type: 'text',   scope: 'all',              default: 'Hi! I\'m Sana, your Sanoire health assistant. Where would you like to find care?', description: 'Opening message shown in the Sana chat panel' },
      { key: 'sana_web_only',         label: 'Sana Web Only',       type: 'toggle', scope: ['android','ios'],  default: false,   description: 'Restrict Sana to web only \u2014 hide on native apps' },
    ],
  },
  // ── UI & Onboarding ──────────────────────────────────────────────────────────
  {
    section: 'UI & Onboarding',
    items: [
      { key: 'show_onboarding',       label: 'Show Onboarding',     type: 'toggle', scope: 'all',              default: true,    description: 'Show the onboarding flow for new users' },
      { key: 'onboarding_headline',   label: 'Onboarding Headline', type: 'text',   scope: 'all',              default: 'Travel with confidence.',  description: 'Main headline on the onboarding screen' },
      { key: 'shop_enabled',          label: 'Shop / Merchandise',  type: 'toggle', scope: ['web'],            default: false,   description: 'Show the Shop collection (currently on hold)' },
      { key: 'community_enabled',     label: 'Community Chat',      type: 'toggle', scope: 'all',              default: false,   description: 'Enable the Community / Lounge feature' },
      { key: 'dark_mode_enabled',     label: 'Dark Mode',           type: 'toggle', scope: 'all',              default: false,   description: 'Enable dark mode option for users' },
    ],
  },
  // ── Requires New Build (read-only advisory) ───────────────────────────────────
  {
    section: 'Requires New Build',
    requiresBuild: true,
    items: [
      { key: '_nav_structure',        label: 'Navigation Structure', type: 'text',  scope: 'all',              default: '',      description: 'Changes to app navigation require a new build via the Builds tab', requiresBuild: true },
      { key: '_screen_layout',        label: 'Screen Layouts',       type: 'text',  scope: 'all',              default: '',      description: 'Visual layout changes require a new build', requiresBuild: true },
      { key: '_permissions',          label: 'App Permissions',      type: 'text',  scope: ['android','ios'],  default: '',      description: 'Permission changes (camera, location, push) require a new build', requiresBuild: true },
    ],
  },
];

const PLATFORM_LABELS = { web: 'Web', android: 'Android', ios: 'iOS' };
const PLATFORM_COLORS = { web: '#314F5C', android: '#3dba78', ios: '#0071e3' };

function scopeCovers(scope, platform) {
  if (scope === 'all') return true;
  return Array.isArray(scope) && scope.includes(platform);
}


// ─── BugsPanel ──────────────────────────────────────────────────────────────
var BUG_PRIORITIES = [
  { id: 'critical', label: 'Critical', color: '#c0392b' },
  { id: 'high',     label: 'High',     color: '#e08c2e' },
  { id: 'medium',   label: 'Medium',   color: '#6F8FA7' },
  { id: 'low',      label: 'Low',      color: '#1D9E75' },
];
var BUG_STATUSES = [
  { id: 'open',        label: 'Open',        color: '#c0392b' },
  { id: 'in_progress', label: 'In Progress', color: '#e08c2e' },
  { id: 'resolved',    label: 'Resolved',    color: '#1D9E75' },
  { id: 'wont_fix',    label: "Won't Fix",   color: '#9aabba' },
];
var BUG_PLATFORMS = ['Web', 'Android', 'iOS', 'All Platforms'];

function BugsPanel() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const { session: bugSess } = useAuth();
  const authorEmail = bugSess?.user?.email || null;
  const authorName  = authorEmail ? authorEmail.split('@')[0].split(/[._-]/).map(function(s){ return s.charAt(0).toUpperCase()+s.slice(1); }).join(' ') : 'Admin';

  var [bugs,           setBugs]           = useState([]);
  var [loading,        setLoading]        = useState(true);
  var [showAdd,        setShowAdd]        = useState(false);
  var [filterStatus,   setFilterStatus]   = useState('all');
  var [filterPlatform, setFilterPlatform] = useState('all');
  var [filterPriority, setFilterPriority] = useState('all');
  var [selected,       setSelected]       = useState(null);
  var [form, setForm] = useState({ title: '', description: '', platform: 'Android', priority: 'high', steps: '', expected: '', actual: '', version: '' });

  useEffect(function() { loadBugs(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function loadBugs() {
    setLoading(true);
    try {
      var { data } = await supabase.from('app_bugs').select('*').order('created_at', { ascending: false });
      setBugs(data || []);
    } catch (_e) { setBugs([]); }
    finally { setLoading(false); }
  }

  async function submitBug() {
    if (!form.title.trim()) return;
    try {
      await supabase.from('app_bugs').insert([{
        title: form.title.trim(), description: form.description.trim(),
        platform: form.platform, priority: form.priority,
        steps: form.steps.trim(), expected: form.expected.trim(),
        actual: form.actual.trim(), version: form.version.trim(),
        status: 'open', reported_by: authorEmail, reporter_name: authorName,
      }]);
      await logActivity({ action: 'bug_filed', entity: 'bugs', summary: 'Bug: ' + form.title.trim(), detail: { platform: form.platform, priority: form.priority }, author_email: authorEmail, author_name: authorName });
      setForm({ title: '', description: '', platform: 'Android', priority: 'high', steps: '', expected: '', actual: '', version: '' });
      setShowAdd(false);
      await loadBugs();
    } catch (_e) {}
  }

  async function updateStatus(bug, newStatus) {
    await supabase.from('app_bugs').update({ status: newStatus }).eq('id', bug.id);
    setBugs(function(b) { return b.map(function(x) { return x.id === bug.id ? Object.assign({}, x, { status: newStatus }) : x; }); });
    if (selected && selected.id === bug.id) setSelected(Object.assign({}, selected, { status: newStatus }));
  }

  async function deleteBug(bug) {
    if (!window.confirm('Delete this bug report?')) return;
    await supabase.from('app_bugs').delete().eq('id', bug.id);
    setBugs(function(b) { return b.filter(function(x) { return x.id !== bug.id; }); });
    if (selected && selected.id === bug.id) setSelected(null);
  }

  var filtered = bugs.filter(function(b) {
    if (filterStatus !== 'all' && b.status !== filterStatus) return false;
    if (filterPlatform !== 'all' && b.platform !== filterPlatform) return false;
    if (filterPriority !== 'all' && b.priority !== filterPriority) return false;
    return true;
  });

  var openCount     = bugs.filter(function(b) { return b.status === 'open'; }).length;
  var inProgCount   = bugs.filter(function(b) { return b.status === 'in_progress'; }).length;
  var resolvedCount = bugs.filter(function(b) { return b.status === 'resolved'; }).length;
  var critCount     = bugs.filter(function(b) { return b.priority === 'critical' && b.status === 'open'; }).length;

  return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 16 } },

    React.createElement('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12 } },
      [
        { label: 'Open', val: openCount, color: '#c0392b' },
        { label: 'In Progress', val: inProgCount, color: '#e08c2e' },
        { label: 'Resolved', val: resolvedCount, color: '#1D9E75' },
        { label: 'Critical', val: critCount, color: '#c0392b' },
      ].map(function(s) {
        return React.createElement('div', { key: s.label, style: Object.assign({}, CARD(t), { textAlign: 'center', padding: '14px 10px' }) },
          React.createElement('div', { style: { fontSize: '1.6rem', fontWeight: 700, color: s.color, lineHeight: 1 } }, s.val),
          React.createElement('div', { style: { fontSize: '.72rem', color: '#9aabba', marginTop: 4 } }, s.label)
        );
      })
    ),

    React.createElement('div', { style: Object.assign({}, CARD(t), { display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }) },
      React.createElement('div', { style: { display: 'flex', background: '#f0f4f6', borderRadius: 8, padding: 2, gap: 1 } },
        [{ id: 'all', label: 'All' }].concat(BUG_STATUSES).map(function(s) {
          return React.createElement('button', {
            key: s.id, onClick: function() { setFilterStatus(s.id); },
            style: { padding: '4px 10px', borderRadius: 6, border: 'none', fontFamily: F, fontSize: '.72rem', cursor: 'pointer', background: filterStatus === s.id ? '#fff' : 'transparent', color: filterStatus === s.id ? '#0f1e28' : '#7a9aaa', fontWeight: filterStatus === s.id ? 600 : 400, boxShadow: filterStatus === s.id ? '0 1px 3px rgba(0,0,0,0.1)' : 'none', whiteSpace: 'nowrap' }
          }, s.label);
        })
      ),
      React.createElement('select', { value: filterPlatform, onChange: function(e) { setFilterPlatform(e.target.value); }, style: { padding: '5px 8px', borderRadius: 7, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.76rem', outline: 'none' } },
        [React.createElement('option', { key: 'all', value: 'all' }, 'All Platforms')].concat(BUG_PLATFORMS.map(function(p) { return React.createElement('option', { key: p, value: p }, p); }))
      ),
      React.createElement('select', { value: filterPriority, onChange: function(e) { setFilterPriority(e.target.value); }, style: { padding: '5px 8px', borderRadius: 7, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.76rem', outline: 'none' } },
        [React.createElement('option', { key: 'all', value: 'all' }, 'All Priorities')].concat(BUG_PRIORITIES.map(function(p) { return React.createElement('option', { key: p.id, value: p.id }, p.label); }))
      ),
      React.createElement('div', { style: { flex: 1 } }),
      React.createElement(Btn, { onClick: function() { setShowAdd(!showAdd); } }, showAdd ? 'Cancel' : '+ File Bug')
    ),

    showAdd && React.createElement('div', { style: Object.assign({}, CARD(t)) },
      React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28', marginBottom: 14 } }, 'File a Bug'),
      React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 10 } },
        React.createElement('input', { value: form.title, placeholder: 'Bug title *', onChange: function(e) { setForm(function(f) { return Object.assign({}, f, { title: e.target.value }); }); }, style: { padding: '8px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.82rem', outline: 'none' } }),
        React.createElement('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 } },
          React.createElement('select', { value: form.platform, onChange: function(e) { setForm(function(f) { return Object.assign({}, f, { platform: e.target.value }); }); }, style: { padding: '7px 10px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', outline: 'none' } },
            BUG_PLATFORMS.map(function(p) { return React.createElement('option', { key: p, value: p }, p); })
          ),
          React.createElement('select', { value: form.priority, onChange: function(e) { setForm(function(f) { return Object.assign({}, f, { priority: e.target.value }); }); }, style: { padding: '7px 10px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', outline: 'none' } },
            BUG_PRIORITIES.map(function(p) { return React.createElement('option', { key: p.id, value: p.id }, p.label); })
          ),
          React.createElement('input', { value: form.version, placeholder: 'App version', onChange: function(e) { setForm(function(f) { return Object.assign({}, f, { version: e.target.value }); }); }, style: { padding: '7px 10px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', outline: 'none' } })
        ),
        React.createElement('textarea', { value: form.description, placeholder: 'Describe the bug...', rows: 2, onChange: function(e) { setForm(function(f) { return Object.assign({}, f, { description: e.target.value }); }); }, style: { padding: '8px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', resize: 'vertical', outline: 'none' } }),
        React.createElement('div', { style: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 } },
          React.createElement('textarea', { value: form.steps, placeholder: 'Steps to reproduce...', rows: 3, onChange: function(e) { setForm(function(f) { return Object.assign({}, f, { steps: e.target.value }); }); }, style: { padding: '8px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.74rem', resize: 'vertical', outline: 'none' } }),
          React.createElement('textarea', { value: form.expected, placeholder: 'Expected result...', rows: 3, onChange: function(e) { setForm(function(f) { return Object.assign({}, f, { expected: e.target.value }); }); }, style: { padding: '8px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.74rem', resize: 'vertical', outline: 'none' } }),
          React.createElement('textarea', { value: form.actual, placeholder: 'Actual result...', rows: 3, onChange: function(e) { setForm(function(f) { return Object.assign({}, f, { actual: e.target.value }); }); }, style: { padding: '8px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.74rem', resize: 'vertical', outline: 'none' } })
        ),
        React.createElement('div', { style: { display: 'flex', justifyContent: 'flex-end' } },
          React.createElement(Btn, { onClick: submitBug }, 'Submit Bug')
        )
      )
    ),

    React.createElement('div', { style: { display: 'flex', gap: 16, alignItems: 'flex-start' } },
      React.createElement('div', { style: Object.assign({}, CARD(t), { flex: 1, padding: 0, overflow: 'hidden', minWidth: 0 }) },
        loading
          ? React.createElement('div', { style: { padding: 32, textAlign: 'center', color: '#9aabba' } }, 'Loading...')
          : filtered.length === 0
            ? React.createElement('div', { style: { padding: 32 } }, React.createElement(Empty, { icon: '\uD83D\uDC1E', title: 'No bugs found', sub: bugs.length === 0 ? 'File one above if you spot something.' : 'No bugs match these filters.' }))
            : filtered.map(function(bug, idx) {
                var pr = BUG_PRIORITIES.find(function(p) { return p.id === bug.priority; }) || BUG_PRIORITIES[2];
                var st = BUG_STATUSES.find(function(s) { return s.id === bug.status; }) || BUG_STATUSES[0];
                var isSel = selected && selected.id === bug.id;
                return React.createElement('div', {
                  key: bug.id, onClick: function() { setSelected(isSel ? null : bug); },
                  style: { display: 'flex', alignItems: 'flex-start', gap: 12, padding: '12px 18px', borderBottom: idx < filtered.length - 1 ? '1px solid #f0f2f4' : 'none', cursor: 'pointer', background: isSel ? '#f0f7ff' : 'transparent' }
                },
                  React.createElement('div', { style: { width: 8, height: 8, borderRadius: '50%', background: pr.color, flexShrink: 0, marginTop: 5 } }),
                  React.createElement('div', { style: { flex: 1, minWidth: 0 } },
                    React.createElement('div', { style: { fontSize: '.82rem', fontWeight: 600, color: '#0f1e28', marginBottom: 3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, bug.title),
                    React.createElement('div', { style: { display: 'flex', gap: 6, flexWrap: 'wrap' } },
                      React.createElement(Pill, { color: pr.color }, pr.label),
                      React.createElement(Pill, { color: '#6F8FA7' }, bug.platform),
                      bug.version && React.createElement(Pill, { color: '#9aabba' }, 'v' + bug.version)
                    )
                  ),
                  React.createElement('div', { style: { flexShrink: 0, fontSize: '.7rem', fontWeight: 700, color: st.color, background: st.color + '15', padding: '2px 8px', borderRadius: 99 } }, st.label)
                );
              })
      ),

      selected && React.createElement('div', { style: Object.assign({}, CARD(t), { width: 300, flexShrink: 0 }) },
        React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28', marginBottom: 12 } }, selected.title),
        React.createElement('div', { style: { marginBottom: 14 } },
          React.createElement('div', { style: { fontSize: '.7rem', color: '#9aabba', marginBottom: 6 } }, 'STATUS'),
          React.createElement('div', { style: { display: 'flex', gap: 4, flexWrap: 'wrap' } },
            BUG_STATUSES.map(function(s) {
              var active = selected.status === s.id;
              return React.createElement('button', {
                key: s.id, onClick: function() { updateStatus(selected, s.id); },
                style: { padding: '3px 10px', borderRadius: 99, border: '1.5px solid ' + (active ? s.color : '#dde4ea'), background: active ? s.color + '18' : '#fff', color: active ? s.color : '#9aabba', fontSize: '.7rem', fontWeight: active ? 700 : 400, cursor: 'pointer', fontFamily: F }
              }, s.label);
            })
          )
        ),
        [
          { label: 'Platform', val: selected.platform },
          { label: 'Priority', val: (BUG_PRIORITIES.find(function(p) { return p.id === selected.priority; }) || {}).label },
          { label: 'Version', val: selected.version || '-' },
          { label: 'Reporter', val: selected.reporter_name || selected.reported_by || '-' },
          { label: 'Filed', val: new Date(selected.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) },
        ].map(function(r) {
          return React.createElement('div', { key: r.label, style: { display: 'flex', justifyContent: 'space-between', fontSize: '.76rem', marginBottom: 6 } },
            React.createElement('span', { style: { color: '#9aabba' } }, r.label),
            React.createElement('span', { style: { color: '#0f1e28', fontWeight: 500 } }, r.val)
          );
        }),
        selected.description && React.createElement('div', { style: { marginTop: 10, fontSize: '.76rem', color: '#4a6070', lineHeight: 1.6, background: '#f8fafc', borderRadius: 8, padding: '10px 12px' } }, selected.description),
        selected.steps && React.createElement('div', { style: { marginTop: 10 } },
          React.createElement('div', { style: { fontSize: '.7rem', fontWeight: 700, color: '#314F5C', marginBottom: 4 } }, 'Steps'),
          React.createElement('div', { style: { fontSize: '.74rem', color: '#4a6070', lineHeight: 1.6, whiteSpace: 'pre-wrap' } }, selected.steps)
        ),
        React.createElement('div', { style: { marginTop: 14, display: 'flex', justifyContent: 'flex-end' } },
          React.createElement('button', { onClick: function() { deleteBug(selected); }, style: { padding: '5px 12px', borderRadius: 7, border: '1px solid #fca5a5', background: '#fef2f2', color: '#c0392b', fontSize: '.74rem', fontWeight: 600, cursor: 'pointer', fontFamily: F } }, 'Delete')
        )
      )
    )
  );
}

// ─── ConfigPanel ─────────────────────────────────────────────────────────────
function ConfigPanel() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const { session: cfgSess }  = useAuth();
  const userEmail             = cfgSess?.user?.email || null;
  const userRole              = userEmail ? (function() {
    // inline getUserRole logic
    if (!userEmail) return 'support';
    try {
      var map = JSON.parse(localStorage.getItem('sanoire_team_roles') || '{}');
      if (map[userEmail]) return map[userEmail];
    } catch (_e) {}
    if (userEmail.endsWith('@sanoire.com') || userEmail.endsWith('@blynkstudio.com')) return 'admin';
    return 'support';
  })() : 'support';
  const isAdmin               = userRole === 'admin' || userRole === 'c_suite';
  const authorName            = userEmail ? userEmail.split('@')[0].split(/[._-]/).map(function(s){ return s.charAt(0).toUpperCase()+s.slice(1); }).join(' ') : 'Admin';

  const [values,      setValues]      = useState({});   // current live config
  const [drafts,      setDrafts]      = useState([]);   // pending proposals
  const [loading,     setLoading]     = useState(true);
  const [saving,      setSaving]      = useState(false);
  const [pendingEdits,setPendingEdits]= useState({});   // unsaved local edits
  const [filterPlat,  setFilterPlat]  = useState('all');
  const [activeSection, setActiveSection] = useState(null);
  const [proposeNote, setProposeNote] = useState('');
  const [proposing,   setProposing]   = useState(false);
  const [proposeKey,  setProposeKey]  = useState(null);
  const [proposeVal,  setProposeVal]  = useState(null);
  const [draftTab,    setDraftTab]    = useState('config'); // 'config' | 'drafts'
  const [toast,       setToast]       = useState(null);
  useEffect(function() { loadConfig(); loadDrafts(); }, []);

  function showToast(msg, type) {
    setToast({ msg, type: type || 'success' });
    setTimeout(function() { setToast(null); }, 3000);
  }

  async function loadConfig() {
    setLoading(true);
    try {
      const { data } = await supabase.from('app_config').select('key,value,platform,updated_at,updated_by');
      const map = {};
      (data || []).forEach(function(row) {
        var pk = row.platform ? row.platform + '::' + row.key : row.key;
        map[pk] = { value: row.value, updated_at: row.updated_at, updated_by: row.updated_by };
      });
      setValues(map);
    } catch (_e) {}
    finally { setLoading(false); }
  }

  async function loadDrafts() {
    try {
      const { data } = await supabase.from('app_config_drafts').select('*').order('created_at', { ascending: false });
      setDrafts(data || []);
    } catch (_e) {}
  }

  // Get effective value: local edit > live DB value > schema default
  function getValue(key, platform) {
    var editKey = platform ? platform + '::' + key : key;
    if (pendingEdits[editKey] !== undefined) return pendingEdits[editKey];
    var dbKey = platform ? platform + '::' + key : key;
    if (values[dbKey]) {
      var v = values[dbKey].value;
      // Parse stored JSON booleans
      if (v === 'true') return true;
      if (v === 'false') return false;
      if (!isNaN(v) && v !== '') return Number(v);
      return v;
    }
    // Fall through to schema default
    for (var si = 0; si < CONFIG_SCHEMA.length; si++) {
      var section = CONFIG_SCHEMA[si];
      for (var ii = 0; ii < section.items.length; ii++) {
        if (section.items[ii].key === key) return section.items[ii].default;
      }
    }
    return null;
  }

  function setPendingEdit(key, platform, value) {
    var editKey = platform ? platform + '::' + key : key;
    setPendingEdits(function(prev) {
      var next = Object.assign({}, prev);
      next[editKey] = value;
      return next;
    });
  }

  var hasPendingEdits = Object.keys(pendingEdits).length > 0;

  async function publishAll() {
    if (!isAdmin) return;
    setSaving(true);
    try {
      var rows = Object.entries(pendingEdits).map(function(pair) {
        var editKey = pair[0]; var val = pair[1];
        var parts = editKey.split('::');
        var platform = parts.length > 1 ? parts[0] : null;
        var key = parts.length > 1 ? parts[1] : parts[0];
        return { key, platform, value: String(val), updated_by: userEmail, updated_at: new Date().toISOString() };
      });
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        await supabase.from('app_config').upsert(
          { key: row.key, platform: row.platform, value: row.value, updated_by: row.updated_by, updated_at: row.updated_at },
          { onConflict: 'key,platform' }
        );
        await logActivity({
          action: 'config_published',
          entity: 'config',
          summary: 'Config "' + row.key + '" set to "' + row.value + '"' + (row.platform ? ' (' + row.platform + ')' : ' (all platforms)'),
          detail: { key: row.key, platform: row.platform || 'all', value: row.value },
          author_email: userEmail,
          author_name: authorName,
        });
      }
      setPendingEdits({});
      await loadConfig();
      showToast(rows.length + ' change' + (rows.length !== 1 ? 's' : '') + ' published live');
    } catch (e) {
      showToast('Publish failed: ' + (e.message || 'Unknown error'), 'error');
    }
    finally { setSaving(false); }
  }

  async function submitProposal() {
    if (!proposeKey) return;
    setSaving(true);
    try {
      await supabase.from('app_config_drafts').insert([{
        key: proposeKey,
        platform: proposeVal?.platform || null,
        proposed_value: String(proposeVal?.value),
        note: proposeNote.trim() || null,
        proposed_by: userEmail,
        proposed_by_name: authorName,
        status: 'pending',
      }]);
      // Send email notification to admin via Supabase Edge Function (or log it)
      await logActivity({
        action: 'config_proposed',
        entity: 'config',
        summary: authorName + ' proposed changing "' + proposeKey + '" to "' + proposeVal?.value + '"',
        detail: { key: proposeKey, proposed_value: proposeVal?.value, note: proposeNote, proposed_by: userEmail },
        author_email: userEmail,
        author_name: authorName,
      });
      setPendingEdits({});
      setProposing(false);
      await loadDrafts();
      showToast('Proposal submitted \u2014 admin will be notified');
    } catch (e) {
      showToast('Failed to submit: ' + (e.message || 'Unknown error'), 'error');
    }
    finally { setSaving(false); }
  }

  async function approveProposal(draft) {
    setSaving(true);
    try {
      await supabase.from('app_config').upsert(
        { key: draft.key, platform: draft.platform, value: draft.proposed_value, updated_by: userEmail, updated_at: new Date().toISOString() },
        { onConflict: 'key,platform' }
      );
      await supabase.from('app_config_drafts').update({ status: 'approved', reviewed_by: userEmail, reviewed_at: new Date().toISOString() }).eq('id', draft.id);
      await logActivity({
        action: 'config_approved',
        entity: 'config',
        summary: 'Config proposal approved: "' + draft.key + '" → "' + draft.proposed_value + '"',
        detail: draft,
        author_email: userEmail,
        author_name: authorName,
      });
      await loadConfig(); await loadDrafts();
      showToast('Proposal approved and published live');
    } catch (e) { showToast('Approve failed', 'error'); }
    finally { setSaving(false); }
  }

  async function rejectProposal(draft) {
    try {
      await supabase.from('app_config_drafts').update({ status: 'rejected', reviewed_by: userEmail, reviewed_at: new Date().toISOString() }).eq('id', draft.id);
      await loadDrafts();
      showToast('Proposal rejected');
    } catch (_e) {}
  }

  // Filter schema items by platform
  function visibleItems(items) {
    if (filterPlat === 'all') return items;
    return items.filter(function(item) { return scopeCovers(item.scope, filterPlat); });
  }

  var pendingDrafts = drafts.filter(function(d) { return d.status === 'pending'; });

  // ─── Render a single config row ────────────────────────────────────────────
  function ConfigRow({ item }) {
    var scopes = item.scope === 'all' ? ['web','android','ios'] : item.scope;
    var platformsToShow = filterPlat === 'all' ? scopes : scopes.filter(function(p) { return p === filterPlat; });

    // For global (all) items show one control; for platform-specific show per platform
    var isGlobal = item.scope === 'all';
    var requiresBuild = item.requiresBuild;

    return React.createElement('div', {
      style: { ...CARD, padding: '14px 18px', opacity: requiresBuild ? 0.6 : 1 }
    },
      React.createElement('div', { style: { display: 'flex', alignItems: 'flex-start', gap: 14 } },
        React.createElement('div', { style: { flex: 1, minWidth: 0 } },
          React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 3 } },
            React.createElement('span', { style: { fontSize: '.84rem', fontWeight: 600, color: '#0f1e28' } }, item.label),
            requiresBuild && React.createElement('span', { style: { fontSize: '.62rem', fontWeight: 700, background: '#fff3cd', color: '#856404', border: '1px solid #ffc107', borderRadius: 99, padding: '1px 8px' } }, 'Requires Build'),
            // Platform scope badges
            (item.scope === 'all' ? ['web','android','ios'] : item.scope).map(function(p) {
              return React.createElement('span', {
                key: p,
                style: { fontSize: '.6rem', fontWeight: 600, borderRadius: 99, padding: '1px 7px', background: PLATFORM_COLORS[p] + '18', color: PLATFORM_COLORS[p], border: '1px solid ' + PLATFORM_COLORS[p] + '30' }
              }, PLATFORM_LABELS[p]);
            })
          ),
          React.createElement('div', { style: { fontSize: '.74rem', color: '#9aabba', lineHeight: 1.5 } }, item.description)
        ),
        // Controls
        requiresBuild
          ? React.createElement(Btn, { small: true, variant: 'ghost', onClick: function() { window.sanoireNav && window.sanoireNav('appstudio'); } }, 'Go to Builds')
          : React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-end', flexShrink: 0 } },
              isGlobal || filterPlat !== 'all'
                ? // Single control
                  renderControl(item, null)
                : // Per-platform controls
                  platformsToShow.map(function(plat) {
                    return React.createElement('div', { key: plat, style: { display: 'flex', alignItems: 'center', gap: 8 } },
                      React.createElement('span', { style: { fontSize: '.68rem', fontWeight: 600, color: PLATFORM_COLORS[plat], minWidth: 52, textAlign: 'right' } }, PLATFORM_LABELS[plat]),
                      renderControl(item, plat)
                    );
                  })
            )
      )
    );
  }

  function renderControl(item, platform) {
    var val = getValue(item.key, platform);
    var editKey = platform ? platform + '::' + item.key : item.key;
    var isDirty = pendingEdits[editKey] !== undefined;

    if (item.type === 'toggle') {
      return React.createElement('button', {
        onClick: function() {
          var newVal = !val;
          setPendingEdit(item.key, platform, newVal);
        },
        style: {
          width: 44, height: 24, borderRadius: 12, border: 'none', cursor: 'pointer',
          background: val ? '#1D9E75' : '#dde4ea', position: 'relative', transition: 'background .2s',
          flexShrink: 0, outline: isDirty ? '2px solid #e08c2e' : 'none', outlineOffset: 2,
        },
      },
        React.createElement('div', { style: { width: 18, height: 18, borderRadius: '50%', background: t.panel, position: 'absolute', top: 3, left: val ? 23 : 3, transition: 'left .2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' } })
      );
    }

    if (item.type === 'select') {
      return React.createElement('select', {
        value: val || item.default,
        onChange: function(e) { setPendingEdit(item.key, platform, e.target.value); },
        style: { padding: '5px 10px', borderRadius: 7, border: '1.5px solid ' + (isDirty ? '#e08c2e' : '#dde4ea'), fontFamily: F, fontSize: '.78rem', color: '#0f1e28', background: '#fafcfd', outline: 'none', cursor: 'pointer' },
      },
        (item.options || []).map(function(o) { return React.createElement('option', { key: o, value: o }, o.charAt(0).toUpperCase() + o.slice(1)); })
      );
    }

    if (item.type === 'number') {
      return React.createElement('input', {
        type: 'number',
        value: val !== null ? val : item.default,
        onChange: function(e) { setPendingEdit(item.key, platform, Number(e.target.value)); },
        style: { width: 70, padding: '5px 10px', borderRadius: 7, border: '1.5px solid ' + (isDirty ? '#e08c2e' : '#dde4ea'), fontFamily: F, fontSize: '.78rem', color: '#0f1e28', background: '#fafcfd', outline: 'none' },
      });
    }

    if (item.type === 'text') {
      return React.createElement('input', {
        type: 'text',
        value: val !== null ? String(val) : String(item.default),
        onChange: function(e) { setPendingEdit(item.key, platform, e.target.value); },
        style: { width: 220, padding: '5px 10px', borderRadius: 7, border: '1.5px solid ' + (isDirty ? '#e08c2e' : '#dde4ea'), fontFamily: F, fontSize: '.76rem', color: '#0f1e28', background: '#fafcfd', outline: 'none' },
      });
    }

    return null;
  }

  return React.createElement('div', { style: { fontFamily: F, position: 'relative' } },

    // ── Toast ─────────────────────────────────────────────────────────────────
    toast && React.createElement('div', { style: { position: 'fixed', bottom: 24, right: 24, zIndex: 9999, background: toast.type === 'error' ? '#c0392b' : '#1D9E75', color: '#fff', borderRadius: 10, padding: '12px 18px', fontSize: '.82rem', fontWeight: 600, fontFamily: F, boxShadow: '0 8px 24px rgba(0,0,0,0.2)', maxWidth: 340 } }, toast.msg),

    // ── Sub-tabs ──────────────────────────────────────────────────────────────
    React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 10 } },
      React.createElement('div', { style: { display: 'flex', gap: 2, background: '#f0f4f6', borderRadius: 10, padding: 3 } },
        [
          { id: 'config', label: 'Remote Config' },
          { id: 'drafts', label: 'Draft Proposals' + (pendingDrafts.length > 0 ? ' (' + pendingDrafts.length + ')' : '') },
        ].map(function(t) {
          return React.createElement('button', {
            key: t.id, onClick: function() { setDraftTab(t.id); },
            style: { padding: '6px 16px', borderRadius: 8, border: 'none', fontFamily: F, fontSize: '.78rem', cursor: 'pointer', background: draftTab === t.id ? '#fff' : 'transparent', color: draftTab === t.id ? '#0f1e28' : '#7a9aaa', fontWeight: draftTab === t.id ? 600 : 400, boxShadow: draftTab === t.id ? '0 1px 4px rgba(0,0,0,0.1)' : 'none', transition: 'all .12s', whiteSpace: 'nowrap' },
          }, t.label);
        })
      ),

      draftTab === 'config' && React.createElement('div', { style: { display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' } },
        // Platform filter
        React.createElement('div', { style: { display: 'flex', background: '#f0f4f6', borderRadius: 8, padding: 2, gap: 1 } },
          [{ id: 'all', label: 'All' }, { id: 'web', label: 'Web' }, { id: 'android', label: 'Android' }, { id: 'ios', label: 'iOS' }].map(function(p) {
            return React.createElement('button', {
              key: p.id, onClick: function() { setFilterPlat(p.id); },
              style: { padding: '4px 11px', borderRadius: 6, border: 'none', fontFamily: F, fontSize: '.72rem', cursor: 'pointer', background: filterPlat === p.id ? '#fff' : 'transparent', color: filterPlat === p.id ? (PLATFORM_COLORS[p.id] || '#0f1e28') : '#7a9aaa', fontWeight: filterPlat === p.id ? 700 : 400, boxShadow: filterPlat === p.id ? '0 1px 3px rgba(0,0,0,0.1)' : 'none', transition: 'all .1s' },
            }, p.label);
          })
        ),
        // Discard / Publish or Propose
        hasPendingEdits && React.createElement(Btn, {
          small: true, variant: 'ghost',
          onClick: function() { setPendingEdits({}); }
        }, 'Discard Changes (' + Object.keys(pendingEdits).length + ')'),
        hasPendingEdits && React.createElement(Btn, {
          small: true,
          variant: isAdmin ? 'primary' : 'secondary',
          disabled: saving,
          onClick: function() {
            if (isAdmin) {
              publishAll();
            } else {
              // Non-admin: propose all pending edits as drafts
              var keys = Object.keys(pendingEdits);
              setProposeKey(keys.join(', '));
              setProposeVal({ pendingEdits });
              setProposing(true);
            }
          }
        }, saving ? 'Saving\u2026' : isAdmin ? '\u25B6 Publish Live' : '\u2709 Propose Changes')
      )
    ),

    // ─────────────────────────────────────────────────────────────────────────
    // CONFIG TAB
    // ─────────────────────────────────────────────────────────────────────────
    draftTab === 'config' && React.createElement('div', null,
      // Role info banner
      !isAdmin && React.createElement('div', { style: { background: 'rgba(111,143,167,0.08)', border: '1px solid rgba(111,143,167,0.25)', borderRadius: 10, padding: '10px 16px', marginBottom: 16, fontSize: '.78rem', color: '#4a6070', display: 'flex', alignItems: 'center', gap: 10 } },
        React.createElement('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', style: { flexShrink: 0 } },
          React.createElement('circle', { cx: 12, cy: 12, r: 10 }), React.createElement('line', { x1: 12, y1: 8, x2: 12, y2: 12 }), React.createElement('line', { x1: 12, y1: 16, x2: 12.01, y2: 16 })
        ),
        React.createElement('span', null, 'You have ', React.createElement('strong', null, userRole), ' access. Changes you make will be submitted as proposals for admin review, not published live.')
      ),

      loading && React.createElement('div', { style: { ...CARD, textAlign: 'center', color: '#9aabba', padding: 48 } }, 'Loading config\u2026'),

      !loading && CONFIG_SCHEMA.map(function(section) {
        var items = visibleItems(section.items);
        if (items.length === 0) return null;
        var isOpen = activeSection === null || activeSection === section.section;
        return React.createElement('div', { key: section.section, style: { marginBottom: 16 } },
          // Section header
          React.createElement('button', {
            onClick: function() { setActiveSection(isOpen && activeSection === section.section ? null : section.section); },
            style: { display: 'flex', alignItems: 'center', gap: 8, width: '100%', background: 'none', border: 'none', cursor: 'pointer', padding: '8px 4px', marginBottom: isOpen ? 8 : 0, fontFamily: F },
          },
            React.createElement('div', { style: { fontSize: '.72rem', fontWeight: 700, color: '#314F5C', textTransform: 'uppercase', letterSpacing: '.07em', flex: 1, textAlign: 'left' } }, section.section),
            section.requiresBuild && React.createElement('span', { style: { fontSize: '.62rem', background: '#fff3cd', color: '#856404', border: '1px solid #ffc107', borderRadius: 99, padding: '1px 8px', fontWeight: 700 } }, 'Build Required'),
            React.createElement('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: '#9aabba', strokeWidth: 2.5, strokeLinecap: 'round', style: { transition: 'transform .15s', transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)' } },
              React.createElement('polyline', { points: '6 9 12 15 18 9' })
            )
          ),
          isOpen && React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 8 } },
            items.map(function(item) { return React.createElement(ConfigRow, { key: item.key, item: item }); })
          )
        );
      })
    ),

    // ─────────────────────────────────────────────────────────────────────────
    // DRAFTS TAB
    // ─────────────────────────────────────────────────────────────────────────
    draftTab === 'drafts' && React.createElement('div', null,
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 } },
        React.createElement('div', null,
          React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Draft Proposals'),
          React.createElement('div', { style: { fontSize: '.74rem', color: '#9aabba', marginTop: 2 } }, 'Changes proposed by team members awaiting admin approval')
        )
      ),

      drafts.length === 0
        ? React.createElement('div', { style: CARD(t) }, React.createElement(Empty, { icon: '\uD83D\uDCCB', title: 'No proposals yet', sub: 'When a non-admin team member proposes a config change, it will appear here for review.' }))
        : React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 8 } },
            drafts.map(function(draft) {
              var statusColors = { pending: '#e08c2e', approved: '#1D9E75', rejected: '#c0392b' };
              var statusColor = statusColors[draft.status] || '#9aabba';
              return React.createElement('div', { key: draft.id, style: { ...CARD, padding: '14px 18px' } },
                React.createElement('div', { style: { display: 'flex', alignItems: 'flex-start', gap: 14 } },
                  React.createElement('div', { style: { flex: 1, minWidth: 0 } },
                    React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 } },
                      React.createElement('span', { style: { fontSize: '.84rem', fontWeight: 700, color: '#0f1e28' } }, draft.key),
                      draft.platform && React.createElement('span', { style: { fontSize: '.62rem', fontWeight: 600, borderRadius: 99, padding: '1px 7px', background: (PLATFORM_COLORS[draft.platform] || '#314F5C') + '18', color: PLATFORM_COLORS[draft.platform] || '#314F5C' } }, PLATFORM_LABELS[draft.platform] || draft.platform),
                      React.createElement(Pill, { color: statusColor }, draft.status.charAt(0).toUpperCase() + draft.status.slice(1))
                    ),
                    React.createElement('div', { style: { fontSize: '.78rem', color: '#4a6070', marginBottom: 4 } },
                      'Change to: ', React.createElement('strong', null, String(draft.proposed_value))
                    ),
                    draft.note && React.createElement('div', { style: { fontSize: '.74rem', color: '#7a9aaa', fontStyle: 'italic', marginBottom: 4 } }, '"' + draft.note + '"'),
                    React.createElement('div', { style: { fontSize: '.68rem', color: '#b0c4ce' } },
                      'Proposed by ', React.createElement('strong', null, draft.proposed_by_name || draft.proposed_by),
                      ' \u00B7 ', new Date(draft.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
                    )
                  ),
                  isAdmin && draft.status === 'pending' && React.createElement('div', { style: { display: 'flex', gap: 6, flexShrink: 0 } },
                    React.createElement(Btn, { small: true, variant: 'danger', onClick: function() { rejectProposal(draft); } }, 'Reject'),
                    React.createElement(Btn, { small: true, onClick: function() { approveProposal(draft); } }, '\u2713 Approve')
                  )
                )
              );
            })
          )
    ),

    // ─── Propose modal ────────────────────────────────────────────────────────
    React.createElement(Modal, { open: proposing, onClose: function() { setProposing(false); }, title: 'Propose Changes' },
      React.createElement('div', { style: { background: '#f8fafc', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: '.78rem', color: '#314F5C' } },
        Object.keys(pendingEdits).length + ' change' + (Object.keys(pendingEdits).length !== 1 ? 's' : '') + ' will be submitted for admin review'
      ),
      React.createElement('div', { style: { marginBottom: 14 } },
        React.createElement('label', { style: { display: 'block', fontSize: '.74rem', fontWeight: 600, color: '#314F5C', marginBottom: 5 } }, 'Note for admin (optional)'),
        React.createElement('textarea', {
          value: proposeNote, onChange: function(e) { setProposeNote(e.target.value); }, rows: 3,
          placeholder: 'Explain why these changes are needed\u2026',
          style: { width: '100%', boxSizing: 'border-box', padding: '8px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.82rem', color: '#0f1e28', outline: 'none', background: '#fafcfd', resize: 'vertical' },
        })
      ),
      React.createElement('div', { style: { display: 'flex', gap: 8, justifyContent: 'flex-end' } },
        React.createElement(Btn, { variant: 'ghost', onClick: function() { setProposing(false); } }, 'Cancel'),
        React.createElement(Btn, { onClick: submitProposal, disabled: saving }, saving ? 'Submitting\u2026' : 'Submit Proposal')
      )
    )
  );
}


// ═══════════════════════════════════════════════════════════════════════════════
// NEW PLATFORM-FIRST APP STUDIO
// ═══════════════════════════════════════════════════════════════════════════════

var GH_TOKEN  = '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';
var GH_REPO   = 'product-sanoire/sanoire-app';
var GH_API    = 'https://api.github.com/repos/' + GH_REPO;
var SB_URL    = 'https://dekxnqbjzgkvltclthqw.supabase.co';
var SB_ANON   = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRla3hucWJqemdrdmx0Y2x0aHF3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE3NzM1ODEsImV4cCI6MjA3NzM0OTU4MX0.07Aj6pv1hhGAIzMgdkoseoSRJscx3vH3Uy9Bq472ubM';
var BUCKET    = 'app-previews';

var BUG_PRIORITIES = [
  { id: 'critical', label: 'Critical', color: '#c0392b' },
  { id: 'high',     label: 'High',     color: '#e08c2e' },
  { id: 'medium',   label: 'Medium',   color: '#6F8FA7' },
  { id: 'low',      label: 'Low',      color: '#1D9E75' },
];
var BUG_STATUSES = [
  { id: 'open',        label: 'Open',        color: '#c0392b' },
  { id: 'in_progress', label: 'In Progress', color: '#e08c2e' },
  { id: 'resolved',    label: 'Resolved',    color: '#1D9E75' },
  { id: 'wont_fix',    label: "Won't Fix",   color: '#9aabba' },
];

var HEALTH_CHECKS = [
  { id: 'homepage',  label: 'Homepage',        url: 'https://www.sanoire.com',                           threshold: 3000 },
  { id: 'sana',      label: 'Sana API',         url: 'https://www.sanoire.com/api/sana', method: 'POST', threshold: 5000,
    body: JSON.stringify({ messages: [{ role: 'user', content: 'ping' }], userId: null, userJwt: null, userLocation: null, lastIntent: null, previousLocations: [], nearMe: false }) },
  { id: 'supabase',  label: 'Supabase DB',      url: SB_URL + '/rest/v1/Locations?limit=1',              threshold: 2000 },
  { id: 'search',    label: 'Search API',       url: SB_URL + '/rest/v1/Locations?limit=5&select=id',    threshold: 2000 },
];

// ── Shared stat tile ─────────────────────────────────────────────────────────
function StatTile({ val, label, color }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return React.createElement('div', {
    style: { background: '#f8fafc', borderRadius: 8, padding: '12px 14px', border: '1px solid #f0f2f4', textAlign: 'center', flex: 1 }
  },
    React.createElement('div', { style: { fontSize: '1.5rem', fontWeight: 700, color: color || '#0f1e28', lineHeight: 1 } }, val),
    React.createElement('div', { style: { fontSize: '.7rem', color: '#9aabba', marginTop: 3 } }, label)
  );
}

// ── Run status helpers ───────────────────────────────────────────────────────
function runColor(run) {
  if (run.status === 'completed') {
    return run.conclusion === 'success' ? '#1D9E75' : '#c0392b';
  }
  if (run.status === 'in_progress') return '#e08c2e';
  return '#9aabba';
}
function runLabel(run) {
  if (run.status === 'completed') return run.conclusion === 'success' ? 'Success' : 'Failed';
  if (run.status === 'in_progress') return 'Running';
  return run.status;
}

// ── BugMini — compact bug list for platform overview ────────────────────────
function BugMini({ platform, onFileNew }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [bugs, setBugs] = useState([]);
  var [loading, setLoading] = useState(true);

  useEffect(function() {
    (async function() {
      setLoading(true);
      try {
        var { data } = await supabase.from('app_bugs')
          .select('*').eq('platform', platform)
          .in('status', ['open', 'in_progress'])
          .order('created_at', { ascending: false }).limit(5);
        setBugs(data || []);
      } catch (_e) { setBugs([]); }
      finally { setLoading(false); }
    })();
  }, [platform]);

  var open    = bugs.filter(function(b) { return b.status === 'open'; }).length;
  var inProg  = bugs.filter(function(b) { return b.status === 'in_progress'; }).length;

  return React.createElement('div', { style: Object.assign({}, CARD(t)) },
    React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 } },
      React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Bugs'),
      React.createElement('button', { onClick: onFileNew, style: { background: 'none', border: 'none', cursor: 'pointer', fontSize: '.76rem', color: '#314F5C', fontWeight: 600, fontFamily: F } }, '+ File bug')
    ),
    React.createElement('div', { style: { display: 'flex', gap: 10, marginBottom: 14 } },
      React.createElement(StatTile, { val: open, label: 'Open', color: open > 0 ? '#c0392b' : '#0f1e28' }),
      React.createElement(StatTile, { val: inProg, label: 'In progress', color: inProg > 0 ? '#e08c2e' : '#0f1e28' })
    ),
    loading
      ? React.createElement('div', { style: { color: '#9aabba', fontSize: '.78rem' } }, 'Loading...')
      : bugs.length === 0
        ? React.createElement('div', { style: { color: '#9aabba', fontSize: '.78rem', textAlign: 'center', padding: '12px 0' } }, 'No open bugs')
        : bugs.map(function(bug) {
            var pr = BUG_PRIORITIES.find(function(p) { return p.id === bug.priority; }) || BUG_PRIORITIES[2];
            var st = BUG_STATUSES.find(function(s) { return s.id === bug.status; }) || BUG_STATUSES[0];
            return React.createElement('div', {
              key: bug.id,
              style: { display: 'flex', alignItems: 'center', gap: 8, padding: '7px 0', borderBottom: '1px solid #f0f2f4' }
            },
              React.createElement('div', { style: { width: 7, height: 7, borderRadius: '50%', background: pr.color, flexShrink: 0 } }),
              React.createElement('div', { style: { flex: 1, fontSize: '.78rem', color: '#0f1e28', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, bug.title),
              React.createElement('div', { style: { fontSize: '.68rem', fontWeight: 700, color: st.color, flexShrink: 0 } }, st.label)
            );
          })
  );
}

// ── TestersMini ──────────────────────────────────────────────────────────────
function TestersMini({ platform }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [testers, setTesters] = useState([]);
  useEffect(function() {
    (async function() {
      try {
        var { data } = await supabase.from('app_testers').select('*')
          .or('platform.eq.' + platform + ',platform.eq.both').eq('status', 'active');
        setTesters(data || []);
      } catch (_e) {}
    })();
  }, [platform]);

  var colors = ['#B5D4F4', '#9FE1CB', '#F5C4B3', '#CECBF6', '#FAC775'];
  var textColors = ['#0C447C', '#085041', '#712B13', '#3C3489', '#633806'];

  return React.createElement('div', { style: Object.assign({}, CARD(t)) },
    React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28', marginBottom: 12 } }, 'Testers'),
    testers.length === 0
      ? React.createElement('div', { style: { color: '#9aabba', fontSize: '.78rem' } }, 'No active testers')
      : React.createElement('div', null,
          React.createElement('div', { style: { display: 'flex', marginBottom: 8 } },
            testers.slice(0, 5).map(function(t, i) {
              var initials = t.name ? t.name.split(' ').map(function(s) { return s[0]; }).join('').slice(0, 2).toUpperCase() : t.email[0].toUpperCase();
              return React.createElement('div', {
                key: t.id,
                title: t.name || t.email,
                style: { width: 28, height: 28, borderRadius: '50%', background: colors[i % colors.length], color: textColors[i % textColors.length], display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.65rem', fontWeight: 700, border: '2px solid #fff', marginLeft: i === 0 ? 0 : -6, flexShrink: 0 }
              }, initials);
            }),
            testers.length > 5 && React.createElement('div', {
              style: { width: 28, height: 28, borderRadius: '50%', background: '#f0f4f6', color: '#314F5C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.65rem', fontWeight: 700, border: '2px solid #fff', marginLeft: -6 }
            }, '+' + (testers.length - 5))
          ),
          React.createElement('div', { style: { fontSize: '.74rem', color: '#9aabba' } }, testers.length + ' active tester' + (testers.length !== 1 ? 's' : ''))
        )
  );
}

// ── RecentRuns ───────────────────────────────────────────────────────────────
function RecentRuns({ workflowFile, platformLabel }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [runs, setRuns] = useState([]);
  var [loading, setLoading] = useState(true);

  var GH_HDR = { 'Authorization': 'token ' + (localStorage.getItem('sanoire_gh_token') || GH_TOKEN), 'Content-Type': 'application/json', 'Accept': 'application/vnd.github+json' };

  async function load() {
    setLoading(true);
    try {
      var url = workflowFile
        ? GH_API + '/actions/workflows/' + workflowFile + '/runs?per_page=5'
        : GH_API + '/actions/runs?per_page=5';
      var resp = await fetch(url, { headers: GH_HDR });
      if (!resp.ok) throw new Error('GitHub API error');
      var data = await resp.json();
      setRuns(data.workflow_runs || []);
    } catch (_e) { setRuns([]); }
    finally { setLoading(false); }
  }

  useEffect(function() { load(); }, [workflowFile]); // eslint-disable-line react-hooks/exhaustive-deps

  return React.createElement('div', { style: Object.assign({}, CARD(t)) },
    React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 } },
      React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Recent builds'),
      React.createElement('div', { style: { display: 'flex', gap: 8, alignItems: 'center' } },
        React.createElement('a', { href: 'https://github.com/' + GH_REPO + '/actions', target: '_blank', rel: 'noreferrer', style: { fontSize: '.72rem', color: '#6F8FA7', textDecoration: 'none', fontFamily: F } }, 'View all \u2197'),
        React.createElement('button', { onClick: load, style: { background: 'none', border: 'none', cursor: 'pointer', color: '#9aabba', display: 'flex', padding: 2 } }, IC.reload)
      )
    ),
    loading
      ? React.createElement('div', { style: { color: '#9aabba', fontSize: '.78rem' } }, 'Loading...')
      : runs.length === 0
        ? React.createElement('div', { style: { color: '#9aabba', fontSize: '.78rem', textAlign: 'center', padding: '16px 0' } }, 'No builds yet \u2014 trigger one above')
        : runs.map(function(run, idx) {
            var color = runColor(run);
            var ago = Math.round((Date.now() - new Date(run.updated_at)) / 60000);
            var agoStr = ago < 1 ? 'just now' : ago < 60 ? ago + 'm ago' : Math.round(ago / 60) + 'h ago';
            return React.createElement('div', {
              key: run.id,
              style: { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: idx < runs.length - 1 ? '1px solid #f0f2f4' : 'none' }
            },
              React.createElement('div', { style: { width: 7, height: 7, borderRadius: '50%', background: color, flexShrink: 0 } }),
              React.createElement('div', { style: { flex: 1, minWidth: 0 } },
                React.createElement('div', { style: { fontSize: '.78rem', fontWeight: 600, color: '#0f1e28', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, run.display_title || run.name),
                React.createElement('div', { style: { fontSize: '.68rem', color: '#9aabba', marginTop: 1 } }, agoStr + ' \u00b7 #' + run.run_number)
              ),
              React.createElement('div', { style: { fontSize: '.7rem', fontWeight: 700, color: color, flexShrink: 0 } }, runLabel(run)),
              React.createElement('a', { href: run.html_url, target: '_blank', rel: 'noreferrer', style: { fontSize: '.68rem', color: '#6F8FA7', textDecoration: 'none', flexShrink: 0, fontFamily: F } }, 'View \u2197')
            );
          })
  );
}

// ── FileBugModal ─────────────────────────────────────────────────────────────
function FileBugModal({ open, onClose, defaultPlatform, authorEmail, authorName }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var _ft = useState({ title: '', description: '', platform: defaultPlatform || 'Android', priority: 'high', steps: '', version: '' });
  var form = _ft[0]; var setForm = _ft[1];
  var _sv = useState(false); var saving = _sv[0]; var setSaving = _sv[1];

  function setField(key, val) { setForm(function(f) { var n = Object.assign({}, f); n[key] = val; return n; }); }

  async function submit() {
    if (!form.title.trim()) return;
    setSaving(true);
    try {
      await supabase.from('app_bugs').insert([{
        title: form.title.trim(), description: form.description.trim(),
        platform: form.platform, priority: form.priority,
        steps: form.steps.trim(), version: form.version.trim(),
        status: 'open', reported_by: authorEmail, reporter_name: authorName,
      }]);
      await logActivity({ action: 'bug_filed', entity: 'bugs', summary: 'Bug: ' + form.title.trim(), detail: { platform: form.platform, priority: form.priority }, author_email: authorEmail, author_name: authorName });
      setForm({ title: '', description: '', platform: defaultPlatform || 'Android', priority: 'high', steps: '', version: '' });
      onClose(true);
    } catch (_e) {}
    finally { setSaving(false); }
  }

  var platOpts = [{ value: 'Web', label: 'Web' }, { value: 'Android', label: 'Android' }, { value: 'iOS', label: 'iOS' }, { value: 'All Platforms', label: 'All Platforms' }];
  var prioOpts = BUG_PRIORITIES.map(function(p) { return { value: p.id, label: p.label }; });

  return React.createElement(Modal, { open: open, onClose: function() { onClose(false); }, title: 'File a Bug' },
    React.createElement(LabeledInput, { label: 'Title', value: form.title, onChange: function(v) { setField('title', v); }, placeholder: 'What went wrong?' }),
    React.createElement('div', { style: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 14 } },
      React.createElement(LabeledSelect, { label: 'Platform', value: form.platform, onChange: function(v) { setField('platform', v); }, options: platOpts }),
      React.createElement(LabeledSelect, { label: 'Priority', value: form.priority, onChange: function(v) { setField('priority', v); }, options: prioOpts }),
      React.createElement(LabeledInput, { label: 'Version', value: form.version, onChange: function(v) { setField('version', v); }, placeholder: 'e.g. 1.4.1' })
    ),
    React.createElement(LabeledTextarea, { label: 'Description', value: form.description, onChange: function(v) { setField('description', v); }, rows: 2, placeholder: 'What happened?' }),
    React.createElement(LabeledTextarea, { label: 'Steps to reproduce', value: form.steps, onChange: function(v) { setField('steps', v); }, rows: 3, placeholder: '1. Open the app' }),
    React.createElement('div', { style: { display: 'flex', justifyContent: 'flex-end', gap: 8 } },
      React.createElement(Btn, { onClick: function() { onClose(false); }, variant: 'secondary' }, 'Cancel'),
      React.createElement(Btn, { onClick: submit, disabled: saving || !form.title.trim() }, saving ? 'Filing...' : 'Submit Bug')
    )
  );
}

// ── HealthMonitor ─────────────────────────────────────────────────────────────
function HealthMonitor() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [checks,  setChecks]  = useState({});
  var [lastRun, setLastRun] = useState(null);
  var [running, setRunning] = useState(false);
  var [autoBug, setAutoBug] = useState(!!localStorage.getItem('sanoire_autofile_bugs'));
  const { session: hmSess } = useAuth();
  var authorEmail = hmSess?.user?.email || null;

  async function fileAutoBug(check, result) {
    try {
      await supabase.from('app_bugs').insert([{
        title: 'Auto-detected: ' + check.label + ' failing (' + result.status + ')',
        description: 'Health monitor detected ' + check.label + ' returned ' + (result.status || 'no response') + ' in ' + result.ms + 'ms. URL: ' + check.url,
        platform: 'Web', priority: 'high', status: 'open',
        reported_by: authorEmail || 'health-monitor', reporter_name: 'Health Monitor',
      }]);
    } catch (_e) {}
  }

  async function runChecks() {
    setRunning(true);
    var results = {};
    for (var i = 0; i < HEALTH_CHECKS.length; i++) {
      var check = HEALTH_CHECKS[i];
      var start = Date.now();
      try {
        var opts = { method: check.method || 'GET', signal: AbortSignal.timeout(8000) };
        if (check.body) {
          opts.body = check.body;
          opts.headers = { 'Content-Type': 'application/json' };
        }
        if (check.url.includes('supabase')) {
          opts.headers = Object.assign(opts.headers || {}, { apikey: SB_ANON, Authorization: 'Bearer ' + SB_ANON });
        }
        var resp = await fetch(check.url, opts);
        var ms = Date.now() - start;
        var slow = check.threshold && ms > check.threshold;
        var ok = (resp.ok || resp.status < 500) && !slow;
        results[check.id] = { ok: ok, status: resp.status, ms: ms, slow: slow };
        // Auto-file bug if enabled and failing
        if (!ok && autoBug) {
          var existing = await supabase.from('app_bugs')
            .select('id').eq('title', 'Auto-detected: ' + check.label + ' failing (' + resp.status + ')').eq('status', 'open').limit(1);
          if (!existing.data || existing.data.length === 0) fileAutoBug(check, results[check.id]);
        }
      } catch (err) {
        var ms2 = Date.now() - start;
        results[check.id] = { ok: false, status: 0, ms: ms2, error: err.message };
        if (autoBug) {
          var existing2 = await supabase.from('app_bugs')
            .select('id').eq('title', 'Auto-detected: ' + check.label + ' failing (0)').eq('status', 'open').limit(1);
          if (!existing2.data || existing2.data.length === 0) fileAutoBug(check, results[check.id]);
        }
      }
    }
    setChecks(results);
    setLastRun(new Date());
    setRunning(false);
  }

  function toggleAutoBug() {
    var next = !autoBug;
    setAutoBug(next);
    if (next) localStorage.setItem('sanoire_autofile_bugs', '1');
    else localStorage.removeItem('sanoire_autofile_bugs');
  }

  useEffect(function() {
    runChecks();
    var interval = setInterval(runChecks, 5 * 60 * 1000);
    return function() { clearInterval(interval); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var allOk   = Object.keys(checks).length > 0 && Object.values(checks).every(function(c) { return c.ok; });
  var failCount = Object.values(checks).filter(function(c) { return !c.ok; }).length;

  return React.createElement('div', { style: Object.assign({}, CARD(t)) },
    React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 } },
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8 } },
        React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Health monitor'),
        Object.keys(checks).length > 0 && React.createElement('div', {
          style: { padding: '2px 8px', borderRadius: 99, fontSize: '.68rem', fontWeight: 700,
            background: allOk ? '#E1F5EE' : '#FCEBEB', color: allOk ? '#085041' : '#c0392b' }
        }, allOk ? 'All ok' : failCount + ' failing')
      ),
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8 } },
        lastRun && React.createElement('div', { style: { fontSize: '.67rem', color: '#b0c4ce' } }, lastRun.toLocaleTimeString()),
        React.createElement('button', { onClick: runChecks, disabled: running,
          style: { background: 'none', border: 'none', cursor: 'pointer', color: '#9aabba', display: 'flex', padding: 2, opacity: running ? 0.5 : 1 }
        }, IC.reload)
      )
    ),

    React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 } },
      HEALTH_CHECKS.map(function(check) {
        var result = checks[check.id];
        var status = !result ? 'pending' : result.ok ? 'ok' : result.slow ? 'slow' : 'fail';
        var color = status === 'ok' ? '#1D9E75' : status === 'slow' ? '#e08c2e' : status === 'fail' ? '#c0392b' : '#9aabba';
        var bg    = status === 'fail' ? '#FCEBEB' : status === 'slow' ? '#FAEEDA' : '#f8fafc';
        var bdr   = status === 'fail' ? '#fca5a5' : status === 'slow' ? '#fcd34d' : '#f0f2f4';
        return React.createElement('div', {
          key: check.id,
          style: { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', borderRadius: 8, background: bg, border: '1px solid ' + bdr }
        },
          React.createElement('div', { style: { width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 } }),
          React.createElement('div', { style: { flex: 1, fontSize: '.77rem', fontWeight: 600, color: '#0f1e28' } }, check.label),
          result && React.createElement('div', { style: { fontSize: '.7rem', color: status === 'ok' ? '#9aabba' : color, fontWeight: status !== 'ok' ? 700 : 400 } },
            result.ms + 'ms' + (check.threshold ? ' / ' + (check.threshold/1000).toFixed(0) + 's limit' : '')
          ),
          React.createElement('div', { style: { fontSize: '.7rem', fontWeight: 700, color: color, flexShrink: 0, minWidth: 36, textAlign: 'right' } },
            status === 'pending' ? '...' : status === 'ok' ? 'OK' : status === 'slow' ? 'SLOW' : 'FAIL'
          )
        );
      })
    ),

    React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', background: autoBug ? '#E1F5EE' : '#f8fafc', borderRadius: 8, border: '1px solid ' + (autoBug ? '#6ee7b7' : '#f0f2f4') } },
      React.createElement('div', null,
        React.createElement('div', { style: { fontSize: '.76rem', fontWeight: 700, color: '#0f1e28' } }, 'Auto-file bugs'),
        React.createElement('div', { style: { fontSize: '.7rem', color: '#9aabba', marginTop: 2 } }, 'Automatically create a bug when any check fails or is slow')
      ),
      React.createElement('button', {
        onClick: toggleAutoBug,
        style: { width: 36, height: 20, borderRadius: 10, border: 'none', cursor: 'pointer', background: autoBug ? '#1D9E75' : '#d1d5db', position: 'relative', transition: 'background .2s', flexShrink: 0 }
      },
        React.createElement('div', { style: { width: 16, height: 16, borderRadius: '50%', background: t.panel, position: 'absolute', top: 2, left: autoBug ? 18 : 2, transition: 'left .2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' } })
      )
    ),
    React.createElement('div', { style: { marginTop: 8, fontSize: '.68rem', color: '#9aabba', lineHeight: 1.6 } },
      'Checks every 5 min. Red = down, amber = slow (over threshold). Auto-bug toggle files issues to Bugs tab automatically.'
    )
  );
}

// ── PerformanceMonitor ────────────────────────────────────────────────────────
var PERF_CHECKS = [
  { id: 'map_tiles',  label: 'Map tiles',     url: 'https://tile.openstreetmap.org/0/0/0.png',  threshold: 1500 },
  { id: 'geocode',    label: 'Geocoding API', url: 'https://nominatim.openstreetmap.org/search?q=Kuala+Lumpur&format=json&limit=1', threshold: 3000 },
  { id: 'ipapi',      label: 'IP Location',   url: 'https://ipapi.co/json/',                    threshold: 2000 },
];

function PerformanceMonitor() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [results, setResults] = useState({});
  var [running, setRunning] = useState(false);
  var [lastRun, setLastRun] = useState(null);
  var [history, setHistory] = useState({}); // rolling avg

  async function runPerf() {
    setRunning(true);
    var newResults = {};
    for (var i = 0; i < PERF_CHECKS.length; i++) {
      var check = PERF_CHECKS[i];
      var times = [];
      for (var r = 0; r < 2; r++) { // 2 pings for accuracy
        var start = Date.now();
        try {
          await fetch(check.url, { signal: AbortSignal.timeout(6000), cache: 'no-store' });
          times.push(Date.now() - start);
        } catch (_e) { times.push(null); }
      }
      var valid = times.filter(function(t) { return t !== null; });
      var avg   = valid.length ? Math.round(valid.reduce(function(a,b){return a+b;},0) / valid.length) : null;
      newResults[check.id] = { ms: avg, ok: avg !== null && avg < check.threshold, timeout: avg === null };
    }
    setResults(newResults);
    setHistory(function(h) {
      var next = Object.assign({}, h);
      Object.keys(newResults).forEach(function(k) {
        if (newResults[k].ms !== null) {
          next[k] = (next[k] || []).concat(newResults[k].ms).slice(-10);
        }
      });
      return next;
    });
    setLastRun(new Date());
    setRunning(false);
  }

  useEffect(function() {
    runPerf();
    var iv = setInterval(runPerf, 10 * 60 * 1000); // every 10 min
    return function() { clearInterval(iv); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return React.createElement('div', { style: Object.assign({}, CARD(t)) },
    React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 } },
      React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Performance'),
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8 } },
        lastRun && React.createElement('div', { style: { fontSize: '.67rem', color: '#b0c4ce' } }, lastRun.toLocaleTimeString()),
        React.createElement('button', { onClick: runPerf, disabled: running,
          style: { background: 'none', border: 'none', cursor: 'pointer', color: '#9aabba', display: 'flex', padding: 2, opacity: running ? 0.5 : 1 }
        }, IC.reload)
      )
    ),
    React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 6 } },
      PERF_CHECKS.map(function(check) {
        var r       = results[check.id];
        var hist    = history[check.id] || [];
        var avg     = hist.length ? Math.round(hist.reduce(function(a,b){return a+b;},0)/hist.length) : null;
        var status  = !r ? 'pending' : r.timeout ? 'fail' : r.ok ? 'ok' : 'slow';
        var color   = status === 'ok' ? '#1D9E75' : status === 'slow' ? '#e08c2e' : status === 'fail' ? '#c0392b' : '#9aabba';
        // Mini sparkline bar
        var maxMs   = Math.max.apply(null, hist.concat([check.threshold]));
        return React.createElement('div', { key: check.id, style: { display: 'flex', flexDirection: 'column', gap: 4, padding: '8px 12px', borderRadius: 8, background: '#f8fafc', border: '1px solid #f0f2f4' } },
          React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8 } },
            React.createElement('div', { style: { width: 7, height: 7, borderRadius: '50%', background: color, flexShrink: 0 } }),
            React.createElement('div', { style: { flex: 1, fontSize: '.76rem', fontWeight: 600, color: '#0f1e28' } }, check.label),
            r && !r.timeout && React.createElement('div', { style: { fontSize: '.7rem', color: color, fontWeight: 600 } }, r.ms + 'ms'),
            avg && React.createElement('div', { style: { fontSize: '.67rem', color: '#9aabba' } }, 'avg ' + avg + 'ms'),
            status === 'pending' && React.createElement('div', { style: { fontSize: '.7rem', color: '#9aabba' } }, 'Checking...')
          ),
          hist.length > 1 && React.createElement('div', { style: { display: 'flex', gap: 2, alignItems: 'flex-end', height: 16 } },
            hist.map(function(ms, i) {
              var h = Math.max(3, Math.round((ms / maxMs) * 14));
              var c = ms > check.threshold ? '#e08c2e' : '#1D9E75';
              return React.createElement('div', { key: i, style: { width: 4, height: h + 'px', borderRadius: 2, background: c, flex: '0 0 4px' } });
            })
          )
        );
      })
    ),
    React.createElement('div', { style: { marginTop: 8, fontSize: '.68rem', color: '#9aabba', lineHeight: 1.6 } },
      'Checks every 10 min. Sparklines show last 10 readings. Amber = slow, red = unreachable.'
    )
  );
}

// ── IssueFixModal — click an issue, Claude analyses and suggests a fix ────────
function IssueFixModal({ bug, onClose, onResolved }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [analysis, setAnalysis]   = useState('');
  var [streaming, setStreaming] = useState(false);
  var [done, setDone]           = useState(false);
  var [copied, setCopied]       = useState(false);

  useEffect(function() {
    if (bug) { setAnalysis(''); setDone(false); analyseWithClaude(bug); }
  }, [bug]); // eslint-disable-line react-hooks/exhaustive-deps

  async function analyseWithClaude(issue) {
    setStreaming(true);
    var prompt = [
      'You are a senior engineer reviewing a bug auto-detected in the Sanoire app — a React/Capacitor healthcare location discovery app.',
      '',
      'Bug title: ' + issue.title,
      'Platform: ' + (issue.platform || 'Web'),
      'Priority: ' + (issue.priority || 'high'),
      'Reporter: ' + (issue.reporter_name || 'Auto-monitor'),
      '',
      'Full details:',
      issue.description || '(no additional details)',
      '',
      'Provide:',
      '1. ROOT CAUSE — what is likely causing this (2-3 sentences)',
      '2. FIX — exact code or config change needed. Be specific. Include file names.',
      '3. HOW TO VERIFY — how to confirm the fix worked',
      '',
      'Be concise and actionable. No preamble. Focus on the Sanoire codebase (React, Capacitor, Supabase, Vercel).',
    ].join('\n');

    try {
      var resp = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model: 'claude-sonnet-4-20250514',
          max_tokens: 1000,
          stream: true,
          messages: [{ role: 'user', content: prompt }],
        }),
      });

      var reader = resp.body.getReader();
      var decoder = new TextDecoder();
      var fullText = '';

      while (true) {
        var _r = await reader.read();
        if (_r.done) break;
        var lines = decoder.decode(_r.value, { stream: true }).split('\n');
        for (var line of lines) {
          if (!line.startsWith('data: ')) continue;
          var data = line.slice(6).trim();
          if (data === '[DONE]') break;
          try {
            var parsed = JSON.parse(data);
            var delta = parsed?.delta?.text || '';
            if (delta) { fullText += delta; setAnalysis(fullText); }
          } catch (_e) {}
        }
      }
    } catch (err) {
      setAnalysis('Error connecting to Claude: ' + err.message + '\n\nMake sure the Anthropic API is available.');
    }
    setStreaming(false);
    setDone(true);
  }

  async function markResolved() {
    await supabase.from('app_bugs').update({ status: 'resolved' }).eq('id', bug.id);
    onResolved(bug.id);
    onClose();
  }

  function copyFix() {
    navigator.clipboard.writeText(analysis).catch(function(){});
    setCopied(true);
    setTimeout(function() { setCopied(false); }, 2000);
  }

  if (!bug) return null;

  var pCfg = (BUG_PRIORITIES || []).find(function(p) { return p.id === bug.priority; }) || { color: '#9aabba', label: bug.priority };
  var ago   = Math.round((Date.now() - new Date(bug.created_at)) / 60000);
  var agoS  = ago < 60 ? ago + 'm ago' : ago < 1440 ? Math.round(ago/60) + 'h ago' : Math.round(ago/1440) + 'd ago';

  return React.createElement(Modal, { open: true, onClose: onClose, title: 'Issue Analysis', wide: true },
    // Issue header
    React.createElement('div', { style: { background: '#f8fafc', borderRadius: 10, padding: '12px 16px', marginBottom: 18, border: '1px solid #f0f2f4' } },
      React.createElement('div', { style: { display: 'flex', alignItems: 'flex-start', gap: 10 } },
        React.createElement('div', { style: { width: 8, height: 8, borderRadius: '50%', background: pCfg.color, flexShrink: 0, marginTop: 5 } }),
        React.createElement('div', { style: { flex: 1 } },
          React.createElement('div', { style: { fontSize: '.86rem', fontWeight: 700, color: '#0f1e28', marginBottom: 6, lineHeight: 1.4 } }, bug.title),
          React.createElement('div', { style: { display: 'flex', gap: 8, flexWrap: 'wrap', fontSize: '.7rem', color: '#9aabba' } },
            React.createElement('span', null, bug.reporter_name || 'Auto-monitor'),
            React.createElement('span', null, '\u00b7'),
            React.createElement('span', null, bug.platform || 'Web'),
            React.createElement('span', null, '\u00b7'),
            React.createElement('span', { style: { color: pCfg.color, fontWeight: 700 } }, (pCfg.label || bug.priority)),
            React.createElement('span', null, '\u00b7'),
            React.createElement('span', null, agoS)
          ),
          bug.description && React.createElement('div', { style: { marginTop: 10, fontSize: '.72rem', color: '#4a6070', lineHeight: 1.65, background: t.panel, borderRadius: 7, padding: '8px 10px', border: '1px solid #eef1f4', fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: 120, overflowY: 'auto' } }, bug.description)
        )
      )
    ),

    // Claude analysis
    React.createElement('div', { style: { marginBottom: 16 } },
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 } },
        React.createElement('div', { style: { fontSize: '.82rem', fontWeight: 700, color: '#0f1e28' } }, 'Claude\'s analysis'),
        streaming && React.createElement('div', { style: { display: 'flex', gap: 3, alignItems: 'center' } },
          [0,1,2].map(function(i) {
            return React.createElement('div', { key: i, style: { width: 5, height: 5, borderRadius: '50%', background: t.accent, animation: 'pulse 1.2s ' + (i*0.2) + 's infinite', opacity: 0.6 } });
          })
        ),
        done && React.createElement('div', { style: { fontSize: '.68rem', color: '#1D9E75', fontWeight: 700 } }, '\u2713 Complete')
      ),
      analysis
        ? React.createElement('div', { style: { fontSize: '.78rem', color: '#1a2e3a', lineHeight: 1.8, background: '#f8fafc', borderRadius: 10, padding: '14px 16px', border: `1px solid ${t.bd}`, whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: 400, overflowY: 'auto', fontFamily: 'system-ui,-apple-system,sans-serif' } }, analysis)
        : React.createElement('div', { style: { background: '#f8fafc', borderRadius: 10, padding: '28px', textAlign: 'center', border: `1px solid ${t.bd}` } },
            React.createElement('div', { style: { fontSize: '.78rem', color: '#9aabba' } }, 'Analysing issue...')
          )
    ),

    // Actions
    React.createElement('div', { style: { display: 'flex', gap: 8, justifyContent: 'space-between', alignItems: 'center' } },
      React.createElement('div', { style: { display: 'flex', gap: 8 } },
        done && React.createElement(Btn, { onClick: copyFix, variant: 'secondary', small: true },
          copied ? '\u2713 Copied' : 'Copy fix'
        ),
        done && React.createElement(Btn, { onClick: function() { analyseWithClaude(bug); setAnalysis(''); setDone(false); }, variant: 'secondary', small: true }, 'Re-analyse')
      ),
      React.createElement('div', { style: { display: 'flex', gap: 8 } },
        React.createElement(Btn, { onClick: onClose, variant: 'secondary', small: true }, 'Close'),
        React.createElement(Btn, { onClick: markResolved, variant: 'success', small: true }, '\u2713 Mark resolved')
      )
    )
  );
}

// ── ErrorFeed ─────────────────────────────────────────────────────────────────
function ErrorFeed() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [errors,   setErrors]   = useState([]);
  var [loading,  setLoading]  = useState(true);
  var [selected, setSelected] = useState(null);

  useEffect(function() {
    loadErrors();
    var channel = supabase.channel('auto-bugs-feed')
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'app_bugs' }, function(payload) {
        var reporters = ['Health Monitor', 'JS Error Monitor', 'Mirror Session', 'Performance Monitor'];
        if (reporters.indexOf(payload.new.reporter_name) !== -1) {
          setErrors(function(e) { return [payload.new].concat(e).slice(0, 30); });
        }
      })
      .subscribe();
    return function() { supabase.removeChannel(channel); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function loadErrors() {
    setLoading(true);
    try {
      var { data } = await supabase.from('app_bugs')
        .select('*')
        .or('reporter_name.eq.Health Monitor,reporter_name.eq.JS Error Monitor,reporter_name.eq.Mirror Session,reporter_name.eq.Performance Monitor')
        .neq('status', 'resolved')
        .order('created_at', { ascending: false })
        .limit(30);
      setErrors(data || []);
    } catch (_e) {}
    finally { setLoading(false); }
  }

  function onResolved(id) {
    setErrors(function(e) { return e.filter(function(x) { return x.id !== id; }); });
  }

  var openCount = errors.filter(function(e) { return e.status === 'open'; }).length;

  return React.createElement('div', { style: Object.assign({}, CARD(t)) },

    selected && React.createElement(IssueFixModal, { bug: selected, onClose: function() { setSelected(null); }, onResolved: onResolved }),

    React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 } },
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8 } },
        React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Auto-detected issues'),
        openCount > 0 && React.createElement('div', { style: { padding: '2px 8px', borderRadius: 99, fontSize: '.68rem', fontWeight: 700, background: '#FCEBEB', color: '#c0392b' } }, openCount)
      ),
      React.createElement('button', { onClick: loadErrors, style: { background: 'none', border: 'none', cursor: 'pointer', color: '#9aabba', display: 'flex', padding: 2 } }, IC.reload)
    ),

    loading
      ? React.createElement('div', { style: { color: '#9aabba', fontSize: '.76rem' } }, 'Loading...')
      : errors.length === 0
        ? React.createElement('div', { style: { color: '#9aabba', fontSize: '.76rem', textAlign: 'center', padding: '16px 0' } }, '\u2713 No open issues detected')
        : React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 2 } },
            errors.map(function(bug) {
              var pCfg = (BUG_PRIORITIES || []).find(function(p) { return p.id === bug.priority; }) || { color: '#9aabba' };
              var ago  = Math.round((Date.now() - new Date(bug.created_at)) / 60000);
              var agoS = ago < 60 ? ago + 'm ago' : ago < 1440 ? Math.round(ago/60) + 'h ago' : Math.round(ago/1440) + 'd ago';
              var sourceIcon = bug.reporter_name === 'Health Monitor' ? '\uD83D\uDFE1' : bug.reporter_name === 'JS Error Monitor' ? '\uD83D\uDED1' : '\uD83D\uDCCB';
              return React.createElement('div', {
                key: bug.id,
                onClick: function() { setSelected(bug); },
                style: { display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', borderRadius: 8, cursor: 'pointer', border: '1px solid transparent', transition: 'all .1s', background: '#fafafa' },
                onMouseEnter: function(e) { e.currentTarget.style.background = '#f0f7ff'; e.currentTarget.style.borderColor = '#dde4ea'; },
                onMouseLeave: function(e) { e.currentTarget.style.background = '#fafafa'; e.currentTarget.style.borderColor = 'transparent'; }
              },
                React.createElement('div', { style: { width: 7, height: 7, borderRadius: '50%', background: pCfg.color, flexShrink: 0 } }),
                React.createElement('div', { style: { flex: 1, minWidth: 0 } },
                  React.createElement('div', { style: { fontSize: '.76rem', fontWeight: 600, color: '#0f1e28', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, bug.title),
                  React.createElement('div', { style: { fontSize: '.67rem', color: '#9aabba', marginTop: 1 } }, sourceIcon + ' ' + bug.reporter_name + ' \u00b7 ' + agoS)
                ),
                React.createElement('div', { style: { flexShrink: 0, display: 'flex', alignItems: 'center', gap: 4, padding: '3px 8px', borderRadius: 6, background: '#EEF4FF', border: '1px solid #c7d7f9' } },
                  React.createElement('svg', { width: 10, height: 10, viewBox: '0 0 24 24', fill: 'none', stroke: '#4F6EF7', strokeWidth: 2.5, strokeLinecap: 'round' },
                    React.createElement('circle', { cx: 11, cy: 11, r: 8 }),
                    React.createElement('path', { d: 'M21 21l-4.35-4.35' })
                  ),
                  React.createElement('span', { style: { fontSize: '.66rem', fontWeight: 700, color: '#4F6EF7' } }, 'Fix with Claude')
                )
              );
            })
          ),

    errors.length > 0 && React.createElement('div', { style: { marginTop: 10, fontSize: '.68rem', color: '#9aabba', lineHeight: 1.5 } },
      'Click any issue to get a root cause analysis and fix from Claude.'
    )
  );
}

// ── SentryPanel ───────────────────────────────────────────────────────────────
function SentryPanel() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [dsn, setDsn] = useState(localStorage.getItem('sanoire_sentry_dsn') || '');
  var [saved, setSaved] = useState(false);

  function saveDsn() {
    localStorage.setItem('sanoire_sentry_dsn', dsn.trim());
    setSaved(true);
    setTimeout(function() { setSaved(false); }, 2000);
  }

  return React.createElement('div', { style: Object.assign({}, CARD(t)) },
    React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 } },
      React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Sentry'),
      React.createElement('div', { style: { padding: '2px 8px', borderRadius: 99, fontSize: '.68rem', fontWeight: 700,
        background: dsn ? '#E1F5EE' : '#f0f4f6', color: dsn ? '#085041' : '#9aabba' } }, dsn ? '\u2713 Configured' : 'Not set up')
    ),
    React.createElement('div', { style: { fontSize: '.76rem', color: '#9aabba', lineHeight: 1.7, marginBottom: 10 } },
      'Real crashes from real users on Android & iOS — full stack traces, device info, user context. Free tier covers Sanoire\'s usage.'
    ),
    !dsn && React.createElement('div', { style: { background: '#f8fafc', borderRadius: 8, padding: '10px 12px', marginBottom: 10, fontSize: '.74rem', color: '#4a6070', lineHeight: 1.75 } },
      React.createElement('div', { style: { fontWeight: 700, marginBottom: 4 } }, 'Setup:'),
      ['1. Free account at sentry.io', '2. New project \u2192 React Native', '3. Copy DSN from Project Settings \u2192 Client Keys', '4. Paste below and save', '5. In terminal: npx @sentry/wizard@latest -i reactNative'].map(function(s, i) {
        return React.createElement('div', { key: i }, s);
      })
    ),
    React.createElement('div', { style: { display: 'flex', gap: 8 } },
      React.createElement('input', { type: 'text', value: dsn, onChange: function(e) { setDsn(e.target.value); },
        placeholder: 'https://xxxx@oxxxx.ingest.sentry.io/xxxx',
        style: { flex: 1, padding: '7px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', outline: 'none' }
      }),
      React.createElement(Btn, { onClick: saveDsn, variant: saved ? 'success' : 'secondary', small: true }, saved ? '\u2713 Saved' : 'Save DSN')
    ),
    dsn && React.createElement('div', { style: { marginTop: 10, padding: '10px 12px', background: '#E1F5EE', borderRadius: 8, fontSize: '.74rem', color: '#085041', lineHeight: 1.65 } },
      '\u2705 Active \u2014 crashes appear at ',
      React.createElement('a', { href: 'https://sentry.io', target: '_blank', rel: 'noreferrer', style: { color: '#085041', fontWeight: 600 } }, 'sentry.io \u2197')
    )
  );
}

// ── LiveDevicePanel (Web platform) ──────────────────────────────────────────
function WebLivePreview() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return React.createElement('div', { style: Object.assign({}, CARD(t), { padding: 0, overflow: 'hidden' }) },
    React.createElement('div', { style: { padding: '14px 18px', borderBottom: '1px solid #f0f2f4', display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
      React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Live preview'),
      React.createElement('a', { href: 'https://www.sanoire.com', target: '_blank', rel: 'noreferrer', style: { fontSize: '.74rem', color: '#314F5C', textDecoration: 'none', fontFamily: F, fontWeight: 600 } }, 'Open full site \u2197')
    ),
    React.createElement('iframe', {
      src: 'https://www.sanoire.com',
      title: 'Sanoire web app',
      style: { width: '100%', height: 500, border: 'none', display: 'block' },
      loading: 'lazy'
    })
  );
}

// ── Android/iOS mini live device panel ───────────────────────────────────────
function NativeLivePreview({ platform, mode, setMode, liveActive, setLiveActive, serverInput, setServerInput }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var isAndroid = platform === 'android';

  if (!isAndroid) {
    return React.createElement('div', { style: Object.assign({}, CARD(t)) },
      React.createElement('div', { style: { fontSize: '.82rem', fontWeight: 700, color: '#0f1e28', marginBottom: 8 } }, 'iOS testing via LambdaTest'),
      React.createElement('div', { style: { fontSize: '.76rem', color: '#9aabba', lineHeight: 1.7, marginBottom: 12 } }, 'Upload your .ipa file to LambdaTest to test on real iOS devices.'),
      React.createElement('a', { href: 'https://applive.lambdatest.com/app', target: '_blank', rel: 'noreferrer',
        style: { display: 'inline-flex', alignItems: 'center', gap: 5, padding: '7px 14px', borderRadius: 8, background: t.accent, color: '#fff', fontSize: '.76rem', fontWeight: 600, textDecoration: 'none', fontFamily: F }
      }, '\u25ba Open App Live \u2197')
    );
  }

  if (mode === 'cloud') return React.createElement(CloudTestingPanel);

  if (!liveActive) {
    return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 12 } },
      React.createElement('div', { style: Object.assign({}, CARD(t)) },
        React.createElement('div', { style: { fontSize: '.86rem', fontWeight: 700, color: '#0f1e28', marginBottom: 14 } }, 'My Device (USB) — Quick Setup'),
        React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 } },
          [
            { n:'1', c: ['Enable ', React.createElement('strong',null,'USB Debugging'), ' on your phone: Settings \u2192 About Phone \u2192 tap Build Number 7 times \u2192 Settings \u2192 Developer Options \u2192 USB Debugging ON.'] },
            { n:'2', c: ['Connect phone to your PC with a ', React.createElement('strong',null,'data USB cable'), ' (not charge-only). Tap ', React.createElement('strong',null,'Allow'), ' when the phone asks to allow USB debugging.'] },
            { n:'3', c: ['In PowerShell, go to the sanoire-app folder and run: ', React.createElement('code',{style:{background:t.rowbg,padding:'1px 7px',borderRadius:4,fontSize:'.76rem',color:t.accent}},'node server.js'), '. Leave the terminal open.'] },
            { n:'4', c: ['First time only: open ', React.createElement('a',{href:serverInput||'https://localhost:8886',target:'_blank',rel:'noreferrer',style:{color:t.accent,fontWeight:600}},'https://localhost:8886'), ' in Chrome \u2192 click Advanced \u2192 Proceed to localhost. Then click Load below.'] },
          ].map(function(s) {
            return React.createElement('div', { key: s.n, style: { display: 'flex', gap: 10, alignItems: 'flex-start' } },
              React.createElement('div', { style: { width: 22, height: 22, borderRadius: '50%', background: t.accent, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.68rem', fontWeight: 700, flexShrink: 0, marginTop: 1 } }, s.n),
              React.createElement('div', { style: { fontSize: '.8rem', color: '#4a6070', lineHeight: 1.7, flex: 1 } }, s.c)
            );
          })
        ),
        React.createElement('div', { style: { display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', paddingTop: 12, borderTop: '1px solid #f0f2f4' } },
          React.createElement('input', { value: serverInput, onChange: function(e) { setServerInput(e.target.value); }, placeholder: 'https://localhost:8886',
            style: { flex: 1, minWidth: 180, padding: '8px 10px', borderRadius: 7, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.76rem', outline: 'none', color: '#314F5C' }
          }),
          React.createElement(Btn, { onClick: function() { setLiveActive(true); } }, '\u25ba Load')
        )
      ),
      React.createElement('div', { style: Object.assign({}, CARD(t), { padding: 0, overflow: 'hidden' }) },
        React.createElement('details', null,
          React.createElement('summary', { style: { padding: '11px 16px', fontSize: '.78rem', fontWeight: 600, color: '#6F8FA7', cursor: 'pointer', listStyle: 'none', display: 'flex', alignItems: 'center', gap: 6 } }, '\u25ba Troubleshooting'),
          React.createElement('div', { style: { padding: '4px 16px 14px', display: 'flex', flexDirection: 'column', gap: 8 } },
            [
              { q: 'adb devices shows nothing', a: 'Try a different cable \u2014 many cables are charge-only. Check phone for the Allow USB debugging prompt.' },
              { q: '"unauthorized" in adb devices', a: 'Unlock your phone and tap Allow on the USB debugging dialog. Unplug and replug if you don\'t see it.' },
              { q: 'Port 8886 already in use', a: 'Run: Get-Process -Name node | Stop-Process -Force, then restart node server.js.' },
              { q: 'ERR_SSL_PROTOCOL_ERROR in iframe', a: 'Pull latest: git fetch origin && git reset --hard origin/main, then restart node server.js.' },
              { q: '"openssl not found" in terminal', a: 'Install Git for Windows from git-scm.com \u2014 it includes openssl. Restart PowerShell after installing.' },
            ].map(function(item, i) {
              return React.createElement('div', { key: i, style: { background: '#f8fafc', borderRadius: 7, padding: '9px 12px', border: '1px solid #edf2f6' } },
                React.createElement('div', { style: { fontSize: '.76rem', fontWeight: 700, color: '#0f1e28', marginBottom: 3 } }, item.q),
                React.createElement('div', { style: { fontSize: '.73rem', color: '#6a8898', lineHeight: 1.6 } }, item.a)
              );
            })
          )
        )
      )
    );
  }

  return React.createElement('div', { style: { display: 'flex', justifyContent: 'center', alignItems: 'flex-start' } },
    React.createElement('div', { style: { background: '#1a1a1c', borderRadius: 36, padding: '8px 7px 7px', boxShadow: '0 20px 60px rgba(0,0,0,0.55), 0 0 0 1px rgba(255,255,255,0.07)', display: 'inline-flex', flexDirection: 'column', alignItems: 'center' } },
      React.createElement('div', { style: { width: 8, height: 8, borderRadius: '50%', background: '#0a0a0c', border: '1px solid rgba(255,255,255,0.1)', margin: '2px auto 7px' } }),
      React.createElement('div', { style: { borderRadius: 26, overflow: 'hidden', width: 280, height: 540, background: '#000' } },
        React.createElement('iframe', {
          key: serverInput,
          src: serverInput.trim().replace(/\/$/, '') || 'https://localhost:8886',
          title: 'Oppo Find X9 \u2014 live',
          style: { width: '100%', height: '100%', border: 'none', display: 'block' },
          allow: 'autoplay',
        })
      ),
      React.createElement('div', { style: { display: 'flex', justifyContent: 'center', gap: 24, padding: '6px 0 2px' } },
        ['\u25C1','\u25CB','\u25A1'].map(function(s) { return React.createElement('span', { key: s, style: { fontSize: 12, color: 'rgba(255,255,255,0.15)' } }, s); })
      )
    )
  );
}

// ─── CloudTestingPanel — full mission control for cloud device testing ─────────
// ── WirelessQR — QR code linking to Android wireless debugging settings ────────
function WirelessQR() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var canvasRef = React.useRef(null);
  // Deep link that opens wireless debugging on OPPO / stock Android
  var url = 'intent:#Intent;action=android.settings.APPLICATION_DEVELOPMENT_SETTINGS;end';

  React.useEffect(function() {
    var canvas = canvasRef.current;
    if (!canvas) return;
    // Use QRCode lib loaded from CDN if available, otherwise show text
    if (window.QRCode) {
      canvas.innerHTML = '';
      new window.QRCode(canvas, {
        text: url,
        width: 140, height: 140,
        colorDark: '#0d1d2b', colorLight: '#ffffff',
        correctLevel: window.QRCode.CorrectLevel.M,
      });
    }
  }, []);

  React.useEffect(function() {
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
    s.onload = function() {
      var canvas = canvasRef.current;
      if (!canvas || !window.QRCode) return;
      canvas.innerHTML = '';
      new window.QRCode(canvas, {
        text: url,
        width: 140, height: 140,
        colorDark: '#0d1d2b', colorLight: '#ffffff',
        correctLevel: window.QRCode.CorrectLevel.M,
      });
    };
    if (!window.QRCode) document.head.appendChild(s);
  }, []); // eslint-disable-line

  return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 } },
    React.createElement('div', { ref: canvasRef, style: {
      width: 140, height: 140, borderRadius: 10,
      background: t.panel, padding: 6,
      boxShadow: '0 1px 4px rgba(15,30,40,0.12), 0 0 0 1px rgba(15,30,40,0.06)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}),
    React.createElement('div', { style: { fontSize: '.68rem', color: '#6F8FA7', textAlign: 'center', fontFamily: F, lineHeight: 1.4, maxWidth: 140 } },
      'Scan with your OPPO to open Wireless Debugging'
    )
  );
}

function CombinedPanel({ serverInput, setServerInput }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [copied, setCopied] = React.useState(null);
  var [live, setLive] = React.useState(false);
  function copy(text, key) {
    navigator.clipboard.writeText(text).then(function() {
      setCopied(key); setTimeout(function() { setCopied(null); }, 1800);
    });
  }
  var cmd = { background: '#0d1d2b', borderRadius: 8, padding: '8px 12px', fontFamily: 'monospace', fontSize: '.70rem', color: '#AFE1F6', wordBreak: 'break-all', flex: 1, lineHeight: 1.5 };
  var row = { display: 'flex', alignItems: 'flex-start', gap: 6, marginBottom: 8 };
  var cpBtn = function(k) { return { padding: '5px 9px', borderRadius: 6, border: 'none', background: copied===k ? '#1D9E75' : '#314F5C', color: '#E0F5FC', fontFamily: F, fontSize: '.70rem', cursor: 'pointer', flexShrink: 0, fontWeight: 600, minWidth: 52 }; };
  var cs = 'powershell -ExecutionPolicy Bypass -File "C:\\Users\\jenni\\Documents\\Sanoire\\sanoire-app\\sanoire-android.ps1"';
  var bs = 'powershell -ExecutionPolicy Bypass -File "C:\\Users\\jenni\\Documents\\Sanoire\\sanoire-app\\sanoire-android.ps1" -build';

  return React.createElement('div', { style: { display: 'flex', gap: 14, alignItems: 'flex-start', flexWrap: 'wrap' } },

    // ── Left: Cloud ──
    React.createElement('div', { style: { flex: 1, minWidth: 300 } },
      React.createElement(CloudTestingPanel)
    ),

    // ── Divider ──
    React.createElement('div', { style: { width: 1, background: '#e8edf2', alignSelf: 'stretch', flexShrink: 0 } }),

    // ── Right: Wireless ──
    React.createElement('div', { style: { flex: 1, minWidth: 300, display: 'flex', flexDirection: 'column', gap: 14 } },

      // Phone frame
      React.createElement('div', { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 } },
        React.createElement('div', { style: { background: '#1a1a1c', borderRadius: 38, padding: '9px 7px 7px', boxShadow: '0 24px 64px rgba(0,0,0,0.45)' } },
          React.createElement('div', { style: { width: 9, height: 9, borderRadius: '50%', background: '#0a0a0c', border: '1px solid rgba(255,255,255,0.08)', margin: '0 auto 6px' } }),
          React.createElement('div', { style: { borderRadius: 28, overflow: 'hidden', width: 260, height: 500, background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            live
              ? React.createElement('iframe', { src: (serverInput||'https://localhost:8886').trim().replace(/\/$/, ''), title: 'Wireless mirror', style: { width: '100%', height: '100%', border: 'none', display: 'block' }, allow: 'autoplay' })
              : React.createElement('div', { style: { textAlign: 'center', color: 'rgba(175,225,246,0.3)', fontSize: '.74rem', fontFamily: F, padding: 24, lineHeight: 2 } },
                  '\u{1F4E1}', React.createElement('br'), 'My Device', React.createElement('br'), 'Connect then Load'
                )
          ),
          React.createElement('div', { style: { display: 'flex', justifyContent: 'center', gap: 26, padding: '7px 0 2px' } },
            ['\u25C1','\u25CB','\u25A1'].map(function(s) { return React.createElement('span', { key: s, style: { fontSize: 13, color: 'rgba(255,255,255,0.25)' } }, s); })
          )
        ),
        React.createElement('div', { style: { display: 'flex', gap: 6, width: 278 } },
          React.createElement('input', { value: serverInput, onChange: function(e) { setServerInput(e.target.value); }, placeholder: 'https://localhost:8886', style: { flex: 1, padding: '5px 8px', borderRadius: 6, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.71rem', outline: 'none' } }),
          React.createElement('button', { onClick: function() { setLive(true); }, style: { padding: '5px 12px', borderRadius: 6, background: t.accent, color: '#E0F5FC', border: 'none', fontFamily: F, fontSize: '.71rem', fontWeight: 700, cursor: 'pointer' } }, '\u25ba Load'),
          live && React.createElement('button', { onClick: function() { setLive(false); }, style: { padding: '5px 8px', borderRadius: 6, background: '#e8edf2', color: '#5a7a8a', border: 'none', fontFamily: F, fontSize: '.71rem', cursor: 'pointer' } }, 'Stop')
        )
      ),

      // QR code
      React.createElement(WirelessQR),

      // ADB commands card
      React.createElement('div', { style: { background: t.panel, borderRadius: 12, padding: '14px 16px', boxShadow: '0 1px 3px rgba(15,30,40,0.07), 0 0 0 1px rgba(15,30,40,0.04)' } },
        React.createElement('div', { style: { fontSize: '.80rem', fontWeight: 700, color: '#0d1d2b', marginBottom: 2, fontFamily: F } }, 'Wireless ADB'),
        React.createElement('div', { style: { fontSize: '.70rem', color: '#6F8FA7', marginBottom: 10, fontFamily: F } }, 'Settings \u2192 Developer Options \u2192 Wireless debugging \u2192 ON'),
        React.createElement('div', { style: { fontSize: '.66rem', fontWeight: 700, color: '#9aabba', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 4, fontFamily: F } }, 'Step 1 \u2014 Pair'),
        React.createElement('div', { style: row },
          React.createElement('div', { style: cmd }, 'adb pair 192.168.100.100:PORT CODE'),
          React.createElement('button', { onClick: function() { copy('adb pair 192.168.100.100:PORT CODE', 'pair'); }, style: cpBtn('pair') }, copied==='pair' ? '\u2713' : 'Copy')
        ),
        React.createElement('div', { style: { fontSize: '.66rem', fontWeight: 700, color: '#9aabba', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 4, fontFamily: F } }, 'Step 2 \u2014 Connect'),
        React.createElement('div', { style: row },
          React.createElement('div', { style: cmd }, 'adb connect 192.168.100.100:PORT'),
          React.createElement('button', { onClick: function() { copy('adb connect 192.168.100.100:PORT', 'conn'); }, style: cpBtn('conn') }, copied==='conn' ? '\u2713' : 'Copy')
        ),
        React.createElement('div', { style: { borderTop: `1px solid ${t.bd}`, margin: '8px 0' } }),
        React.createElement('div', { style: { fontSize: '.66rem', fontWeight: 700, color: '#9aabba', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 4, fontFamily: F } }, 'Script \u2014 connect only'),
        React.createElement('div', { style: row },
          React.createElement('div', { style: cmd }, cs),
          React.createElement('button', { onClick: function() { copy(cs, 'cs'); }, style: cpBtn('cs') }, copied==='cs' ? '\u2713' : 'Copy')
        ),
        React.createElement('div', { style: { fontSize: '.66rem', fontWeight: 700, color: '#9aabba', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 4, fontFamily: F } }, 'Script \u2014 build + install'),
        React.createElement('div', { style: row },
          React.createElement('div', { style: cmd }, bs),
          React.createElement('button', { onClick: function() { copy(bs, 'bs'); }, style: cpBtn('bs') }, copied==='bs' ? '\u2713' : 'Copy')
        )
      )
    )
  );
}

function WirelessPanel({ serverInput, setServerInput }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [copied, setCopied] = React.useState(null);
  var [live, setLive] = React.useState(false);
  function copy(text, key) {
    navigator.clipboard.writeText(text).then(function() {
      setCopied(key); setTimeout(function() { setCopied(null); }, 1800);
    });
  }
  var cmd = { background: '#0d1d2b', borderRadius: 8, padding: '10px 14px', fontFamily: 'monospace', fontSize: '.72rem', color: '#AFE1F6', wordBreak: 'break-all', flex: 1, lineHeight: 1.6 };
  var row = { display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 10 };
  var cpBtn = function(k) { return { padding: '6px 10px', borderRadius: 6, border: 'none', background: copied===k ? '#1D9E75' : '#314F5C', color: '#E0F5FC', fontFamily: F, fontSize: '.72rem', cursor: 'pointer', flexShrink: 0, fontWeight: 600, minWidth: 60 }; };
  var cs = 'powershell -ExecutionPolicy Bypass -File "C:\\Users\\jenni\\Documents\\Sanoire\\sanoire-app\\sanoire-android.ps1"';
  var bs = 'powershell -ExecutionPolicy Bypass -File "C:\\Users\\jenni\\Documents\\Sanoire\\sanoire-app\\sanoire-android.ps1" -build';
  return React.createElement('div', { style: { display: 'flex', gap: 16, alignItems: 'flex-start', flexWrap: 'wrap' } },
    React.createElement('div', { style: { flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 } },
      React.createElement('div', { style: { background: '#1a1a1c', borderRadius: 38, padding: '9px 7px 7px', boxShadow: '0 24px 64px rgba(0,0,0,0.45)' } },
        React.createElement('div', { style: { width: 9, height: 9, borderRadius: '50%', background: '#0a0a0c', border: '1px solid rgba(255,255,255,0.08)', margin: '0 auto 6px' } }),
        React.createElement('div', { style: { borderRadius: 28, overflow: 'hidden', width: 300, height: 580, background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
          live
            ? React.createElement('iframe', { src: (serverInput||'https://localhost:8886').trim().replace(/\/$/, ''), title: 'Wireless mirror', style: { width: '100%', height: '100%', border: 'none', display: 'block' }, allow: 'autoplay' })
            : React.createElement('div', { style: { textAlign: 'center', color: 'rgba(175,225,246,0.3)', fontSize: '.76rem', fontFamily: F, padding: 24, lineHeight: 2 } }, 'Wireless', React.createElement('br'), 'Connect then Load')
        ),
        React.createElement('div', { style: { display: 'flex', justifyContent: 'center', gap: 26, padding: '7px 0 2px' } },
          ['\u25C1','\u25CB','\u25A1'].map(function(s) { return React.createElement('span', { key: s, style: { fontSize: 13, color: 'rgba(255,255,255,0.25)' } }, s); })
        )
      ),
      React.createElement('div', { style: { display: 'flex', gap: 6, width: 318 } },
        React.createElement('input', { value: serverInput, onChange: function(e) { setServerInput(e.target.value); }, placeholder: 'https://localhost:8886', style: { flex: 1, padding: '6px 9px', borderRadius: 6, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.72rem', outline: 'none' } }),
        React.createElement('button', { onClick: function() { setLive(true); }, style: { padding: '6px 14px', borderRadius: 6, background: t.accent, color: '#E0F5FC', border: 'none', fontFamily: F, fontSize: '.72rem', fontWeight: 700, cursor: 'pointer' } }, '\u25ba Load'),
        live && React.createElement('button', { onClick: function() { setLive(false); }, style: { padding: '6px 10px', borderRadius: 6, background: '#e8edf2', color: '#5a7a8a', border: 'none', fontFamily: F, fontSize: '.72rem', cursor: 'pointer' } }, 'Stop')
      )
    ),
    React.createElement('div', { style: { flex: 1, minWidth: 280 } },
      React.createElement('div', { style: { background: t.panel, borderRadius: 12, padding: '16px 18px', boxShadow: '0 1px 3px rgba(15,30,40,0.07), 0 0 0 1px rgba(15,30,40,0.04)' } },
        React.createElement('div', { style: { fontSize: '.82rem', fontWeight: 700, color: '#0d1d2b', marginBottom: 2, fontFamily: F } }, 'Wireless ADB'),
        React.createElement('div', { style: { fontSize: '.72rem', color: '#6F8FA7', marginBottom: 14, fontFamily: F } }, 'Settings \u2192 Developer Options \u2192 Wireless debugging \u2192 ON'),
        React.createElement('div', { style: { fontSize: '.68rem', fontWeight: 700, color: '#9aabba', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 5, fontFamily: F } }, 'Step 1 \u2014 Pair'),
        React.createElement('div', { style: row },
          React.createElement('div', { style: cmd }, 'adb pair 192.168.100.100:PORT CODE'),
          React.createElement('button', { onClick: function() { copy('adb pair 192.168.100.100:PORT CODE', 'pair'); }, style: cpBtn('pair') }, copied==='pair' ? '\u2713' : 'Copy')
        ),
        React.createElement('div', { style: { fontSize: '.68rem', fontWeight: 700, color: '#9aabba', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 5, fontFamily: F } }, 'Step 2 \u2014 Connect'),
        React.createElement('div', { style: row },
          React.createElement('div', { style: cmd }, 'adb connect 192.168.100.100:PORT'),
          React.createElement('button', { onClick: function() { copy('adb connect 192.168.100.100:PORT', 'conn'); }, style: cpBtn('conn') }, copied==='conn' ? '\u2713' : 'Copy')
        ),
        React.createElement('div', { style: { borderTop: `1px solid ${t.bd}`, margin: '10px 0' } }),
        React.createElement('div', { style: { fontSize: '.68rem', fontWeight: 700, color: '#9aabba', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 5, fontFamily: F } }, 'Script \u2014 connect only'),
        React.createElement('div', { style: row },
          React.createElement('div', { style: cmd }, cs),
          React.createElement('button', { onClick: function() { copy(cs, 'cs'); }, style: cpBtn('cs') }, copied==='cs' ? '\u2713' : 'Copy')
        ),
        React.createElement('div', { style: { fontSize: '.68rem', fontWeight: 700, color: '#9aabba', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 5, fontFamily: F } }, 'Script \u2014 connect + build + install'),
        React.createElement('div', { style: row },
          React.createElement('div', { style: cmd }, bs),
          React.createElement('button', { onClick: function() { copy(bs, 'bs'); }, style: cpBtn('bs') }, copied==='bs' ? '\u2713' : 'Copy')
        )
      )
    )
  );
}

function CloudTestingPanel() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  // LambdaTest credentials moved to server side (api/lambdatest-*.js).
  // All LT API calls go through the Vercel proxy to avoid CORS + keep creds off the browser.
  var DEFAULT_APP_ID = 'APP10160371691775702177773115';
  var SB_URL_LOCAL  = 'https://dekxnqbjzgkvltclthqw.supabase.co';

  var DEVICES = [
    { brand:'Samsung',  name:'Galaxy S26 Ultra',    os:'16', popular:true  },
    { brand:'Samsung',  name:'Galaxy S25 Ultra',    os:'16', popular:true  },
    { brand:'Samsung',  name:'Galaxy S24 Ultra',    os:'14', popular:false },
    { brand:'Samsung',  name:'Galaxy S23 Ultra',    os:'13', popular:false },
    { brand:'Samsung',  name:'Galaxy S23',          os:'13', popular:false },
    { brand:'Samsung',  name:'Galaxy A32',          os:'11', popular:false },
    { brand:'Google',   name:'Pixel 9 Pro',         os:'15', popular:true  },
    { brand:'Google',   name:'Pixel 8 Pro',         os:'14', popular:false },
    { brand:'Google',   name:'Pixel 7',             os:'13', popular:false },
    { brand:'OnePlus',  name:'OnePlus 12',          os:'14', popular:false },
    { brand:'Xiaomi',   name:'Redmi Note 12',       os:'13', popular:false },
    { brand:'Oppo',     name:'Oppo Reno8',          os:'13', popular:false },
    { brand:'Motorola', name:'Moto G71 5G',         os:'11', popular:false },
  ];

  var CHECKLIST = [
    { id:'launch',  label:'App launches without errors' },
    { id:'login',   label:'Login / sign up works' },
    { id:'search',  label:'Search returns results' },
    { id:'map',     label:'Map loads with pins' },
    { id:'card',    label:'Location cards open correctly' },
    { id:'sana',    label:'Sana AI responds' },
    { id:'nav',     label:'Bottom navigation works' },
    { id:'account', label:'Account screen loads' },
    { id:'pass',    label:'Pass / subscription visible' },
    { id:'visual',  label:'No visual glitches' },
  ];

  // ── State ───────────────────────────────────────────────────────────────────
  var [apps,        setApps]       = useState([]);
  var [appsLoading, setAppsLoading]= useState(true);
  var [selectedApp, setSelectedApp]= useState(null);
  var [selectedDev, setSelectedDev]= useState(function() {
    try { return JSON.parse(localStorage.getItem('lt_last_device')||'null') || DEVICES[0]; } catch(_){ return DEVICES[0]; }
  });
  var [showPicker,  setShowPicker] = useState(false);
  var [devFilter,   setDevFilter]  = useState('Popular');
  var [devSearch,   setDevSearch]  = useState('');
  var [uploading,   setUploading]  = useState(false);
  var [uploadMsg,   setUploadMsg]  = useState(null);

  // Session state — persisted across navigations
  var [session, setSession] = useState(function() {
    try { return JSON.parse(localStorage.getItem('lt_active_session')||'null'); } catch(_){ return null; }
  });
  var [checklist, setChecklist] = useState(function() {
    try { return JSON.parse(localStorage.getItem('lt_checklist')||'{}'); } catch(_){ return {}; }
  });
  var [elapsed, setElapsed] = useState(0);

  // Inline bug filing
  var [bugInput,  setBugInput]  = useState('');
  var [bugPrio,   setBugPrio]   = useState('high');
  var [latestApp,  setLatestApp]  = useState(null); // always the newest uploaded APK
  var [filing,    setFiling]    = useState(false);
  var [filed,     setFiled]     = useState(null);

  // Supabase-stored app_id (dynamically fetched — overrides DEFAULT_APP_ID)
  var [sbAppId,          setSbAppId]         = useState(null);
  var [sbAppIdUpdatedAt, setSbAppIdUpdatedAt] = useState(null);
  var [sbAppIdLoading,   setSbAppIdLoading]   = useState(true);
  var [sbAppIdError,     setSbAppIdError]     = useState(null);

  // Window ref — tracks the LambdaTest tab so we can detect when it's closed
  var ltWindowRef = React.useRef(null);

  // Post-session summary shown after a session ends
  var [sessionEnded, setSessionEnded] = useState(null); // { device, os, apk, duration, checks }

  // Team — who else is testing (stored in Supabase app_config)
  var [teamSessions, setTeamSessions] = useState([]);

  // Past sessions log
  var [pastSessions, setPastSessions] = useState(function() {
    try { return JSON.parse(localStorage.getItem('lt_past_sessions')||'[]'); } catch(_){ return []; }
  });

  // ── Effects ─────────────────────────────────────────────────────────────────
  useEffect(function() { fetchLatestApp(); loadTeamSessions(); fetchSupabaseAppId(); }, []); // eslint-disable-line

  // Tick elapsed time
  useEffect(function() {
    if (!session) return;
    setElapsed(Math.floor((Date.now() - session.startedAt) / 1000));
    var iv = setInterval(function() {
      setElapsed(Math.floor((Date.now() - session.startedAt) / 1000));
    }, 1000);
    return function() { clearInterval(iv); };
  }, [session]);

  // Broadcast presence to team every 15s while session active
  useEffect(function() {
    if (!session) return;
    broadcastPresence();
    var iv = setInterval(broadcastPresence, 15000);
    return function() { clearInterval(iv); };
  }, [session]); // eslint-disable-line

  // Poll every 2s — auto-end session when the LambdaTest tab is closed
  useEffect(function() {
    if (!session) return;
    var iv = setInterval(function() {
      if (ltWindowRef.current && ltWindowRef.current.closed) {
        clearInterval(iv);
        endSession();
      }
    }, 2000);
    return function() { clearInterval(iv); };
  }, [session]); // eslint-disable-line

  // ── Data functions ───────────────────────────────────────────────────────────
  async function loadApps() {
    setAppsLoading(true);
    try {
      var r = await fetch('/api/lambdatest-apps');
      var data = await r.json();
      var list = data.data || [];
      setApps(list);
      var lastApp = null;
      try { lastApp = JSON.parse(localStorage.getItem('lt_last_app')||'null'); } catch(_) {}
      setSelectedApp((lastApp && list.find(function(a){ return a.app_id === lastApp.app_id; })) || list.find(function(a){ return a.app_id === (sbAppId || DEFAULT_APP_ID); }) || list[0] || null);
    } catch(_e) { setApps([]); }
    finally { setAppsLoading(false); }
  }

  async function loadTeamSessions() {
    try {
      var r = await fetch(SB_URL_LOCAL + '/rest/v1/app_config?key=eq.lt_team_sessions&select=value', {
        headers: { apikey: SB_ANON, Authorization: 'Bearer ' + SB_ANON }
      });
      var data = await r.json();
      if (data && data[0] && data[0].value) {
        var sessions = JSON.parse(data[0].value);
        // Filter to sessions active in last 10 minutes
        var active = sessions.filter(function(s) { return Date.now() - s.lastSeen < 600000; });
        setTeamSessions(active);
      }
    } catch(_e) {}
  }

  async function broadcastPresence() {
    if (!session) return;
    try {
      var allSessions = teamSessions.filter(function(s) { return s.user !== (session.user||'You') && Date.now() - s.lastSeen < 600000; });
      allSessions.push({ user: session.user || 'You', device: session.device, apk: session.apk, lastSeen: Date.now() });
      await fetch(SB_URL_LOCAL + '/rest/v1/app_config', {
        method: 'POST',
        headers: { apikey: SB_ANON, Authorization: 'Bearer ' + SB_ANON, 'Content-Type': 'application/json', Prefer: 'resolution=merge-duplicates,return=minimal' },
        body: JSON.stringify({ key: 'lt_team_sessions', value: JSON.stringify(allSessions) })
      });
    } catch(_e) {}
  }

  async function uploadApk(file) {
    setUploading(true); setUploadMsg(null);
    try {
      var fd = new FormData(); fd.append('appFile', file); fd.append('name', file.name);
      var r = await fetch('/api/lambdatest-upload', { method:'POST', body: fd });
      var data = await r.json();
      if (data.app_id || data.app_url) { setUploadMsg({ ok:true, text:'\u2713 Uploaded' }); await loadApps(); }
      else setUploadMsg({ ok:false, text: data.message || 'Upload failed' });
    } catch(err) { setUploadMsg({ ok:false, text: err.message }); }
    finally { setUploading(false); }
  }

  async function fetchSupabaseAppId() {
    setSbAppIdLoading(true); setSbAppIdError(null);
    try {
      var r = await fetch(SB_URL_LOCAL + '/rest/v1/app_config?key=eq.lambdatest_app_id&select=value,updated_at', {
        headers: { apikey: SB_ANON, Authorization: 'Bearer ' + SB_ANON }
      });
      var data = await r.json();
      if (data && data[0] && data[0].value) {
        setSbAppId(data[0].value);
        setSbAppIdUpdatedAt(data[0].updated_at);
      } else {
        setSbAppIdError('No app_id row in app_config — using built-in fallback');
      }
    } catch (_e) { setSbAppIdError('Failed to fetch app_id from Supabase'); }
    finally { setSbAppIdLoading(false); }
  }

  function selectDev(dev) { setSelectedDev(dev); localStorage.setItem('lt_last_device', JSON.stringify(dev)); setShowPicker(false); }
  function selectApp(app) { setSelectedApp(app); localStorage.setItem('lt_last_app', JSON.stringify(app)); }

  async function fetchLatestApp() {
    try {
      var r = await fetch('/api/lambdatest-apps');
      var data = await r.json();
      var list = data.data || [];
      // Sort by updated_at desc — most recently uploaded first
      list.sort(function(a, b) { return new Date(b.updated_at) - new Date(a.updated_at); });
      if (list[0]) setLatestApp(list[0]);
    } catch (_e) {}
  }

  function startSession() {
    // Use sbAppId from Supabase (updated by CI on every build), fall back to hardcoded default
    var rawId = sbAppId || DEFAULT_APP_ID;
    // LambdaTest requires the lt:// prefix for auto-install on /app endpoint
    var appId = rawId.startsWith('lt://') ? rawId : 'lt://' + rawId;
    var apkName = latestApp ? latestApp.name : 'latest build';
    var url = 'https://applive.lambdatest.com/app' +
      '?os=android' +
      '&device=Galaxy+S26+Ultra' +
      '&osVersion=16' +
      '&appId=' + encodeURIComponent(appId);
    var win = window.open(url, '_blank');
    ltWindowRef.current = win;
    var s = { device: 'Galaxy S26 Ultra', brand: 'Samsung', os: '16', apk: apkName, startedAt: Date.now(), user: 'You' };
    setSession(s); localStorage.setItem('lt_active_session', JSON.stringify(s));
    setChecklist({}); localStorage.setItem('lt_checklist', '{}');
    setElapsed(0); setFiled(null); setSessionEnded(null);
  }

  function endSession() {
    // Close the LambdaTest tab if it's still open
    if (ltWindowRef.current && !ltWindowRef.current.closed) {
      try { ltWindowRef.current.close(); } catch(_e) {}
    }
    ltWindowRef.current = null;
    if (session) {
      var endedAt = Date.now();
      var durationSecs = Math.round((endedAt - session.startedAt) / 1000);
      var checks = Object.values(checklist).filter(Boolean).length;
      var past = [Object.assign({}, session, { endedAt: endedAt, checklist: checklist })].concat(pastSessions).slice(0,10);
      setPastSessions(past); localStorage.setItem('lt_past_sessions', JSON.stringify(past));
      setSessionEnded({ device: session.device, os: session.os, apk: session.apk, duration: durationSecs, checks: checks });
    }
    setSession(null); localStorage.removeItem('lt_active_session');
    setChecklist({}); localStorage.removeItem('lt_checklist');
  }

  function toggleCheck(id) {
    setChecklist(function(c) {
      var next = Object.assign({}, c, { [id]: !c[id] });
      localStorage.setItem('lt_checklist', JSON.stringify(next));
      return next;
    });
  }

  async function fileBug() {
    if (!bugInput.trim() || filing) return;
    setFiling(true);
    try {
      await fetch(SB_URL_LOCAL + '/rest/v1/app_bugs', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', apikey:SB_ANON, Authorization:'Bearer '+SB_ANON, Prefer:'return=minimal' },
        body: JSON.stringify({
          title: bugInput.trim(),
          description: 'Found during cloud session on ' + (session||{}).device + ' (Android ' + (session||{}).os + ')\nAPK: ' + (session||{}).apk,
          platform:'Android', priority: bugPrio, status:'open', reporter_name:'Cloud Session',
        })
      });
      setFiled(bugInput.trim()); setBugInput('');
      setTimeout(function(){ setFiled(null); }, 3000);
    } catch(_e) {}
    setFiling(false);
  }

  function fmtTime(s) {
    var m = Math.floor(s/60); var ss = s%60;
    return (m>0 ? m+'m ' : '') + ss + 's';
  }
  function timeAgo(ts) {
    var ago = Math.round((Date.now()-ts)/60000);
    return ago < 1 ? 'just now' : ago < 60 ? ago+'m ago' : Math.round(ago/60)+'h ago';
  }

  var checkedCount = CHECKLIST.filter(function(item){ return checklist[item.id]; }).length;
  var filteredDevs = DEVICES.filter(function(d) {
    if (devFilter === 'Popular' && !d.popular) return false;
    if (devSearch && !d.name.toLowerCase().includes(devSearch.toLowerCase())) return false;
    return true;
  });

  // ── PHASE 1: NO ACTIVE REAL-DEVICE SESSION ───────────────────────────────────
  if (!session) {
    return React.createElement('div', { style: { display:'flex', flexDirection:'column', gap:14 } },

      // ── Session-ended summary card (shown immediately after a session ends) ──
      sessionEnded && React.createElement('div', { style: Object.assign({}, CARD(t), { border:'1.5px solid #d1fae5', background:'#f0fdf7', padding:'16px 18px' }) },
        React.createElement('div', { style:{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 } },
          React.createElement('div', { style:{ display:'flex', alignItems:'center', gap:8 } },
            React.createElement('div', { style:{ width:8, height:8, borderRadius:'50%', background:'#6EE7B7' } }),
            React.createElement('div', { style:{ fontSize:'.84rem', fontWeight:700, color:'#065F46' } }, 'Session ended')
          ),
          React.createElement('button', { onClick:function(){ setSessionEnded(null); },
            style:{ background:'none', border:'none', cursor:'pointer', fontSize:'.7rem', color:'#9aabba', fontFamily:F, padding:'2px 6px' }
          }, '\u2715')
        ),
        React.createElement('div', { style:{ fontSize:'.75rem', color:'#374151', marginBottom:12, lineHeight:1.6 } },
          React.createElement('span', { style:{ fontWeight:600 } }, sessionEnded.device),
          ' \u00b7 Android ' + sessionEnded.os,
          React.createElement('br', null),
          (function() {
            var m = Math.floor(sessionEnded.duration/60); var s = sessionEnded.duration%60;
            return 'Duration: ' + (m>0 ? m+'m ' : '') + s + 's';
          })() + ' \u00b7 ' + sessionEnded.checks + '/10 checks passed'
        ),
        React.createElement('button', { onClick: startSession,
          style:{ width:'100%', padding:'9px', borderRadius:8, border:'none', background:'#1D9E75', color:'#fff', fontFamily:F, fontSize:'.82rem', fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:6 }
        },
          React.createElement('svg', { width:13, height:13, viewBox:'0 0 24 24', fill:'currentColor' },
            React.createElement('path', { d:'M8 5v14l11-7z' })
          ),
          'Relaunch session'
        )
      ),

      // One-click launch card
      React.createElement('div', { style: Object.assign({}, CARD(t), { textAlign:'center', padding:'28px 24px' }) },
        React.createElement('div', { style:{ fontSize:'.88rem', fontWeight:700, color:t.tx, marginBottom:4 } }, 'Real Device testing'),
        React.createElement('div', { style:{ fontSize:'.73rem', color:'#9aabba', marginBottom:16 } }, 'Real Android hardware — opens in a new tab, ideal for accurate testing'),

        // Device info chip
        React.createElement('div', { style:{ display:'inline-flex', alignItems:'center', gap:8, padding:'7px 16px', background:'#f0f7ff', borderRadius:99, border:'1px solid #c7d7f9', marginBottom:20 } },
          React.createElement('div', { style:{ width:7, height:7, borderRadius:'50%', background:'#1D9E75' } }),
          React.createElement('div', { style:{ fontSize:'.78rem', fontWeight:700, color:t.accent } }, 'Galaxy S26 Ultra'),
          React.createElement('div', { style:{ fontSize:'.72rem', color:t.mut } }, '· Android 16 · ' + (latestApp ? latestApp.name : 'loading...'))
        ),

        // Big launch button
        React.createElement('button', {
          onClick: startSession,
          style:{ width:'100%', padding:'14px', borderRadius:10, border:'none', background:'#1D9E75', color:'#fff', fontFamily:F, fontSize:'.96rem', fontWeight:700, cursor:'pointer', boxShadow:'0 4px 18px rgba(29,158,117,0.35)', transition:'all .15s', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }
        },
          React.createElement('svg', { width:16, height:16, viewBox:'0 0 24 24', fill:'currentColor' },
            React.createElement('path', { d:'M8 5v14l11-7z' })
          ),
          'Start live session'
        ),
        React.createElement('div', { style:{ marginTop:9, fontSize:'.68rem', color:'#b0c4ce' } }, 'Opens instantly on a real Galaxy S26 Ultra. Keep this tab open as mission control.'),
        React.createElement('div', { style:{ marginTop:5, fontSize:'.66rem', color:'#c8d6de' } }, 'Best on desktop Chrome. On mobile: use single slow taps \u2014 hold doesn\u2019t translate to the remote device.'),

        // Supabase app_id status
        sbAppIdLoading
          ? React.createElement('div', { style:{ marginTop:8, fontSize:'.67rem', color:'#9aabba', display:'flex', alignItems:'center', gap:5, justifyContent:'center' } },
              React.createElement('svg', { width:10, height:10, viewBox:'0 0 24 24', fill:'none', stroke:'#9aabba', strokeWidth:2 },
                React.createElement('circle', { cx:12, cy:12, r:10 }),
                React.createElement('path', { d:'M12 6v6l4 2' })
              ),
              'Fetching latest app ID from Supabase...'
            )
          : sbAppIdError
            ? React.createElement('div', { style:{ marginTop:8, fontSize:'.67rem', color:'#f0a960', display:'flex', alignItems:'center', gap:5, justifyContent:'center' } },
                React.createElement('svg', { width:10, height:10, viewBox:'0 0 24 24', fill:'none', stroke:'#f0a960', strokeWidth:2.5 },
                  React.createElement('path', { d:'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z' }),
                  React.createElement('line', { x1:12, y1:9, x2:12, y2:13 }),
                  React.createElement('line', { x1:12, y1:17, x2:'12.01', y2:17 })
                ),
                sbAppIdError
              )
            : React.createElement('div', { style:{ marginTop:8, fontSize:'.67rem', color:'#1D9E75', display:'flex', alignItems:'center', gap:5, justifyContent:'center' } },
                React.createElement('svg', { width:10, height:10, viewBox:'0 0 24 24', fill:'none', stroke:'#1D9E75', strokeWidth:2.5 },
                  React.createElement('path', { d:'M20 6L9 17l-5-5' })
                ),
                'App ID from Supabase',
                sbAppIdUpdatedAt
                  ? React.createElement('span', { style:{ color:'#9aabba' } },
                      '\u00b7 updated ' + (function() {
                        var ms = Date.now() - new Date(sbAppIdUpdatedAt).getTime();
                        var mins = Math.round(ms/60000);
                        if (mins < 1) return 'just now';
                        if (mins < 60) return mins + 'm ago';
                        var hrs = Math.round(mins/60);
                        if (hrs < 24) return hrs + 'h ago';
                        return Math.round(hrs/24) + 'd ago';
                      })()
                    )
                  : null
              )
      ),

      // Team testing now
      teamSessions.length > 0 && React.createElement('div', { style:Object.assign({}, CARD(t)) },
        React.createElement('div', { style:{ fontSize:'.82rem', fontWeight:700, color:t.tx, marginBottom:10 } }, 'Team testing now'),
        teamSessions.map(function(s) {
          return React.createElement('div',{ key:s.user, style:{ display:'flex', alignItems:'center', gap:8, padding:'7px 0', borderBottom:'1px solid #f0f2f4' } },
            React.createElement('div', { style:{ width:7, height:7, borderRadius:'50%', background:'#1D9E75', flexShrink:0 } }),
            React.createElement('div', { style:{ flex:1, fontSize:'.76rem', color:t.tx, fontWeight:600 } }, s.user),
            React.createElement('div', { style:{ fontSize:'.7rem', color:'#9aabba' } }, s.device + ' · ' + timeAgo(s.lastSeen))
          );
        })
      ),

      // Past sessions
      pastSessions.length > 0 && React.createElement('div', { style:Object.assign({}, CARD(t), { padding:0, overflow:'hidden' }) },
        React.createElement('div', { style:{ padding:'12px 16px', borderBottom:'1px solid #f0f2f4', display:'flex', alignItems:'center', justifyContent:'space-between' } },
          React.createElement('div', { style:{ fontSize:'.82rem', fontWeight:700, color:t.tx } }, 'Past sessions'),
          React.createElement('button', { onClick:function(){ setPastSessions([]); localStorage.removeItem('lt_past_sessions'); }, style:{ background:'none', border:'none', cursor:'pointer', fontSize:'.7rem', color:'#9aabba', fontFamily:F } }, 'Clear')
        ),
        pastSessions.slice(0,5).map(function(s, i) {
          var dur = s.endedAt ? Math.round((s.endedAt-s.startedAt)/60000) : null;
          var chk = Object.values(s.checklist||{}).filter(Boolean).length;
          return React.createElement('div',{ key:i, style:{ padding:'10px 16px', borderBottom:i<pastSessions.length-1?'1px solid #f8f8f8':'none' } },
            React.createElement('div', { style:{ display:'flex', alignItems:'center', justifyContent:'space-between' } },
              React.createElement('div', { style:{ fontSize:'.76rem', fontWeight:600, color:t.tx } }, s.device),
              React.createElement('div', { style:{ fontSize:'.68rem', color:'#9aabba' } }, timeAgo(s.startedAt) + (dur ? ' · ' + dur + 'min' : ''))
            ),
            React.createElement('div', { style:{ fontSize:'.7rem', color:t.mut, marginTop:2 } }, chk + '/10 checks passed')
          );
        })
      )
    );
  }

  // ── PHASE 2: ACTIVE SESSION — MISSION CONTROL ───────────────────────────────
  return React.createElement('div', { style:{ display:'flex', flexDirection:'column', gap:14 } },

    // Keyframe injection for pulsing dot
    React.createElement('style', null, '@keyframes ltPulse{0%,100%{box-shadow:0 0 0 0 rgba(29,158,117,0.5)}60%{box-shadow:0 0 0 7px rgba(29,158,117,0)}}'),

    // Session status bar
    React.createElement('div', { style:Object.assign({}, CARD(t), { border:'2px solid #1D9E75', padding:'14px 16px' }) },
      React.createElement('div', { style:{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 } },
        React.createElement('div', { style:{ display:'flex', alignItems:'center', gap:8 } },
          React.createElement('div', { style:{ width:10, height:10, borderRadius:'50%', background:'#1D9E75', animation:'ltPulse 2s ease-in-out infinite', flexShrink:0 } }),
          React.createElement('div', null,
            React.createElement('div', { style:{ fontSize:'.86rem', fontWeight:700, color:t.tx } }, 'Session active'),
            React.createElement('div', { style:{ fontSize:'.72rem', color:t.mut } }, session.device + ' \u00b7 Android ' + session.os + ' \u00b7 ' + session.apk)
          )
        ),
        React.createElement('div', { style:{ textAlign:'right' } },
          React.createElement('div', { style:{ fontSize:'1.1rem', fontWeight:700, color:'#1D9E75', fontFamily:'monospace' } }, fmtTime(elapsed)),
          React.createElement('div', { style:{ fontSize:'.68rem', color:'#9aabba' } }, 'elapsed')
        )
      ),
      React.createElement('div', { style:{ display:'flex', gap:8 } },
        React.createElement('a', { href:'https://applive.lambdatest.com/app', target:'_blank', rel:'noreferrer',
          style:{ flex:1, padding:'8px', borderRadius:7, border:'1.5px solid #1D9E75', background:'#E1F5EE', color:'#065F46', fontFamily:F, fontSize:'.78rem', fontWeight:700, textDecoration:'none', textAlign:'center' }
        }, '\u21aa Return to LambdaTest'),
        React.createElement('button', { onClick: endSession,
          style:{ padding:'8px 14px', borderRadius:7, border:'1.5px solid #fca5a5', background:'#FCEBEB', color:'#c0392b', fontFamily:F, fontSize:'.76rem', fontWeight:700, cursor:'pointer', flexShrink:0 }
        }, 'End session')
      )
    ),

    // Inline bug filing
    React.createElement('div', { style:Object.assign({}, CARD(t)) },
      React.createElement('div', { style:{ fontSize:'.82rem', fontWeight:700, color:t.tx, marginBottom:10 } }, 'File a bug'),
      React.createElement('div', { style:{ display:'flex', gap:7, marginBottom:7 } },
        React.createElement('input', { value:bugInput, onChange:function(e){ setBugInput(e.target.value); }, onKeyDown:function(e){ if(e.key==='Enter') fileBug(); },
          placeholder:'Describe what went wrong...',
          style:{ flex:1, padding:'8px 10px', borderRadius:7, border:'1.5px solid #dde4ea', fontFamily:F, fontSize:'.78rem', outline:'none' }
        }),
        React.createElement('select', { value:bugPrio, onChange:function(e){ setBugPrio(e.target.value); },
          style:{ padding:'8px', borderRadius:7, border:'1.5px solid #dde4ea', fontFamily:F, fontSize:'.74rem', outline:'none', cursor:'pointer', color:t.accent, fontWeight:600 }
        },
          [['critical','Critical'],['high','High'],['medium','Medium'],['low','Low']].map(function(p){ return React.createElement('option',{ key:p[0], value:p[0] }, p[1]); })
        ),
        React.createElement('button', { onClick:fileBug, disabled:!bugInput.trim()||filing,
          style:{ padding:'8px 14px', borderRadius:7, border:'none', background:bugInput.trim()?'#314F5C':'#e8eef2', color:bugInput.trim()?'#fff':'#9aabba', fontFamily:F, fontSize:'.76rem', fontWeight:700, cursor:bugInput.trim()?'pointer':'not-allowed', flexShrink:0 }
        }, filing?'...':'File bug')
      ),
      filed && React.createElement('div', { style:{ fontSize:'.74rem', color:'#1D9E75', fontWeight:600 } }, '\u2713 Bug filed \u2014 visible in the Bugs tab'),
      React.createElement('div', { style:{ fontSize:'.7rem', color:'#9aabba' } }, 'Press Enter or click File bug. Goes straight to the Bugs tab with this session\'s device info.')
    ),

    // Testing checklist
    React.createElement('div', { style:Object.assign({}, CARD(t)) },
      React.createElement('div', { style:{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 } },
        React.createElement('div', { style:{ fontSize:'.82rem', fontWeight:700, color:t.tx } }, 'Test checklist'),
        React.createElement('div', { style:{ display:'flex', alignItems:'center', gap:8 } },
          React.createElement('div', { style:{ fontSize:'.78rem', fontWeight:700, color: checkedCount===CHECKLIST.length?'#1D9E75':'#9aabba' } }, checkedCount+'/'+CHECKLIST.length),
          checkedCount === CHECKLIST.length && React.createElement('div', { style:{ fontSize:'.7rem', fontWeight:700, color:'#1D9E75', background:'#E1F5EE', padding:'2px 8px', borderRadius:99 } }, 'Complete')
        )
      ),
      // Progress bar
      React.createElement('div', { style:{ height:4, background:'#f0f2f4', borderRadius:99, marginBottom:12, overflow:'hidden' } },
        React.createElement('div', { style:{ height:'100%', width:(checkedCount/CHECKLIST.length*100)+'%', background:'#1D9E75', borderRadius:99, transition:'width .3s' } })
      ),
      React.createElement('div', { style:{ display:'flex', flexDirection:'column', gap:6 } },
        CHECKLIST.map(function(item) {
          var done = !!checklist[item.id];
          return React.createElement('div', { key:item.id, onClick:function(){ toggleCheck(item.id); },
            style:{ display:'flex', alignItems:'center', gap:9, padding:'7px 10px', borderRadius:7, cursor:'pointer', background:done?'#E1F5EE':'#f8fafc', border:'1px solid '+(done?'#6EE7B7':'#edf0f3'), transition:'all .12s' }
          },
            React.createElement('div', { style:{ width:17, height:17, borderRadius:4, border:'1.5px solid '+(done?'#1D9E75':'#c0c8d0'), background:done?'#1D9E75':'#fff', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, transition:'all .12s' } },
              done && React.createElement('svg',{ width:10, height:10, viewBox:'0 0 12 12', fill:'none' },
                React.createElement('polyline',{ points:'2,6 5,9 10,3', stroke:'#fff', strokeWidth:2, strokeLinecap:'round', strokeLinejoin:'round' })
              )
            ),
            React.createElement('span', { style:{ fontSize:'.76rem', color:done?'#065F46':'#4a6070', textDecoration:done?'line-through':'none', lineHeight:1.4 } }, item.label)
          );
        })
      )
    )
  );
}


function BuildCard({ platform, authorEmail, authorName, compact }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [webEnv, setWebEnv] = useState('production');
  var [droidType, setDroidType] = useState('debug');
  var [status, setStatus] = useState(null);
  var [loading, setLoading] = useState(false);

  var GH_HDR = { 'Authorization': 'token ' + (localStorage.getItem('sanoire_gh_token') || GH_TOKEN), 'Content-Type': 'application/json', 'Accept': 'application/vnd.github+json' };

  async function triggerBuild() {
    setLoading(true); setStatus(null);
    try {
      var isWeb = platform === 'web';
      var workflow = isWeb ? 'deploy-web.yml' : 'build-android.yml';
      var inputs = isWeb
        ? { environment: webEnv, triggered_by: authorName || authorEmail || 'Admin Dashboard' }
        : { build_type: droidType, triggered_by: authorName || authorEmail || 'Admin Dashboard' };
      var resp = await fetch(GH_API + '/actions/workflows/' + workflow + '/dispatches', {
        method: 'POST', headers: GH_HDR,
        body: JSON.stringify({ ref: 'main', inputs: inputs })
      });
      setStatus(resp.status === 204 ? 'started' : 'error');
      if (resp.status === 204) {
        await logActivity({ action: isWeb ? 'web_deploy' : 'android_build', entity: 'builds', summary: (isWeb ? 'Web deploy triggered' : 'Android build triggered') + ' (' + (isWeb ? webEnv : droidType) + ')', author_email: authorEmail, author_name: authorName });
      }
    } catch (_e) { setStatus('error'); }
    finally { setLoading(false); }
  }

  if (compact && platform === 'android') {
    return React.createElement('div', { style: { display: 'flex', gap: 6, alignItems: 'center' } },
      React.createElement('div', { style: { display: 'flex', background: '#f0f4f6', borderRadius: 7, padding: 2, gap: 1 } },
        ['debug','release'].map(function(t) {
          return React.createElement('button', {
            key: t, onClick: function() { setDroidType(t); },
            style: { padding: '4px 10px', borderRadius: 5, border: 'none', fontFamily: F, fontSize: '.72rem', cursor: 'pointer', background: droidType === t ? '#fff' : 'transparent', color: droidType === t ? '#0f1e28' : '#7a9aaa', fontWeight: droidType === t ? 600 : 400, boxShadow: droidType === t ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }
          }, t.charAt(0).toUpperCase()+t.slice(1));
        })
      ),
      React.createElement(Btn, { onClick: triggerBuild, disabled: loading, small: true },
        loading ? 'Triggering...' : '\u25ba Build APK'
      ),
      status === 'started' && React.createElement('div', { style: { fontSize: '.7rem', color: '#1D9E75', fontWeight: 700 } }, '\u2713 Triggered'),
      status === 'error'   && React.createElement('div', { style: { fontSize: '.7rem', color: '#c0392b', fontWeight: 700 } }, 'Failed')
    );
  }

  return React.createElement('div', { style: Object.assign({}, CARD(t)) },
    React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28', marginBottom: 12 } },
      platform === 'web' ? 'Deploy' : 'Build'
    ),
    platform === 'web' && React.createElement('div', { style: { display: 'flex', background: '#f0f4f6', borderRadius: 8, padding: 2, gap: 1, marginBottom: 12, width: 'fit-content' } },
      ['production', 'preview'].map(function(env) {
        return React.createElement('button', {
          key: env, onClick: function() { setWebEnv(env); },
          style: { padding: '4px 12px', borderRadius: 6, border: 'none', fontFamily: F, fontSize: '.74rem', cursor: 'pointer', background: webEnv === env ? '#fff' : 'transparent', color: webEnv === env ? '#0f1e28' : '#7a9aaa', fontWeight: webEnv === env ? 600 : 400, boxShadow: webEnv === env ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }
        }, env.charAt(0).toUpperCase() + env.slice(1));
      })
    ),
    platform === 'android' && React.createElement('div', { style: { display: 'flex', background: '#f0f4f6', borderRadius: 8, padding: 2, gap: 1, marginBottom: 12, width: 'fit-content' } },
      ['debug', 'release'].map(function(t) {
        return React.createElement('button', {
          key: t, onClick: function() { setDroidType(t); },
          style: { padding: '4px 12px', borderRadius: 6, border: 'none', fontFamily: F, fontSize: '.74rem', cursor: 'pointer', background: droidType === t ? '#fff' : 'transparent', color: droidType === t ? '#0f1e28' : '#7a9aaa', fontWeight: droidType === t ? 600 : 400, boxShadow: droidType === t ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }
        }, t.charAt(0).toUpperCase() + t.slice(1));
      })
    ),
    React.createElement('div', { style: { display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' } },
      React.createElement(Btn, { onClick: triggerBuild, disabled: loading },
        loading ? 'Triggering...' : platform === 'web' ? '\u25ba Deploy web app' : '\u25ba Build Android APK'
      ),
      platform === 'web' && React.createElement('a', { href: 'https://vercel.com/sanoire/sanoire-app/deployments', target: '_blank', rel: 'noreferrer', style: { fontSize: '.74rem', color: '#6F8FA7', textDecoration: 'none', fontFamily: F } }, 'View Vercel \u2197'),
      platform === 'android' && React.createElement('a', { href: 'https://applive.lambdatest.com/app', target: '_blank', rel: 'noreferrer', style: { fontSize: '.74rem', color: '#6F8FA7', textDecoration: 'none', fontFamily: F } }, 'Open on cloud device \u2197')
    ),
    status === 'started' && React.createElement('div', { style: { marginTop: 10, fontSize: '.76rem', color: '#1D9E75' } }, '\u2713 Triggered \u2014 check Recent builds below for progress'),
    status === 'error' && React.createElement('div', { style: { marginTop: 10, fontSize: '.76rem', color: '#c0392b' } }, 'Failed to trigger. Check the GitHub token has workflow scope.')
  );
}

// ── LocalBuildCard — PowerShell commands for local build + install ─────────────
function LocalBuildCard() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [copied, setCopied] = React.useState(null);
  function copy(text, key) {
    navigator.clipboard.writeText(text).then(function() {
      setCopied(key); setTimeout(function() { setCopied(null); }, 2000);
    });
  }
  var APP = 'C:\\Users\\jenni\\Documents\\Sanoire\\sanoire-app';
  var PS  = 'powershell -ExecutionPolicy Bypass -File "' + APP + '\\sanoire-android.ps1"';

  var cmds = [
    { key: 'connect',  label: 'Connect wirelessly (no build)',    cmd: PS },
    { key: 'build',    label: 'Connect + build + install',        cmd: PS + ' -build' },
    { key: 'install',  label: 'Install existing APK (no build)',  cmd: 'cd "' + APP + '\\android"; $env:JAVA_HOME="C:\\Program Files\\Android\\Android Studio\\jbr"; $env:PATH="$env:JAVA_HOME\\bin;$env:PATH"; .\\gradlew installDebug' },
    { key: 'uninstall',label: 'Uninstall + reinstall (clean)',    cmd: 'cd "' + APP + '\\android"; $env:JAVA_HOME="C:\\Program Files\\Android\\Android Studio\\jbr"; $env:PATH="$env:JAVA_HOME\\bin;$env:PATH"; .\\gradlew uninstallDebug; .\\gradlew installDebug' },
  ];

  var cmdStyle = {
    background: '#0d1d2b', borderRadius: 7, padding: '8px 12px',
    fontFamily: 'monospace', fontSize: '.68rem', color: '#AFE1F6',
    wordBreak: 'break-all', flex: 1, lineHeight: 1.6,
  };
  var cpBtn = function(k) {
    return {
      padding: '5px 10px', borderRadius: 6, border: 'none', flexShrink: 0,
      background: copied===k ? '#1D9E75' : '#314F5C', color: '#E0F5FC',
      fontFamily: F, fontSize: '.70rem', cursor: 'pointer', fontWeight: 600, minWidth: 58,
    };
  };

  return React.createElement('div', { style: Object.assign({}, CARD(t)) },
    React.createElement('div', { style: { fontSize: '.86rem', fontWeight: 700, color: '#0f1e28', marginBottom: 4 } }, 'Local Build Commands'),
    React.createElement('div', { style: { fontSize: '.72rem', color: '#9aabba', marginBottom: 14 } },
      'Run in PowerShell on your Windows machine. Requires wireless ADB connected first for wireless commands.'
    ),
    cmds.map(function(c) {
      return React.createElement('div', { key: c.key, style: { marginBottom: 10 } },
        React.createElement('div', { style: { fontSize: '.66rem', fontWeight: 700, color: '#9aabba', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 4, fontFamily: F } }, c.label),
        React.createElement('div', { style: { display: 'flex', alignItems: 'flex-start', gap: 7 } },
          React.createElement('div', { style: cmdStyle }, c.cmd),
          React.createElement('button', { onClick: function() { copy(c.cmd, c.key); }, style: cpBtn(c.key) },
            copied===c.key ? '\u2713 Done' : 'Copy'
          )
        )
      );
    })
  );
}

// ── Platform page ─────────────────────────────────────────────────────────────
function PlatformPage({ platform, authorEmail, authorName, onFileBug }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var isWeb     = platform === 'web';
  var isAndroid = platform === 'android';
  var isIos     = platform === 'ios';
  var label     = isWeb ? 'Web' : isAndroid ? 'Android' : 'iOS';
  var bugPlatform = isWeb ? 'Web' : isAndroid ? 'Android' : 'iOS';

  // Lifted Android state — must be before any conditionals (Rules of Hooks)
  var [droidMode,        setDroidMode]        = useState('cloud');
  var [droidLive,        setDroidLive]        = useState(false);
  var [droidServerInput, setDroidServerInput] = useState('https://localhost:8886');
  var droidIsStreaming = droidMode === 'usb' && droidLive;

  if (isIos) {
    return React.createElement('div', { style: { display: 'flex', gap: 20, alignItems: 'flex-start', flexWrap: 'wrap' } },
      React.createElement('div', { style: { flex: 1, minWidth: 300, display: 'flex', flexDirection: 'column', gap: 16 } },
        React.createElement('div', { style: Object.assign({}, CARD(t)) },
          React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28', marginBottom: 8 } }, 'iOS status'),
          React.createElement('div', { style: { display: 'inline-block', padding: '3px 10px', borderRadius: 99, fontSize: '.72rem', fontWeight: 700, background: '#f0f4f6', color: '#9aabba', marginBottom: 12 } }, 'Not yet configured'),
          React.createElement('div', { style: { fontSize: '.78rem', color: '#9aabba', lineHeight: 1.7, marginBottom: 14 } }, 'iOS builds require Xcode signing keys and App Store Connect credentials. Once configured, you can build and deploy iOS directly from this dashboard.'),
          React.createElement(Btn, { onClick: function() {}, variant: 'secondary' }, 'Set up iOS build \u2192')
        ),
        React.createElement(BugMini, { platform: bugPlatform, onFileNew: onFileBug }),
        React.createElement(TestersMini, { platform: 'ios' })
      ),
      React.createElement('div', { style: { width: 300, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 16 } },
        React.createElement(NativeLivePreview, { platform: 'ios' }),
        React.createElement(SentryPanel)
      )
    );
  }

  // Android — lift preview state so layout can react
  if (isAndroid) {
    return React.createElement('div', { style: { display: 'flex', gap: 16, alignItems: 'flex-start', flexWrap: 'wrap' } },
      React.createElement('div', { style: { flex: 1, minWidth: 320, display: 'flex', flexDirection: 'column', gap: 16 } },
        React.createElement(CloudTestingPanel)
      ),
      React.createElement('div', { style: { width: 300, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 16 } },
        React.createElement(BuildCard, { platform: 'android', authorEmail: authorEmail, authorName: authorName }),
        React.createElement(TestersMini, { platform: 'android' }),
        React.createElement(RecentRuns, { workflowFile: 'build-android.yml' }),
        React.createElement(BugMini, { platform: 'Android', onFileNew: onFileBug }),
        React.createElement(ErrorFeed),
        React.createElement(SentryPanel)
      )
    );
  }

  // Web: iframe preview left, deploy/health/sentry right
  return React.createElement('div', { style: { display: 'flex', gap: 20, alignItems: 'flex-start', flexWrap: 'wrap' } },
    React.createElement('div', { style: { flex: 1, minWidth: 300, display: 'flex', flexDirection: 'column', gap: 16 } },
      React.createElement(WebLivePreview),
      React.createElement(BugMini, { platform: bugPlatform, onFileNew: onFileBug })
    ),
    React.createElement('div', { style: { width: 320, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 16 } },
      React.createElement(BuildCard, { platform: platform, authorEmail: authorEmail, authorName: authorName }),
      React.createElement(TestersMini, { platform: platform }),
      React.createElement(HealthMonitor),
      React.createElement(PerformanceMonitor),
      React.createElement(ErrorFeed),
      React.createElement(SentryPanel)
    )
  );
}

// ── Settings modal ────────────────────────────────────────────────────────────
function SettingsModal({ open, onClose }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [innerTab, setInnerTab] = useState('config');

  var INNER_TABS = [
    { id: 'config',   label: 'Remote Config' },
    { id: 'testers',  label: 'Testers' },
    { id: 'activity', label: 'Activity Log' },
  ];

  return React.createElement(Modal, { open: open, onClose: onClose, title: 'App Studio Settings', wide: true },
    React.createElement('div', { style: { display: 'flex', gap: 2, background: '#f0f4f6', borderRadius: 8, padding: 2, marginBottom: 20, width: 'fit-content' } },
      INNER_TABS.map(function(t) {
        return React.createElement('button', {
          key: t.id, onClick: function() { setInnerTab(t.id); },
          style: { padding: '5px 14px', borderRadius: 6, border: 'none', fontFamily: F, fontSize: '.76rem', cursor: 'pointer', background: innerTab === t.id ? '#fff' : 'transparent', color: innerTab === t.id ? '#0f1e28' : '#7a9aaa', fontWeight: innerTab === t.id ? 600 : 400, boxShadow: innerTab === t.id ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }
        }, t.label);
      })
    ),
    innerTab === 'config'   && React.createElement(ConfigPanel),
    innerTab === 'testers'  && React.createElement(TestersPanel),
    innerTab === 'activity' && React.createElement(ActivityPanel)
  );
}

// ── Monaco loader ─────────────────────────────────────────────────────────────
function loadMonaco(cb) {
  if (window.monaco) { cb(window.monaco); return; }
  if (window._monacoLoading) { (window._monacoQ = window._monacoQ || []).push(cb); return; }
  window._monacoLoading = true; window._monacoQ = [cb];
  var s = document.createElement('script');
  s.src = 'https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.44.0/min/vs/loader.min.js';
  s.onload = function() {
    window.require.config({ paths: { vs: 'https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.44.0/min/vs' } });
    window.require(['vs/editor/editor.main'], function(m) {
      window.monaco = m;
      m.editor.defineTheme('sanoire-dark', {
        base: 'vs-dark', inherit: true, rules: [
          { token: 'comment', foreground: '6F8FA7' },
          { token: 'keyword', foreground: 'AFE1F6' },
          { token: 'string',  foreground: '819D84' },
        ],
        colors: {
          'editor.background': '#0f1e28',
          'editor.foreground': '#e0eef6',
          'editor.lineHighlightBackground': '#162534',
          'editorLineNumber.foreground': '#314F5C',
          'editor.selectionBackground': '#314F5C50',
          'editorCursor.foreground': '#AFE1F6',
        }
      });
      m.editor.setTheme('sanoire-dark');
      (window._monacoQ || []).forEach(function(fn) { fn(m); });
      window._monacoLoading = false;
    });
  };
  document.head.appendChild(s);
}

function MonacoWrapper({ value, language, onChange }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var ref = React.useRef(null);
  var inst = React.useRef(null);
  React.useEffect(function() {
    loadMonaco(function(m) {
      if (inst.current) inst.current.dispose();
      var ed = m.editor.create(ref.current, {
        value: value || '', language: language || 'javascript', theme: 'sanoire-dark',
        fontSize: 13, lineHeight: 22, fontFamily: 'Consolas,Monaco,monospace',
        minimap: { enabled: false }, scrollBeyondLastLine: false,
        wordWrap: 'on', automaticLayout: true, padding: { top: 12, bottom: 12 },
        renderLineHighlight: 'line', smoothScrolling: true,
      });
      ed.onDidChangeModelContent(function() { if (onChange) onChange(ed.getValue()); });
      inst.current = ed;
    });
    return function() { if (inst.current) { inst.current.dispose(); inst.current = null; } };
  }, []); // eslint-disable-line
  React.useEffect(function() {
    if (!inst.current || inst.current.getValue() === value) return;
    inst.current.getModel().setValue(value || '');
  }, [value]);
  React.useEffect(function() {
    if (!inst.current || !window.monaco) return;
    window.monaco.editor.setModelLanguage(inst.current.getModel(), language || 'javascript');
  }, [language]);
  return React.createElement('div', { ref: ref, style: { width: '100%', height: '100%' } });
}


// ── DeploymentsCard ───────────────────────────────────────────────────────────
function DeploymentsCard({ deployments, loading, repo, onRefresh }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var IC_RELOAD = React.createElement('svg', { width:13, height:13, viewBox:'0 0 24 24', fill:'none', stroke:'currentColor', strokeWidth:2.2, strokeLinecap:'round' },
    React.createElement('polyline', { points:'23 4 23 10 17 10' }),
    React.createElement('path', { d:'M20.49 15a9 9 0 11-2.12-9.36L23 10' })
  );

  function stateColor(state) {
    if (state === 'READY') return '#1D9E75';
    if (state === 'BUILDING' || state === 'QUEUED' || state === 'INITIALIZING') return '#e08c2e';
    if (state === 'ERROR' || state === 'CANCELED') return '#c0392b';
    return '#9aabba';
  }
  function stateLabel(state) {
    if (state === 'READY') return 'Live';
    if (state === 'BUILDING') return 'Building';
    if (state === 'QUEUED' || state === 'INITIALIZING') return 'Queued';
    if (state === 'ERROR') return 'Failed';
    return state || 'Unknown';
  }
  function timeAgo(ts) {
    var ago = Math.round((Date.now() - new Date(ts)) / 60000);
    if (ago < 1) return 'just now';
    if (ago < 60) return ago + 'm ago';
    if (ago < 1440) return Math.round(ago/60) + 'h ago';
    return Math.round(ago/1440) + 'd ago';
  }

  var projectUrl = repo === 'product-sanoire/sanoire-app'
    ? 'https://vercel.com/sanoire/sanoire-app/deployments'
    : 'https://vercel.com/sanoire/sanoire-admin/deployments';

  var liveUrl = repo === 'product-sanoire/sanoire-app'
    ? 'https://www.sanoire.com'
    : 'https://admin.sanoire.com';

  return React.createElement('div', { style: { background: '#F7F3EC', borderRadius: 12, border: '1px solid #E5DDD0', overflow: 'hidden' } },

    // Header
    React.createElement('div', { style: { padding: '10px 14px', borderBottom: '1px solid #E5DDD0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
      React.createElement('div', { style: { fontSize: '.82rem', fontWeight: 700, color: '#3D2B1F' } }, 'Deployments'),
      React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8 } },
        React.createElement('a', { href: projectUrl, target: '_blank', rel: 'noreferrer',
          style: { fontSize: '.68rem', color: '#9F7E4F', textDecoration: 'none', fontWeight: 600 }
        }, 'View all'),
        React.createElement('button', { onClick: onRefresh, disabled: loading,
          style: { background: 'none', border: 'none', cursor: 'pointer', color: '#9F8A6A', display: 'flex', opacity: loading ? 0.4 : 1, padding: 2 }
        }, IC_RELOAD)
      )
    ),

    // Live site link
    React.createElement('div', { style: { padding: '8px 14px', borderBottom: '1px solid #E5DDD0', display: 'flex', alignItems: 'center', gap: 6 } },
      React.createElement('div', { style: { width: 7, height: 7, borderRadius: '50%', background: '#1D9E75', flexShrink: 0, boxShadow: '0 0 0 2px rgba(29,158,117,0.2)' } }),
      React.createElement('a', { href: liveUrl, target: '_blank', rel: 'noreferrer',
        style: { fontSize: '.74rem', color: '#314F5C', fontWeight: 600, textDecoration: 'none', fontFamily: 'monospace', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
      }, liveUrl.replace('https://', '')),
      React.createElement('span', { style: { fontSize: '.66rem', color: '#1D9E75', fontWeight: 700, background: '#E1F5EE', padding: '1px 6px', borderRadius: 4, flexShrink: 0 } }, 'Live')
    ),

    // Deployment list
    loading && deployments.length === 0
      ? React.createElement('div', { style: { padding: '14px', fontSize: '.74rem', color: '#9F8A6A', textAlign: 'center' } }, 'Loading...')
      : deployments.length === 0
        ? React.createElement('div', { style: { padding: '14px', fontSize: '.74rem', color: '#9F8A6A', textAlign: 'center' } }, 'No deployments found.\nAdd your Vercel token in settings.')
        : React.createElement('div', null,
            deployments.map(function(d, i) {
              var color = stateColor(d.state);
              var isPulse = d.state === 'BUILDING' || d.state === 'QUEUED' || d.state === 'INITIALIZING';
              return React.createElement('div', { key: d.id,
                style: { padding: '8px 14px', borderBottom: i < deployments.length-1 ? '1px solid #EDE8DF' : 'none', display: 'flex', alignItems: 'flex-start', gap: 8 }
              },
                React.createElement('div', { style: { width: 7, height: 7, borderRadius: '50%', background: color, flexShrink: 0, marginTop: 4, animation: isPulse ? 'pulse 1.2s infinite' : 'none' } }),
                React.createElement('div', { style: { flex: 1, minWidth: 0 } },
                  React.createElement('div', { style: { fontSize: '.74rem', color: '#3D2B1F', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.4 } }, d.message || 'Deployment'),
                  React.createElement('div', { style: { fontSize: '.67rem', color: '#9F8A6A', marginTop: 2, display: 'flex', gap: 5 } },
                    React.createElement('span', { style: { fontFamily: 'monospace' } }, d.sha),
                    React.createElement('span', null, '\u00b7'),
                    React.createElement('span', null, timeAgo(d.createdAt))
                  )
                ),
                React.createElement('div', { style: { fontSize: '.66rem', fontWeight: 700, color: color, flexShrink: 0, marginTop: 2 } }, stateLabel(d.state))
              );
            })
          ),

    // Vercel token prompt if not set
    !localStorage.getItem('sanoire_vercel_token') && React.createElement('div', { style: { padding: '8px 14px', borderTop: '1px solid #E5DDD0', fontSize: '.67rem', color: '#9F8A6A', lineHeight: 1.6 } },
      'Showing recent commits. ',
      React.createElement('button', { onClick: function() {
        var t = prompt('Paste your Vercel token (Account Settings \u2192 Tokens):');
        if (t && t.trim()) { localStorage.setItem('sanoire_vercel_token', t.trim()); onRefresh(); }
      }, style: { background: 'none', border: 'none', cursor: 'pointer', color: '#9F7E4F', fontWeight: 700, fontFamily: F, fontSize: '.67rem', padding: 0 } }, 'Add Vercel token for live status.')
    )
  );
}

// ── CodeEditorTab ─────────────────────────────────────────────────────────────
// ── CodeEditorTab — describe what you want, Claude finds and fixes the files ──
function CodeEditorTab({ authorEmail }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var GH_TOKEN  = localStorage.getItem('sanoire_gh_token') || '';
  var GH_REPO   = localStorage.getItem('code_repo') || 'product-sanoire/sanoire-app';
  var REPOS     = [
    { id: 'product-sanoire/sanoire-app',   label: 'sanoire-app (main app)' },
    { id: 'product-sanoire/sanoire-admin', label: 'sanoire-admin (dashboard)' },
  ];

  var [repo,        setRepo]        = useState(GH_REPO);
  var [input,       setInput]       = useState('');
  var [messages,    setMessages]    = useState([]);
  var [loading,     setLoading]     = useState(false);
  var [token,       setToken]       = useState(GH_TOKEN);
  var [tokenInput,  setTokenInput]  = useState('');
  var [recentEdits, setRecentEdits] = useState(
    JSON.parse(localStorage.getItem('code_recent_edits') || '[]')
  );
  var [deployments, setDeployments]   = useState([]);
  var [deploysLoading, setDeploysLoading] = useState(false);
  var inputRef = React.useRef(null);
  var bottomRef = React.useRef(null);

  React.useEffect(function() {
    if (bottomRef.current) bottomRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  React.useEffect(function() {
    fetchDeployments();
    var iv = setInterval(fetchDeployments, 30000);
    return function() { clearInterval(iv); };
  }, [repo]); // eslint-disable-line

  async function fetchDeployments() {
    setDeploysLoading(true);
    try {
      var projectSlug = repo === 'product-sanoire/sanoire-app' ? 'sanoire-app' : 'sanoire-admin';
      var vToken = localStorage.getItem('sanoire_vercel_token') || '';
      if (!vToken) {
        // Use GitHub API to get recent commits as a proxy for deploy status
        var r = await fetch('https://api.github.com/repos/' + repo + '/commits?per_page=5', { headers: ghHeaders() });
        var commits = await r.json();
        if (Array.isArray(commits)) {
          setDeployments(commits.map(function(c) {
            return {
              id: c.sha,
              sha: c.sha.slice(0,7),
              message: c.commit.message.split(String.fromCharCode(10))[0].slice(0,60),

              createdAt: c.commit.author.date,
              state: 'READY',
              url: 'https://' + projectSlug + '.vercel.app',
              source: 'github',
            };
          }));
        }
        return;
      }
      var resp = await fetch('https://api.vercel.com/v6/deployments?projectId=' + projectSlug + '&limit=5', {
        headers: { Authorization: 'Bearer ' + vToken }
      });
      var data = await resp.json();
      if (data.deployments) {
        setDeployments(data.deployments.map(function(d) {
          return {
            id: d.uid,
            sha: d.meta && d.meta.githubCommitSha ? d.meta.githubCommitSha.slice(0,7) : '?',
            message: (d.meta && d.meta.githubCommitMessage || d.name || '').slice(0,60),
            createdAt: new Date(d.createdAt).toISOString(),
            state: d.state,
            url: 'https://' + d.url,
            source: 'vercel',
          };
        }));
      }
    } catch (_e) {}
    finally { setDeploysLoading(false); }
  }

  function ghHeaders() {
    return { 'Authorization': 'token ' + token, 'Content-Type': 'application/json', 'Accept': 'application/vnd.github+json' };
  }

  // Fetch a file from GitHub
  async function fetchFile(path) {
    var r = await fetch('https://api.github.com/repos/' + repo + '/contents/' + path, { headers: ghHeaders() });
    if (!r.ok) throw new Error('Cannot read ' + path + ' (' + r.status + ')');
    var data = await r.json();
    var dec = new TextDecoder();
    var bytes = Uint8Array.from(atob(data.content.replace(/\n/g, '')), function(c) { return c.charCodeAt(0); });
    return { content: dec.decode(bytes), sha: data.sha };
  }

  // Push a file to GitHub
  async function pushFile(path, content, sha, commitMsg) {
    var enc = new TextEncoder();
    var bytes = enc.encode(content);
    var b64 = btoa(String.fromCharCode.apply(null, Array.from(bytes)));
    var r = await fetch('https://api.github.com/repos/' + repo + '/contents/' + path, {
      method: 'PUT', headers: ghHeaders(),
      body: JSON.stringify({ message: commitMsg, content: b64, sha: sha, branch: 'main' })
    });
    if (!r.ok) throw new Error('Push failed for ' + path + ': ' + (await r.text()));
    var result = await r.json();
    return result.commit.sha.slice(0, 7);
  }

  // List files in a directory
  async function listDir(path) {
    var r = await fetch('https://api.github.com/repos/' + repo + '/contents/' + (path || ''), { headers: ghHeaders() });
    if (!r.ok) return [];
    var items = await r.json();
    return Array.isArray(items) ? items.map(function(i) { return i.path; }) : [];
  }

  function addMessage(role, content, extra) {
    setMessages(function(m) { return m.concat(Object.assign({ role: role, content: content, ts: Date.now() }, extra || {})); });
  }

  function updateLastMessage(content, extra) {
    setMessages(function(m) {
      var updated = m.slice();
      updated[updated.length - 1] = Object.assign({}, updated[updated.length - 1], { content: content }, extra || {});
      return updated;
    });
  }

  async function send() {
    var request = input.trim();
    if (!request || loading) return;
    setInput('');
    setLoading(true);
    addMessage('user', request);
    addMessage('assistant', 'Thinking about which files to change...');

    try {
      // Phase 1: Ask Claude which files need changing and what to do
      var srcFiles = await listDir('src');
      var srcScreens = await listDir('src/screens');
      var fileList = srcFiles.concat(srcScreens).join('\n');

      var planPrompt = [
        'You are a senior React developer working on the Sanoire app (' + repo + ').',
        'The user wants to make this change: "' + request + '"',
        '',
        'Available files in the repo:',
        fileList,
        '',
        'Your job:',
        '1. Identify which file(s) need to change (max 3 files)',
        '2. For each file, describe exactly what to change',
        '',
        'Respond in this exact JSON format (no markdown, no explanation outside JSON):',
        '{',
        '  "summary": "one sentence describing what will change",',
        '  "files": [',
        '    { "path": "src/screens/TestFetch.js", "instruction": "specific description of what to change in this file" }',
        '  ]',
        '}',
        '',
        'Rules:',
        '- Only include files that genuinely need to change',
        '- Be specific in the instruction (mention exact component names, colours, behaviour)',
        '- Brand: #314F5C teal, #AFE1F6 light blue, #819D84 sage, #6F8FA7 mid-blue',
        '- No TypeScript. Use React.createElement syntax. Inline styles.',
      ].join('\n');

      var planResp = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ model: 'claude-sonnet-4-20250514', max_tokens: 1000,
          messages: [{ role: 'user', content: planPrompt }] })
      });
      var planData = await planResp.json();
      var planText = (planData.content || []).map(function(b) { return b.text || ''; }).join('');

      var plan;
      try { plan = JSON.parse(planText.trim()); }
      catch (_e) {
        // Try to extract JSON from the response
        var jsonMatch = planText.match(/\{[\s\S]*\}/);
        if (jsonMatch) plan = JSON.parse(jsonMatch[0]);
        else throw new Error('Could not parse plan from Claude');
      }

      updateLastMessage(plan.summary + '\n\nFiles to update: ' + plan.files.map(function(f) { return f.path; }).join(', '));

      // Phase 2: For each file, fetch it and ask Claude to edit it
      var committed = [];
      for (var i = 0; i < plan.files.length; i++) {
        var fileTask = plan.files[i];
        addMessage('assistant', 'Reading ' + fileTask.path + '...');

        var fileData = await fetchFile(fileTask.path);

        updateLastMessage('Editing ' + fileTask.path + '...');

        var editPrompt = [
          'You are editing ' + fileTask.path + ' in the Sanoire ' + repo.split('/')[1] + ' repo.',
          '',
          'Change to make: ' + fileTask.instruction,
          '',
          'Current file content:',
          '```',
          fileData.content.slice(0, 60000), // limit for large files
          '```',
          '',
          'Return ONLY the complete updated file content. No explanation. No markdown fences. Just the raw file content starting from the first line.',
          '',
          'Rules:',
          '- Preserve all existing functionality unless explicitly told to change it',
          '- Match the existing code style exactly',
          '- No TypeScript. Inline styles. React.createElement syntax.',
          '- Brand colours: #314F5C #AFE1F6 #819D84 #6F8FA7',
        ].join('\n');

        var editResp = await fetch('https://api.anthropic.com/v1/messages', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ model: 'claude-sonnet-4-20250514', max_tokens: 16000,
            messages: [{ role: 'user', content: editPrompt }] })
        });
        var editData = await editResp.json();
        var newContent = (editData.content || []).map(function(b) { return b.text || ''; }).join('');

        // Strip any accidental markdown fences
        newContent = newContent.replace(/^```[a-z]*\n?/, '').replace(/\n?```$/, '').trim();

        updateLastMessage('Pushing ' + fileTask.path + ' to GitHub...');

        var commitSha = await pushFile(
          fileTask.path, newContent, fileData.sha,
          'Code: ' + request.slice(0, 60) + ' [' + fileTask.path.split('/').pop() + ']'
        );
        committed.push({ path: fileTask.path, sha: commitSha });
      }

      // Success
      var successMsg = [
        plan.summary,
        '',
        committed.map(function(c) { return '\u2713 ' + c.path + ' (commit ' + c.sha + ')'; }).join('\n'),
        '',
        'Deploying to Vercel now (~35 seconds)...',
      ].join('\n');

      updateLastMessage(successMsg, { type: 'success', files: committed });

      // Save to recent edits
      var edit = { id: Date.now(), request: request, files: committed, repo: repo, ts: new Date().toISOString() };
      var recent = [edit].concat(recentEdits).slice(0, 20);
      setRecentEdits(recent);
      localStorage.setItem('code_recent_edits', JSON.stringify(recent));

    } catch (err) {
      updateLastMessage('Error: ' + err.message, { type: 'error' });
    }
    setLoading(false);
    if (inputRef.current) inputRef.current.focus();
  }

  function saveToken() {
    var t = tokenInput.trim();
    if (!t) return;
    localStorage.setItem('sanoire_gh_token', t);
    setToken(t);
    setTokenInput('');
  }

  // ── Token gate ───────────────────────────────────────────────────────────────
  if (!token) {
    return React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: 420, fontFamily: F } },
      React.createElement('div', { style: { background: t.panel, borderRadius: 14, padding: 32, width: 400, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', border: `1px solid ${t.bd}` } },
        React.createElement('div', { style: { fontSize: '.9rem', fontWeight: 700, color: '#0f1e28', marginBottom: 6 } }, 'Connect GitHub'),
        React.createElement('div', { style: { fontSize: '.78rem', color: '#6a8898', lineHeight: 1.7, marginBottom: 16 } },
          'Paste your GitHub personal access token. It\'s stored locally in your browser only.',
          React.createElement('br'),
          React.createElement('a', { href: 'https://github.com/settings/tokens/new?scopes=repo&description=Sanoire+Code+Tab', target: '_blank', rel: 'noreferrer', style: { color: '#314F5C', fontWeight: 600 } }, 'Create token (repo scope)')
        ),
        React.createElement('div', { style: { display: 'flex', gap: 8 } },
          React.createElement('input', { type: 'password', value: tokenInput, onChange: function(e) { setTokenInput(e.target.value); },
            onKeyDown: function(e) { if (e.key === 'Enter') saveToken(); },
            placeholder: 'ghp_xxxxxxxxxxxxxxxxxxxx', autoFocus: true,
            style: { flex: 1, padding: '9px 12px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: 'monospace', fontSize: '.82rem', outline: 'none' }
          }),
          React.createElement('button', { onClick: saveToken, disabled: !tokenInput.trim(),
            style: { padding: '9px 16px', borderRadius: 8, border: 'none', background: tokenInput.trim() ? '#314F5C' : '#e8eef2', color: tokenInput.trim() ? '#fff' : '#9aabba', fontFamily: F, fontSize: '.8rem', fontWeight: 700, cursor: tokenInput.trim() ? 'pointer' : 'not-allowed' }
          }, 'Connect')
        )
      )
    );
  }

  // ── Main UI ──────────────────────────────────────────────────────────────────
  return React.createElement('div', { style: { display: 'flex', gap: 20, alignItems: 'flex-start', fontFamily: F } },

    // ── Left: chat interface ─────────────────────────────────────────────────
    React.createElement('div', { style: { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0, background: '#F7F3EC', borderRadius: 12, border: '1px solid #E5DDD0', overflow: 'hidden' } },

      // Header
      React.createElement('div', { style: { padding: '14px 18px', borderBottom: '1px solid #E5DDD0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
        React.createElement('div', null,
          React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28' } }, 'Claude Code'),
          React.createElement('div', { style: { fontSize: '.72rem', color: '#9aabba', marginTop: 2 } }, 'Describe what you want — Claude finds the files, makes the changes, and pushes to GitHub')
        ),
        React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8 } },
          React.createElement('select', { value: repo, onChange: function(e) { setRepo(e.target.value); localStorage.setItem('code_repo', e.target.value); },
            style: { padding: '5px 10px', borderRadius: 7, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.74rem', outline: 'none', color: '#314F5C', fontWeight: 600, cursor: 'pointer' }
          }, REPOS.map(function(r) { return React.createElement('option', { key: r.id, value: r.id }, r.label); })),
          React.createElement('button', { onClick: function() { localStorage.removeItem('sanoire_gh_token'); setToken(''); },
            style: { padding: '4px 8px', borderRadius: 6, border: `1px solid ${t.bd}`, background: t.panel, fontFamily: F, fontSize: '.7rem', color: '#9aabba', cursor: 'pointer' }
          }, 'Disconnect')
        )
      ),

      // Messages
      React.createElement('div', { style: { minHeight: 300, maxHeight: 420, overflowY: 'auto', padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: 12 } },

        messages.length === 0 && React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 10 } },
          React.createElement('div', { style: { fontSize: '.8rem', color: '#9aabba', lineHeight: 1.7 } }, 'Examples of what you can say:'),
          [
            'Make the search bar background teal and increase the font size',
            'Add a loading spinner to the Sana chat when waiting for a response',
            'Fix the spacing on the bottom navigation bar on mobile',
            'Change the homepage map pin colour to match the brand colour',
            'Add a "Verified" badge next to clinic names in search results',
          ].map(function(example, i) {
            return React.createElement('div', { key: i,
              onClick: function() { setInput(example); if (inputRef.current) inputRef.current.focus(); },
              style: { padding: '9px 13px', background: '#F2EDE4', borderRadius: 8, border: '1px solid #E5DDD0', fontSize: '.78rem', color: '#314F5C', cursor: 'pointer', transition: 'background .1s' },
              onMouseEnter: function(e) { e.currentTarget.style.background = '#EDE5D8'; },
              onMouseLeave: function(e) { e.currentTarget.style.background = '#F2EDE4'; },
            }, '"' + example + '"');
          })
        ),

        messages.map(function(msg, i) {
          var isUser = msg.role === 'user';
          var isSuccess = msg.type === 'success';
          var isError = msg.type === 'error';
          return React.createElement('div', { key: i, style: { display: 'flex', flexDirection: 'column', alignItems: isUser ? 'flex-end' : 'flex-start', gap: 4 } },
            React.createElement('div', { style: {
              maxWidth: '90%', padding: '10px 14px',
              borderRadius: isUser ? '12px 12px 2px 12px' : '12px 12px 12px 2px',
              background: isUser ? '#314F5C' : isSuccess ? '#E1F5EE' : isError ? '#FCEBEB' : '#EDE8DF',
              border: isSuccess ? '1px solid #6EE7B7' : isError ? '1px solid #fca5a5' : '1px solid #E5DDD0',
              color: isUser ? '#fff' : isError ? '#c0392b' : '#1a2e3a',
              fontSize: '.8rem', lineHeight: 1.7, fontFamily: F, whiteSpace: 'pre-wrap', wordBreak: 'break-word',
            } },
              loading && i === messages.length - 1 && !isUser
                ? React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 8 } },
                    React.createElement('div', { style: { display: 'flex', gap: 3 } },
                      [0,1,2].map(function(j) {
                        return React.createElement('div', { key: j, style: { width: 5, height: 5, borderRadius: '50%', background: t.accent, opacity: 0.6, animation: 'pulse 1.2s '+(j*0.2)+'s infinite' } });
                      })
                    ),
                    React.createElement('span', null, msg.content)
                  )
                : msg.content,
              isSuccess && msg.files && React.createElement('div', { style: { marginTop: 10, display: 'flex', gap: 6, flexWrap: 'wrap' } },
                msg.files.map(function(f) {
                  return React.createElement('a', { key: f.path,
                    href: 'https://github.com/' + repo + '/blob/main/' + f.path,
                    target: '_blank', rel: 'noreferrer',
                    style: { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 8px', background: t.panel, border: '1px solid #6EE7B7', borderRadius: 6, fontSize: '.7rem', color: '#065F46', textDecoration: 'none', fontWeight: 600 }
                  }, f.path.split('/').pop(), ' ', React.createElement('span', null, '\u2197'));
                })
              )
            )
          );
        }),
        React.createElement('div', { ref: bottomRef })
      ),

      // Input bar
      React.createElement('div', { style: { padding: '12px 16px', borderTop: '1px solid #E5DDD0', background: '#EDE8DF' } },
        React.createElement('div', { style: { display: 'flex', gap: 8, alignItems: 'flex-end' } },
          React.createElement('textarea', {
            ref: inputRef,
            value: input,
            onChange: function(e) { setInput(e.target.value); },
            onKeyDown: function(e) { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); send(); } },
            placeholder: 'Describe what you want to change... (Ctrl+Enter to send)',
            disabled: loading, rows: 3,
            style: { flex: 1, padding: '9px 12px', borderRadius: 9, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.82rem', outline: 'none', resize: 'none', lineHeight: 1.6, background: loading ? '#F2EDE4' : '#FEFCF8' }
          }),
          React.createElement('button', { onClick: send, disabled: !input.trim() || loading,
            style: { padding: '10px 20px', borderRadius: 9, border: 'none', background: input.trim() && !loading ? '#314F5C' : '#e8eef2', color: input.trim() && !loading ? '#fff' : '#9aabba', fontFamily: F, fontSize: '.82rem', fontWeight: 700, cursor: input.trim() && !loading ? 'pointer' : 'not-allowed', flexShrink: 0, transition: 'all .15s' }
          }, loading ? 'Working...' : 'Send')
        ),
        React.createElement('div', { style: { fontSize: '.68rem', color: '#9F8A6A', marginTop: 6 } },
          'Claude will read the relevant files, make the changes, and push directly to GitHub. Vercel deploys automatically in ~35 seconds.'
        )
      )
    ),

    // ── Right: recent changes ────────────────────────────────────────────────
    React.createElement('div', { style: { width: 280, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 14 } },

      React.createElement(DeploymentsCard, { deployments: deployments, loading: deploysLoading, repo: repo, onRefresh: fetchDeployments }),

      React.createElement('div', { style: { background: '#F7F3EC', borderRadius: 12, border: '1px solid #E5DDD0', overflow: 'hidden' } },
        React.createElement('div', { style: { padding: '12px 16px', borderBottom: '1px solid #E5DDD0', fontSize: '.82rem', fontWeight: 700, color: '#3D2B1F' } }, 'Recent changes'),
        recentEdits.length === 0
          ? React.createElement('div', { style: { padding: '16px', fontSize: '.76rem', color: '#9F8A6A', textAlign: 'center' } }, 'No changes yet')
          : React.createElement('div', { style: { maxHeight: 380, overflowY: 'auto' } },
              recentEdits.map(function(edit) {
                var ago = Math.round((Date.now() - new Date(edit.ts)) / 60000);
                var agoStr = ago < 1 ? 'just now' : ago < 60 ? ago + 'm ago' : Math.round(ago/60) + 'h ago';
                return React.createElement('div', { key: edit.id, style: { padding: '10px 14px', borderBottom: '1px solid #E5DDD0' } },
                  React.createElement('div', { style: { fontSize: '.76rem', fontWeight: 600, color: '#3D2B1F', marginBottom: 4, lineHeight: 1.4 } }, edit.request.slice(0, 60) + (edit.request.length > 60 ? '...' : '')),
                  React.createElement('div', { style: { display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 4 } },
                    (edit.files || []).map(function(f) {
                      return React.createElement('a', { key: f.path,
                        href: 'https://github.com/' + edit.repo + '/blob/main/' + f.path,
                        target: '_blank', rel: 'noreferrer',
                        style: { fontSize: '.66rem', color: '#314F5C', background: '#f0f7ff', padding: '1px 6px', borderRadius: 4, textDecoration: 'none', fontWeight: 600 }
                      }, f.path.split('/').pop());
                    })
                  ),
                  React.createElement('div', { style: { fontSize: '.67rem', color: '#9F8A6A' } }, agoStr + ' \u00b7 ' + edit.repo.split('/')[1])
                );
              })
            )
      ),

      React.createElement('div', { style: { background: '#EDE8DF', borderRadius: 12, border: '1px solid #C8B99A', padding: '14px 16px' } },
        React.createElement('div', { style: { fontSize: '.78rem', fontWeight: 700, color: '#5C3D1E', marginBottom: 8 } }, 'How it works'),
        [
          'You describe the change in plain English',
          'Claude reads the relevant source files from GitHub',
          'Claude edits the files and pushes to main',
          'Vercel deploys automatically in ~35 seconds',
        ].map(function(step, i) {
          return React.createElement('div', { key: i, style: { display: 'flex', gap: 8, marginBottom: 6, alignItems: 'flex-start' } },
            React.createElement('div', { style: { width: 18, height: 18, borderRadius: '50%', background: '#9F7E4F', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.64rem', fontWeight: 700, flexShrink: 0, marginTop: 1 } }, i + 1),
            React.createElement('div', { style: { fontSize: '.74rem', color: '#5C3D1E', lineHeight: 1.6 } }, step)
          );
        })
      )
    )
  );
}


// ═══════════════════════════════════════════════════════════════════════════════
// SOUNDS MANAGER — manage city_sounds table
// ═══════════════════════════════════════════════════════════════════════════════

var CITY_COUNTRY = [
  { city: 'Bangkok',        country: 'Thailand'      },
  { city: 'Bali',           country: 'Indonesia'     },
  { city: 'Singapore',      country: 'Singapore'     },
  { city: 'Amsterdam',      country: 'Netherlands'   },
  { city: 'Dubai',          country: 'UAE'           },
  { city: 'Tokyo',          country: 'Japan'         },
  { city: 'London',         country: 'UK'            },
  { city: 'Paris',          country: 'France'        },
  { city: 'New York',       country: 'USA'           },
  { city: 'Sydney',         country: 'Australia'     },
  { city: 'Barcelona',      country: 'Spain'         },
  { city: 'Lisbon',         country: 'Portugal'      },
  { city: 'Istanbul',       country: 'Turkey'        },
  { city: 'Kuala Lumpur',   country: 'Malaysia'      },
  { city: 'Ho Chi Minh City', country: 'Vietnam'     },
  { city: 'Chiang Mai',     country: 'Thailand'      },
  { city: 'Seoul',          country: 'South Korea'   },
  { city: 'Mumbai',         country: 'India'         },
  { city: 'Cape Town',      country: 'South Africa'  },
  { city: 'Mexico City',    country: 'Mexico'        },
  { city: 'Medellín',       country: 'Colombia'      },
  { city: 'Berlin',         country: 'Germany'       },
  { city: 'Tbilisi',        country: 'Georgia'       },
  { city: 'Nairobi',        country: 'Kenya'         },
  { city: 'Marrakech',      country: 'Morocco'       },
];

var MOOD_COLORS = {
  calm:      '#819D84',
  explore:   '#314F5C',
  nightlife: '#9F7E4F',
  sleep:     '#6F8FA7',
};

var MOOD_LABELS = { calm: 'Calm', explore: 'Explore', nightlife: 'Nightlife', sleep: 'Sleep' };
var SOURCE_LABELS = { pixabay: 'Pixabay', epidemic: 'Epidemic Sound', custom: 'Custom' };

function MoodBadge({ mood }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var c = MOOD_COLORS[mood] || '#9aabba';
  var label = MOOD_LABELS[mood] || mood;
  return React.createElement('span', {
    style: {
      display: 'inline-flex', alignItems: 'center', gap: 5,
      padding: '2px 9px', borderRadius: 99,
      fontSize: '.65rem', fontWeight: 600,
      background: c + '18', color: c, border: '1px solid ' + c + '30',
    }
  },
    React.createElement('span', {
      style: { width: 6, height: 6, borderRadius: '50%', background: c, flexShrink: 0 }
    }),
    label
  );
}

function fmtDuration(secs) {
  if (!secs) return '—';
  var m = Math.floor(secs / 60);
  var s = secs % 60;
  return m + ':' + (s < 10 ? '0' : '') + s;
}

function SoundsStatCard({ label, value, sub, accent }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return React.createElement('div', {
    style: { ...CARD, display: 'flex', flexDirection: 'column', gap: 4, minWidth: 140, flex: 1 }
  },
    React.createElement('div', { style: { fontSize: '.72rem', color: '#7a9aaa', fontWeight: 500, letterSpacing: '.03em', textTransform: 'uppercase' } }, label),
    React.createElement('div', { style: { fontSize: '1.6rem', fontWeight: 700, color: accent || '#0f1e28', lineHeight: 1.1 } }, value),
    sub && React.createElement('div', { style: { fontSize: '.73rem', color: '#9aabba' } }, sub)
  );
}

var SOUNDS_EMPTY_FORM = {
  title: '', city: '', country: '', mood: 'calm', source: 'pixabay',
  audio_url: '', duration_seconds: '', is_featured: false,
};

function SoundsManager() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  var [sounds, setSounds]           = useState([]);
  var [loading, setLoading]         = useState(true);
  var [search, setSearch]           = useState('');
  var [filterCity, setFilterCity]   = useState('');
  var [filterMood, setFilterMood]   = useState('');
  var [filterSource, setFilterSource] = useState('');
  var [sortBy, setSortBy]           = useState('created_at');
  var [showForm, setShowForm]       = useState(false);
  var [editSound, setEditSound]     = useState(null);
  var [form, setForm]               = useState(SOUNDS_EMPTY_FORM);
  var [saving, setSaving]           = useState(false);
  var [deleteId, setDeleteId]       = useState(null);
  var [deleting, setDeleting]       = useState(false);
  var [playingId, setPlayingId]     = useState(null);
  var [audioErr, setAudioErr]       = useState(null);
  var [formError, setFormError]     = useState('');
  var [uploadFile, setUploadFile]   = useState(null);
  var [uploading, setUploading]     = useState(false);
  var [bulkText, setBulkText]       = useState('');
  var [bulkStatus, setBulkStatus]   = useState('');
  var [activeSection, setActiveSection] = useState('table');

  var audioRef = React.useRef(null);

  useEffect(function() { loadSounds(); }, []);

  function loadSounds() {
    setLoading(true);
    supabase
      .from('city_sounds')
      .select('*')
      .order('created_at', { ascending: false })
      .then(function(res) {
        setSounds(res.data || []);
        setLoading(false);
      });
  }

  // ── Derived data ──────────────────────────────────────────────────────────

  var filtered = sounds.filter(function(s) {
    if (search && !s.title.toLowerCase().includes(search.toLowerCase())) return false;
    if (filterCity && s.city !== filterCity) return false;
    if (filterMood && s.mood !== filterMood) return false;
    if (filterSource && s.source !== filterSource) return false;
    return true;
  });

  var sorted = filtered.slice().sort(function(a, b) {
    if (sortBy === 'play_count') return (b.play_count || 0) - (a.play_count || 0);
    if (sortBy === 'city')       return (a.city || '').localeCompare(b.city || '');
    if (sortBy === 'title')      return (a.title || '').localeCompare(b.title || '');
    return new Date(b.created_at) - new Date(a.created_at);
  });

  var totalCount = sounds.length;

  var citiesWithZero = CITY_COUNTRY.filter(function(cc) {
    return !sounds.some(function(s) { return s.city === cc.city; });
  });

  var moodCounts = {};
  ['calm','explore','nightlife','sleep'].forEach(function(m) {
    moodCounts[m] = sounds.filter(function(s) { return s.mood === m; }).length;
  });

  var topPlayed = sounds.slice().sort(function(a,b) { return (b.play_count||0)-(a.play_count||0); }).slice(0,3);

  // ── Audio preview ──────────────────────────────────────────────────────────

  function togglePlay(sound) {
    setAudioErr(null);
    if (playingId === sound.id) {
      if (audioRef.current) { audioRef.current.pause(); audioRef.current.currentTime = 0; }
      setPlayingId(null);
      return;
    }
    if (audioRef.current) { audioRef.current.pause(); }
    if (!sound.audio_url) { setAudioErr('No audio URL for this track.'); return; }
    var audio = new window.Audio(sound.audio_url);
    audioRef.current = audio;
    audio.onended = function() { setPlayingId(null); };
    audio.onerror = function() { setAudioErr('Could not load audio.'); setPlayingId(null); };
    audio.play().catch(function(_e) { setAudioErr('Playback blocked by browser.'); setPlayingId(null); });
    setPlayingId(sound.id);
  }

  // ── Form helpers ───────────────────────────────────────────────────────────

  function openAdd() {
    setEditSound(null);
    setForm(SOUNDS_EMPTY_FORM);
    setUploadFile(null);
    setFormError('');
    setShowForm(true);
  }

  function openEdit(sound) {
    setEditSound(sound);
    setForm({
      title:            sound.title || '',
      city:             sound.city || '',
      country:          sound.country || '',
      mood:             sound.mood || 'calm',
      source:           sound.source || 'pixabay',
      audio_url:        sound.audio_url || '',
      duration_seconds: sound.duration_seconds ? String(sound.duration_seconds) : '',
      is_featured:      !!sound.is_featured,
    });
    setUploadFile(null);
    setFormError('');
    setShowForm(true);
  }

  function setField(k, v) {
    setForm(function(prev) {
      var next = Object.assign({}, prev, { [k]: v });
      if (k === 'city') {
        var match = CITY_COUNTRY.find(function(cc) { return cc.city === v; });
        if (match) next.country = match.country;
      }
      return next;
    });
  }

  function handleFileChange(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    setUploadFile(file);
    // Auto-detect duration
    var url = URL.createObjectURL(file);
    var tmp = new window.Audio(url);
    tmp.onloadedmetadata = function() {
      setField('duration_seconds', String(Math.round(tmp.duration)));
      URL.revokeObjectURL(url);
    };
  }

  async function saveSound() {
    if (!form.title.trim())      { setFormError('Title is required.'); return; }
    if (!form.city)               { setFormError('City is required.'); return; }
    if (!form.audio_url && !uploadFile) { setFormError('Provide an audio file or URL.'); return; }
    setSaving(true); setFormError('');
    try {
      var audioUrl = form.audio_url;
      if (uploadFile) {
        setUploading(true);
        var ext  = uploadFile.name.split('.').pop();
        var path = 'sounds/' + Date.now() + '_' + form.city.replace(/\s+/g, '-').toLowerCase() + '.' + ext;
        var { error: upErr } = await supabase.storage.from('sounds').upload(path, uploadFile, { upsert: true });
        setUploading(false);
        if (upErr) { setFormError('Upload failed: ' + upErr.message); setSaving(false); return; }
        var { data: pubData } = supabase.storage.from('sounds').getPublicUrl(path);
        audioUrl = pubData.publicUrl;
      }
      var payload = {
        title:            form.title.trim(),
        city:             form.city,
        country:          form.country,
        mood:             form.mood,
        source:           form.source,
        audio_url:        audioUrl,
        duration_seconds: form.duration_seconds ? parseInt(form.duration_seconds, 10) : null,
        is_featured:      form.is_featured,
      };
      var result;
      if (editSound) {
        result = await supabase.from('city_sounds').update(payload).eq('id', editSound.id);
      } else {
        result = await supabase.from('city_sounds').insert([payload]);
      }
      if (result.error) { setFormError(result.error.message); setSaving(false); return; }
      setShowForm(false);
      loadSounds();
    } catch (_e) {
      setFormError('Unexpected error. Please try again.');
    }
    setSaving(false);
  }

  async function deleteSound() {
    if (!deleteId) return;
    setDeleting(true);
    await supabase.from('city_sounds').delete().eq('id', deleteId);
    setDeleting(false);
    setDeleteId(null);
    loadSounds();
  }

  async function toggleFeatured(sound) {
    await supabase.from('city_sounds').update({ is_featured: !sound.is_featured }).eq('id', sound.id);
    setSounds(function(prev) {
      return prev.map(function(s) { return s.id === sound.id ? { ...s, is_featured: !s.is_featured } : s; });
    });
  }

  // ── Bulk import ────────────────────────────────────────────────────────────

  async function runBulkImport() {
    var lines = bulkText.split('\n').map(function(l) { return l.trim(); }).filter(Boolean);
    if (!lines.length) { setBulkStatus('No URLs found.'); return; }
    setBulkStatus('Importing ' + lines.length + ' track(s)...');
    var ok = 0; var fail = 0;
    for (var i = 0; i < lines.length; i++) {
      var url = lines[i];
      var src = url.includes('pixabay') ? 'pixabay' : url.includes('epidemicsound') ? 'epidemic' : 'custom';
      var payload = {
        title:            'Untitled — ' + src + ' ' + (i + 1),
        city:             '',
        country:          '',
        mood:             'explore',
        source:           src,
        audio_url:        url,
        duration_seconds: null,
        is_featured:      false,
      };
      var res = await supabase.from('city_sounds').insert([payload]);
      if (res.error) { fail++; } else { ok++; }
    }
    setBulkStatus('Done — ' + ok + ' added' + (fail ? ', ' + fail + ' failed' : '') + '. Edit titles/cities in the table.');
    setBulkText('');
    loadSounds();
  }

  // ── Render ─────────────────────────────────────────────────────────────────

  var sectionTabs = [
    { id: 'table', label: 'All Sounds' },
    { id: 'stats', label: 'Stats' },
    { id: 'bulk',  label: 'Bulk Import' },
  ];

  return React.createElement('div', { style: { fontFamily: F } },

    // Section tabs + Add button
    React.createElement('div', {
      style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 10 }
    },
      React.createElement('div', { style: { display: 'flex', gap: 2, background: '#f0f4f6', borderRadius: 8, padding: 2 } },
        sectionTabs.map(function(t) {
          var active = activeSection === t.id;
          return React.createElement('button', {
            key: t.id, onClick: function() { setActiveSection(t.id); },
            style: { padding: '6px 14px', borderRadius: 6, border: 'none', fontFamily: F, fontSize: '.78rem', cursor: 'pointer', background: active ? '#fff' : 'transparent', color: active ? '#0f1e28' : '#7a9aaa', fontWeight: active ? 600 : 400, boxShadow: active ? '0 1px 3px rgba(0,0,0,0.09)' : 'none', transition: 'all .12s' }
          }, t.label);
        })
      ),
      React.createElement('div', { style: { display: 'flex', gap: 8, alignItems: 'center' } },
        audioErr && React.createElement('span', { style: { fontSize: '.72rem', color: '#c0392b' } }, audioErr),
        React.createElement(Btn, { onClick: openAdd, variant: 'primary', small: true },
          React.createElement('span', { style: { display: 'flex', alignItems: 'center', gap: 5 } },
            React.createElement('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.5, strokeLinecap: 'round' },
              React.createElement('line', { x1: 12, y1: 5, x2: 12, y2: 19 }),
              React.createElement('line', { x1: 5, y1: 12, x2: 19, y2: 12 })
            ),
            'Add Sound'
          )
        )
      )
    ),

    // ── Stats section ──────────────────────────────────────────────────────
    activeSection === 'stats' && React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 20 } },

      // KPI row
      React.createElement('div', { style: { display: 'flex', gap: 14, flexWrap: 'wrap' } },
        React.createElement(SoundsStatCard, { label: 'Total Sounds', value: totalCount, sub: filtered.length !== totalCount ? filtered.length + ' matching filters' : null, accent: '#314F5C' }),
        React.createElement(SoundsStatCard, { label: 'Cities with 0 Sounds', value: citiesWithZero.length, sub: citiesWithZero.length > 0 ? citiesWithZero.map(function(c) { return c.city; }).slice(0,3).join(', ') + (citiesWithZero.length > 3 ? '…' : '') : 'All cities covered', accent: citiesWithZero.length > 0 ? '#c0392b' : '#1D9E75' }),
        React.createElement(SoundsStatCard, { label: 'Featured', value: sounds.filter(function(s) { return s.is_featured; }).length, sub: 'of ' + totalCount + ' total', accent: '#e08c2e' })
      ),

      // Mood breakdown
      React.createElement('div', { style: CARD(t) },
        React.createElement('div', { style: { fontSize: '.8rem', fontWeight: 700, color: '#0f1e28', marginBottom: 14 } }, 'Sounds by Mood'),
        React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 10 } },
          ['calm','explore','nightlife','sleep'].map(function(m) {
            var count = moodCounts[m] || 0;
            var pct = totalCount > 0 ? Math.round((count / totalCount) * 100) : 0;
            var c = MOOD_COLORS[m];
            return React.createElement('div', { key: m, style: { display: 'flex', alignItems: 'center', gap: 10 } },
              React.createElement('div', { style: { width: 76, fontSize: '.74rem', fontWeight: 600, color: c, flexShrink: 0 } }, MOOD_LABELS[m]),
              React.createElement('div', { style: { flex: 1, height: 6, background: '#f0f4f6', borderRadius: 3, overflow: 'hidden' } },
                React.createElement('div', { style: { width: pct + '%', height: '100%', background: c, borderRadius: 3, transition: 'width .4s' } })
              ),
              React.createElement('div', { style: { width: 40, textAlign: 'right', fontSize: '.72rem', color: '#7a9aaa', flexShrink: 0 } }, count)
            );
          })
        )
      ),

      // Most played
      React.createElement('div', { style: CARD(t) },
        React.createElement('div', { style: { fontSize: '.8rem', fontWeight: 700, color: '#0f1e28', marginBottom: 14 } }, 'Most Played'),
        topPlayed.length === 0
          ? React.createElement('div', { style: { fontSize: '.78rem', color: '#9aabba' } }, 'No play data yet.')
          : React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 10 } },
              topPlayed.map(function(s, i) {
                return React.createElement('div', { key: s.id, style: { display: 'flex', alignItems: 'center', gap: 10 } },
                  React.createElement('div', { style: { width: 20, height: 20, borderRadius: 6, background: '#f0f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.66rem', fontWeight: 700, color: '#7a9aaa', flexShrink: 0 } }, i + 1),
                  React.createElement('div', { style: { flex: 1, minWidth: 0 } },
                    React.createElement('div', { style: { fontSize: '.78rem', fontWeight: 600, color: '#0f1e28', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }, s.title),
                    React.createElement('div', { style: { fontSize: '.68rem', color: '#9aabba' } }, s.city)
                  ),
                  React.createElement('div', { style: { fontSize: '.78rem', fontWeight: 600, color: '#314F5C' } }, (s.play_count || 0).toLocaleString())
                );
              })
            )
      ),

      // Cities with zero sounds
      citiesWithZero.length > 0 && React.createElement('div', { style: CARD(t) },
        React.createElement('div', { style: { fontSize: '.8rem', fontWeight: 700, color: '#0f1e28', marginBottom: 4 } }, 'Cities with no sounds'),
        React.createElement('div', { style: { fontSize: '.73rem', color: '#9aabba', marginBottom: 14 } }, 'These cities have 0 tracks — consider adding ambient sounds.'),
        React.createElement('div', { style: { display: 'flex', flexWrap: 'wrap', gap: 6 } },
          citiesWithZero.map(function(cc) {
            return React.createElement('span', {
              key: cc.city,
              style: { padding: '3px 10px', borderRadius: 99, fontSize: '.7rem', fontWeight: 600, background: '#fef2f2', color: '#c0392b', border: '1px solid #fca5a5' }
            }, cc.city);
          })
        )
      )
    ),

    // ── Bulk Import section ────────────────────────────────────────────────
    activeSection === 'bulk' && React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 16 } },
      React.createElement('div', { style: CARD(t) },
        React.createElement('div', { style: { fontSize: '.88rem', fontWeight: 700, color: '#0f1e28', marginBottom: 6 } }, 'Bulk Import from URLs'),
        React.createElement('div', { style: { fontSize: '.76rem', color: '#7a9aaa', marginBottom: 16, lineHeight: 1.5 } },
          'Paste one audio URL per line (Pixabay, Epidemic Sound, or direct MP3 links). Each will be added as a new sound with basic metadata — edit titles, cities, and moods in the table afterwards.'
        ),
        React.createElement(LabeledTextarea, {
          label: 'Audio URLs (one per line)',
          value: bulkText, onChange: setBulkText,
          placeholder: 'https://cdn.pixabay.com/audio/...\nhttps://...',
          rows: 8,
        }),
        React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 12 } },
          React.createElement(Btn, { onClick: runBulkImport, variant: 'primary', disabled: !bulkText.trim() },
            React.createElement('span', { style: { display: 'flex', alignItems: 'center', gap: 5 } },
              IC.upload, 'Import All'
            )
          ),
          bulkStatus && React.createElement('span', { style: { fontSize: '.75rem', color: bulkStatus.includes('failed') ? '#c0392b' : '#1D9E75' } }, bulkStatus)
        )
      ),
      React.createElement('div', { style: { ...CARD, background: '#fafcfd' } },
        React.createElement('div', { style: { fontSize: '.8rem', fontWeight: 700, color: '#314F5C', marginBottom: 10 } }, 'Epidemic Sound'),
        React.createElement('div', { style: { fontSize: '.75rem', color: '#7a9aaa', lineHeight: 1.5 } },
          'Paste an Epidemic Sound track URL above. The source field will be auto-set to "Epidemic Sound". Manually edit the title, city, and mood after import — Epidemic Sound does not provide a public API for metadata extraction.'
        ),
        React.createElement('div', { style: { height: 12 } }),
        React.createElement('div', { style: { fontSize: '.8rem', fontWeight: 700, color: '#314F5C', marginBottom: 10 } }, 'Pixabay'),
        React.createElement('div', { style: { fontSize: '.75rem', color: '#7a9aaa', lineHeight: 1.5 } },
          'Paste Pixabay audio track URLs. The free CDN URL format is: cdn.pixabay.com/audio/... — source will be auto-detected. Edit metadata after import.'
        )
      )
    ),

    // ── Table section ──────────────────────────────────────────────────────
    activeSection === 'table' && React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 14 } },

      // Filter bar
      React.createElement('div', { style: { ...CARD, padding: '14px 16px' } },
        React.createElement('div', { style: { display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' } },

          // Search
          React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 7, flex: '1 1 180px', border: '1.5px solid #dde4ea', borderRadius: 8, padding: '7px 10px', background: '#fafcfd' } },
            React.createElement('span', { style: { color: '#9aabba', display: 'flex' } }, IC.filter),
            React.createElement('input', {
              value: search, onChange: function(e) { setSearch(e.target.value); },
              placeholder: 'Search by title…',
              style: { border: 'none', outline: 'none', fontSize: '.8rem', fontFamily: F, color: '#0f1e28', background: 'transparent', flex: 1, minWidth: 0 }
            })
          ),

          // City filter
          React.createElement('select', {
            value: filterCity, onChange: function(e) { setFilterCity(e.target.value); },
            style: { padding: '7px 10px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', color: '#314F5C', background: '#fafcfd', outline: 'none', cursor: 'pointer' }
          },
            React.createElement('option', { value: '' }, 'All cities'),
            CITY_COUNTRY.map(function(cc) {
              return React.createElement('option', { key: cc.city, value: cc.city }, cc.city);
            })
          ),

          // Mood filter
          React.createElement('select', {
            value: filterMood, onChange: function(e) { setFilterMood(e.target.value); },
            style: { padding: '7px 10px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', color: '#314F5C', background: '#fafcfd', outline: 'none', cursor: 'pointer' }
          },
            React.createElement('option', { value: '' }, 'All moods'),
            ['calm','explore','nightlife','sleep'].map(function(m) {
              return React.createElement('option', { key: m, value: m }, MOOD_LABELS[m]);
            })
          ),

          // Source filter
          React.createElement('select', {
            value: filterSource, onChange: function(e) { setFilterSource(e.target.value); },
            style: { padding: '7px 10px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', color: '#314F5C', background: '#fafcfd', outline: 'none', cursor: 'pointer' }
          },
            React.createElement('option', { value: '' }, 'All sources'),
            ['pixabay','epidemic','custom'].map(function(s) {
              return React.createElement('option', { key: s, value: s }, SOURCE_LABELS[s]);
            })
          ),

          // Sort
          React.createElement('select', {
            value: sortBy, onChange: function(e) { setSortBy(e.target.value); },
            style: { padding: '7px 10px', borderRadius: 8, border: '1.5px solid #dde4ea', fontFamily: F, fontSize: '.78rem', color: '#314F5C', background: '#fafcfd', outline: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center' }
          },
            React.createElement('option', { value: 'created_at' }, 'Sort: Newest'),
            React.createElement('option', { value: 'play_count' }, 'Sort: Most played'),
            React.createElement('option', { value: 'city' },       'Sort: City A-Z'),
            React.createElement('option', { value: 'title' },      'Sort: Title A-Z')
          ),

          React.createElement('span', { style: { fontSize: '.72rem', color: '#9aabba', whiteSpace: 'nowrap' } },
            sorted.length + ' of ' + totalCount
          )
        )
      ),

      // Table
      React.createElement('div', { style: { ...CARD, padding: 0, overflow: 'hidden' } },
        loading
          ? React.createElement('div', { style: { padding: '48px 24px', textAlign: 'center', color: '#9aabba', fontSize: '.82rem' } }, 'Loading sounds…')
          : sorted.length === 0
            ? React.createElement(Empty, {
                icon: IC.music,
                title: 'No sounds found',
                sub: totalCount === 0 ? 'Add your first ambient track to get started.' : 'Try adjusting filters.',
              })
            : React.createElement('div', { style: { overflowX: 'auto' } },
                React.createElement('table', { style: { width: '100%', borderCollapse: 'collapse', fontFamily: F } },
                  React.createElement('thead', null,
                    React.createElement('tr', { style: { background: '#f7f9fb', borderBottom: `1px solid ${t.bd}` } },
                      ['', 'Title', 'City', 'Mood', 'Duration', 'Source', 'Featured', 'Plays', ''].map(function(h, i) {
                        return React.createElement('th', {
                          key: i,
                          style: { padding: '10px 14px', textAlign: 'left', fontSize: '.68rem', fontWeight: 700, color: '#7a9aaa', textTransform: 'uppercase', letterSpacing: '.04em', whiteSpace: 'nowrap' }
                        }, h);
                      })
                    )
                  ),
                  React.createElement('tbody', null,
                    sorted.map(function(sound, idx) {
                      var isPlaying = playingId === sound.id;
                      var rowBg = idx % 2 === 0 ? '#fff' : '#fafcfd';
                      return React.createElement('tr', {
                        key: sound.id,
                        style: { background: rowBg, borderBottom: `1px solid ${t.bd}`, transition: 'background .1s' },
                        onMouseEnter: function(e) { e.currentTarget.style.background = '#f0f7fb'; },
                        onMouseLeave: function(e) { e.currentTarget.style.background = rowBg; },
                      },
                        // Play button
                        React.createElement('td', { style: { padding: '10px 10px 10px 14px', width: 36 } },
                          React.createElement('button', {
                            onClick: function() { togglePlay(sound); },
                            title: isPlaying ? 'Stop' : 'Preview',
                            style: { width: 28, height: 28, borderRadius: 7, border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', background: isPlaying ? '#314F5C' : '#f0f4f6', color: isPlaying ? '#fff' : '#6F8FA7', transition: 'all .12s', flexShrink: 0 }
                          },
                            isPlaying ? IC.pause : IC.play
                          )
                        ),
                        // Title
                        React.createElement('td', { style: { padding: '10px 14px', maxWidth: 220 } },
                          React.createElement('div', { style: { fontSize: '.8rem', fontWeight: 600, color: '#0f1e28', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }, sound.title || '—'),
                          sound.audio_url && React.createElement('div', { style: { fontSize: '.66rem', color: '#9aabba', marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 200 } }, sound.audio_url)
                        ),
                        // City
                        React.createElement('td', { style: { padding: '10px 14px', whiteSpace: 'nowrap' } },
                          React.createElement('div', { style: { fontSize: '.78rem', fontWeight: 600, color: '#314F5C' } }, sound.city || '—'),
                          sound.country && React.createElement('div', { style: { fontSize: '.66rem', color: '#9aabba' } }, sound.country)
                        ),
                        // Mood
                        React.createElement('td', { style: { padding: '10px 14px' } },
                          sound.mood ? React.createElement(MoodBadge, { mood: sound.mood }) : React.createElement('span', { style: { color: '#9aabba', fontSize: '.74rem' } }, '—')
                        ),
                        // Duration
                        React.createElement('td', { style: { padding: '10px 14px', fontSize: '.78rem', color: '#7a9aaa', whiteSpace: 'nowrap' } },
                          fmtDuration(sound.duration_seconds)
                        ),
                        // Source
                        React.createElement('td', { style: { padding: '10px 14px', fontSize: '.74rem', color: '#9aabba', whiteSpace: 'nowrap' } },
                          SOURCE_LABELS[sound.source] || sound.source || '—'
                        ),
                        // Featured toggle
                        React.createElement('td', { style: { padding: '10px 14px' } },
                          React.createElement('button', {
                            onClick: function() { toggleFeatured(sound); },
                            title: sound.is_featured ? 'Remove featured' : 'Mark as featured',
                            style: { background: 'none', border: 'none', cursor: 'pointer', padding: 2, display: 'flex', alignItems: 'center' }
                          },
                            sound.is_featured ? IC.starFill : IC.star
                          )
                        ),
                        // Play count
                        React.createElement('td', { style: { padding: '10px 14px', fontSize: '.78rem', color: '#314F5C', fontWeight: 600, whiteSpace: 'nowrap' } },
                          (sound.play_count || 0).toLocaleString()
                        ),
                        // Actions
                        React.createElement('td', { style: { padding: '10px 14px' } },
                          React.createElement('div', { style: { display: 'flex', gap: 4 } },
                            React.createElement('button', {
                              onClick: function() { openEdit(sound); },
                              title: 'Edit',
                              style: { background: '#f0f4f6', border: 'none', borderRadius: 6, padding: '5px 7px', cursor: 'pointer', display: 'flex', alignItems: 'center', color: '#6F8FA7' }
                            }, IC.pencil),
                            React.createElement('button', {
                              onClick: function() { setDeleteId(sound.id); },
                              title: 'Delete',
                              style: { background: '#fef2f2', border: 'none', borderRadius: 6, padding: '5px 7px', cursor: 'pointer', display: 'flex', alignItems: 'center', color: '#c0392b' }
                            }, IC.trash)
                          )
                        )
                      );
                    })
                  )
                )
              )
      )
    ),

    // ── Add/Edit Modal ─────────────────────────────────────────────────────
    React.createElement(Modal, {
      open: showForm,
      onClose: function() { setShowForm(false); },
      title: editSound ? 'Edit Sound' : 'Add New Sound',
      wide: true,
    },
      React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 0 } },

        React.createElement('div', { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' } },
          React.createElement(LabeledInput, { label: 'Title', value: form.title, onChange: function(v) { setField('title', v); }, placeholder: 'e.g. Morning market ambience', required: true }),
          React.createElement(LabeledSelect, {
            label: 'City',
            value: form.city,
            onChange: function(v) { setField('city', v); },
            options: [{ value: '', label: '— Select city —' }].concat(CITY_COUNTRY.map(function(cc) { return { value: cc.city, label: cc.city + ', ' + cc.country }; })),
          }),
          React.createElement(LabeledInput, { label: 'Country', value: form.country, onChange: function(v) { setField('country', v); }, placeholder: 'Auto-filled from city' }),
          React.createElement(LabeledSelect, {
            label: 'Mood',
            value: form.mood,
            onChange: function(v) { setField('mood', v); },
            options: [
              { value: 'calm',      label: 'Calm'          },
              { value: 'explore',   label: 'Explore'       },
              { value: 'nightlife', label: 'Nightlife'     },
              { value: 'sleep',     label: 'Sleep'         },
            ],
          }),
          React.createElement(LabeledSelect, {
            label: 'Source',
            value: form.source,
            onChange: function(v) { setField('source', v); },
            options: [
              { value: 'pixabay',  label: 'Pixabay'        },
              { value: 'epidemic', label: 'Epidemic Sound' },
              { value: 'custom',   label: 'Custom'         },
            ],
          }),
          React.createElement(LabeledInput, { label: 'Duration (seconds)', value: form.duration_seconds, onChange: function(v) { setField('duration_seconds', v); }, placeholder: 'e.g. 180', type: 'number' })
        ),

        // Audio URL or file upload
        React.createElement('div', { style: { marginBottom: 14 } },
          React.createElement('label', { style: { display: 'block', fontSize: '.74rem', fontWeight: 600, color: '#314F5C', marginBottom: 5 } }, 'Audio File (upload MP3)'),
          React.createElement('input', {
            type: 'file', accept: 'audio/*',
            onChange: handleFileChange,
            style: { fontSize: '.78rem', fontFamily: F, color: '#0f1e28' }
          }),
          uploadFile && React.createElement('div', { style: { fontSize: '.7rem', color: '#1D9E75', marginTop: 4 } }, 'Selected: ' + uploadFile.name + (uploading ? ' — uploading…' : ''))
        ),
        React.createElement(LabeledInput, {
          label: 'Or Audio URL (external link)',
          value: form.audio_url,
          onChange: function(v) { setField('audio_url', v); },
          placeholder: 'https://cdn.pixabay.com/audio/...',
        }),

        // Featured toggle
        React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14, padding: '10px 12px', background: '#f7f9fb', borderRadius: 8, border: `1px solid ${t.bd}` } },
          React.createElement('button', {
            onClick: function() { setField('is_featured', !form.is_featured); },
            style: {
              width: 36, height: 20, borderRadius: 10, border: 'none', cursor: 'pointer', position: 'relative', transition: 'background .2s',
              background: form.is_featured ? '#314F5C' : '#d5e0e6',
              flexShrink: 0,
            }
          },
            React.createElement('span', {
              style: { position: 'absolute', top: 2, left: form.is_featured ? 18 : 2, width: 16, height: 16, borderRadius: '50%', background: t.panel, transition: 'left .2s', boxShadow: '0 1px 3px rgba(0,0,0,0.15)' }
            })
          ),
          React.createElement('span', { style: { fontSize: '.78rem', color: '#314F5C', fontWeight: 500 } }, 'Featured track')
        ),

        formError && React.createElement('div', { style: { background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '8px 12px', fontSize: '.76rem', color: '#c0392b', marginBottom: 12 } }, formError),

        React.createElement('div', { style: { display: 'flex', gap: 8, justifyContent: 'flex-end', paddingTop: 4 } },
          React.createElement(Btn, { onClick: function() { setShowForm(false); }, variant: 'secondary' }, 'Cancel'),
          React.createElement(Btn, { onClick: saveSound, variant: 'primary', disabled: saving || uploading }, saving ? 'Saving…' : editSound ? 'Save changes' : 'Add sound')
        )
      )
    ),

    // ── Delete confirm modal ───────────────────────────────────────────────
    React.createElement(Modal, {
      open: !!deleteId,
      onClose: function() { setDeleteId(null); },
      title: 'Delete sound?',
    },
      React.createElement('div', null,
        React.createElement('p', { style: { fontSize: '.84rem', color: '#4a6272', marginBottom: 20 } },
          'This will permanently remove the sound from the library and all city playlists. This cannot be undone.'
        ),
        React.createElement('div', { style: { display: 'flex', gap: 8, justifyContent: 'flex-end' } },
          React.createElement(Btn, { onClick: function() { setDeleteId(null); }, variant: 'secondary' }, 'Cancel'),
          React.createElement(Btn, { onClick: deleteSound, variant: 'danger', disabled: deleting }, deleting ? 'Deleting…' : 'Delete')
        )
      )
    )
  );
}

// ─────────────────────────────────────────────────────────────────────────────

function AppStudioBody() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const { session } = useAuth();
  const authorEmail = session?.user?.email || null;
  const authorName  = authorEmail ? authorEmail.split('@')[0].split(/[._-]/).map(function(s){ return s.charAt(0).toUpperCase()+s.slice(1); }).join(' ') : 'Admin';

  var [platform, setPlatform] = useState('android');
  var [showSettings, setShowSettings] = useState(false);
  var [showFileBug, setShowFileBug] = useState(false);
  var [fileBugPlatform, setFileBugPlatform] = useState('Android');

  function openFileBug(plat) {
    setFileBugPlatform(plat || 'Android');
    setShowFileBug(true);
  }

  var PLATFORMS = [
    { id: 'android', label: 'Android', icon: IC.android },
    { id: 'web',     label: 'Web',     icon: IC.web     },
    { id: 'ios',     label: 'iOS',     icon: IC.ios     },
    { id: 'code',    label: 'Code',    icon: React.createElement('svg', { width:14, height:14, viewBox:'0 0 24 24', fill:'none', stroke:'currentColor', strokeWidth:2, strokeLinecap:'round', strokeLinejoin:'round' }, React.createElement('polyline',{points:'16 18 22 12 16 6'}), React.createElement('polyline',{points:'8 6 2 12 8 18'})) },
    { id: 'sounds',  label: 'Sounds',  icon: IC.music   },
  ];

  return React.createElement('div', { style: { fontFamily: F, minHeight: '100%' } },

    // Header row
    React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 } },
      // Platform tabs
      React.createElement('div', { style: { display: 'flex', gap: 2, background: '#f0f4f6', borderRadius: 10, padding: 3 } },
        PLATFORMS.map(function(p) {
          var active = platform === p.id;
          return React.createElement('button', {
            key: p.id, onClick: function() { setPlatform(p.id); },
            style: { display: 'flex', alignItems: 'center', gap: 6, padding: '7px 16px', borderRadius: 8, border: 'none', fontFamily: F, fontSize: '.82rem', cursor: 'pointer', background: active ? '#fff' : 'transparent', color: active ? '#0f1e28' : '#7a9aaa', fontWeight: active ? 600 : 400, boxShadow: active ? '0 1px 4px rgba(0,0,0,0.1)' : 'none', transition: 'all .12s' }
          },
            React.createElement('span', { style: { display: 'flex', opacity: active ? 1 : 0.6 } }, p.icon),
            p.label
          );
        })
      ),
      // Actions
      React.createElement('div', { style: { display: 'flex', gap: 8, alignItems: 'center' } },
        React.createElement(Btn, { onClick: function() { openFileBug(platform === 'web' ? 'Web' : platform === 'ios' ? 'iOS' : 'Android'); }, variant: 'secondary', small: true }, '+ File bug'),
        React.createElement('button', {
          onClick: function() { setShowSettings(true); },
          title: 'Settings',
          style: { background: '#f0f4f6', border: 'none', borderRadius: 8, padding: '7px 10px', cursor: 'pointer', display: 'flex', alignItems: 'center', color: '#6F8FA7' }
        },
          React.createElement('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round' },
            React.createElement('circle', { cx: 12, cy: 12, r: 3 }),
            React.createElement('path', { d: 'M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z' })
          )
        )
      )
    ),

    // Platform content
    platform === 'sounds'
      ? React.createElement(SoundsManager)
      : platform === 'code'
        ? React.createElement(CodeEditorTab, { authorEmail: authorEmail })
        : React.createElement(PlatformPage, { platform: platform, authorEmail: authorEmail, authorName: authorName, onFileBug: function() { openFileBug(platform === 'web' ? 'Web' : platform === 'ios' ? 'iOS' : 'Android'); } }),

    // Modals
    React.createElement(FileBugModal, { open: showFileBug, onClose: function(filed) { setShowFileBug(false); }, defaultPlatform: fileBugPlatform, authorEmail: authorEmail, authorName: authorName }),
    React.createElement(SettingsModal, { open: showSettings, onClose: function() { setShowSettings(false); } })
  );
}

export default function AppStudio(props) {
  if (props && props.embed) return <AppStudioBody />;
  return <ConsoleShell title="The App"><AppStudioBody /></ConsoleShell>;
}
